import _process from "process";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
var process = _process;
!function (e, t) {
  exports = t();
}(exports, function () {
  "use strict";

  /*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
  
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
  
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */
  var e = function (t, n) {
    return e = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }, e(t, n);
  };
  function t(t, n) {
    if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      (this || _global).constructor = t;
    }
    e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
  }
  var n = function () {
    return n = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, n.apply(this || _global, arguments);
  };
  function r(e, t) {
    var n = {};
    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;
      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
    }
    return n;
  }
  function o(e, t, n, r) {
    return new (n || (n = Promise))(function (o, i) {
      function a(e) {
        try {
          u(r.next(e));
        } catch (e) {
          i(e);
        }
      }
      function s(e) {
        try {
          u(r.throw(e));
        } catch (e) {
          i(e);
        }
      }
      function u(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(a, s);
      }
      u((r = r.apply(e, t || [])).next());
    });
  }
  function i(e, t) {
    var n,
      r,
      o,
      i,
      a = {
        label: 0,
        sent: function () {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
    return i = {
      next: s(0),
      throw: s(1),
      return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this || _global;
    }), i;
    function s(i) {
      return function (s) {
        return function (i) {
          if (n) throw new TypeError("Generator is already executing.");
          for (; a;) try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;
              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };
              case 5:
                a.label++, r = i[1], i = [0];
                continue;
              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;
              default:
                if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                  a = 0;
                  continue;
                }
                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }
                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }
                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }
                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
          if (5 & i[0]) throw i[1];
          return {
            value: i[0] ? i[1] : void 0,
            done: !0
          };
        }([i, s]);
      };
    }
  }
  function a(e) {
    var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
      next: function () {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }
  function s(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r,
      o,
      i = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (n = i.return) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }
    return a;
  }
  function u(e, t, n) {
    if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
    return e.concat(r || Array.prototype.slice.call(t));
  }
  var c = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof _global ? _global : "undefined" != typeof self ? self : {};
  function l(e) {
    if (e.__esModule) return e;
    var t = Object.defineProperty({}, "__esModule", {
      value: !0
    });
    return Object.keys(e).forEach(function (n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function () {
          return e[n];
        }
      });
    }), t;
  }
  var p = {
    exports: {}
  };
  !function (e) {
    !function (t, n) {
      var r = Math.pow(2, -24),
        o = Math.pow(2, 32),
        i = Math.pow(2, 53);
      var a = {
        encode: function (e) {
          var t,
            r = new ArrayBuffer(256),
            a = new DataView(r),
            s = 0;
          function u(e) {
            for (var n = r.byteLength, o = s + e; n < o;) n *= 2;
            if (n !== r.byteLength) {
              var i = a;
              r = new ArrayBuffer(n), a = new DataView(r);
              for (var u = s + 3 >> 2, c = 0; c < u; ++c) a.setUint32(4 * c, i.getUint32(4 * c));
            }
            return t = e, a;
          }
          function c() {
            s += t;
          }
          function l(e) {
            c(u(1).setUint8(s, e));
          }
          function p(e) {
            for (var t = u(e.length), n = 0; n < e.length; ++n) t.setUint8(s + n, e[n]);
            c();
          }
          function f(e, t) {
            t < 24 ? l(e << 5 | t) : t < 256 ? (l(e << 5 | 24), l(t)) : t < 65536 ? (l(e << 5 | 25), function (e) {
              c(u(2).setUint16(s, e));
            }(t)) : t < 4294967296 ? (l(e << 5 | 26), function (e) {
              c(u(4).setUint32(s, e));
            }(t)) : (l(e << 5 | 27), function (e) {
              var t = e % o,
                n = (e - t) / o,
                r = u(8);
              r.setUint32(s, n), r.setUint32(s + 4, t), c();
            }(t));
          }
          if (function e(t) {
            var r;
            if (!1 === t) return l(244);
            if (!0 === t) return l(245);
            if (null === t) return l(246);
            if (t === n) return l(247);
            switch (typeof t) {
              case "number":
                if (Math.floor(t) === t) {
                  if (0 <= t && t <= i) return f(0, t);
                  if (-i <= t && t < 0) return f(1, -(t + 1));
                }
                return l(251), function (e) {
                  c(u(8).setFloat64(s, e));
                }(t);
              case "string":
                var o = [];
                for (r = 0; r < t.length; ++r) {
                  var a = t.charCodeAt(r);
                  a < 128 ? o.push(a) : a < 2048 ? (o.push(192 | a >> 6), o.push(128 | 63 & a)) : a < 55296 ? (o.push(224 | a >> 12), o.push(128 | a >> 6 & 63), o.push(128 | 63 & a)) : (a = (1023 & a) << 10, a |= 1023 & t.charCodeAt(++r), a += 65536, o.push(240 | a >> 18), o.push(128 | a >> 12 & 63), o.push(128 | a >> 6 & 63), o.push(128 | 63 & a));
                }
                return f(3, o.length), p(o);
              default:
                var h;
                if (Array.isArray(t)) for (f(4, h = t.length), r = 0; r < h; ++r) e(t[r]);else if (t instanceof Uint8Array) f(2, t.length), p(t);else {
                  var d = Object.keys(t);
                  for (f(5, h = d.length), r = 0; r < h; ++r) {
                    var y = d[r];
                    e(y), e(t[y]);
                  }
                }
            }
          }(e), "slice" in r) return r.slice(0, s);
          for (var h = new ArrayBuffer(s), d = new DataView(h), y = 0; y < s; ++y) d.setUint8(y, a.getUint8(y));
          return h;
        },
        decode: function (e, t, i) {
          var a = new DataView(e),
            s = 0;
          function u(e, t) {
            return s += t, e;
          }
          function c(t) {
            return u(new Uint8Array(e, s, t), t);
          }
          function l() {
            return u(a.getUint8(s), 1);
          }
          function p() {
            return u(a.getUint16(s), 2);
          }
          function f() {
            return u(a.getUint32(s), 4);
          }
          function h() {
            return 255 === a.getUint8(s) && (s += 1, !0);
          }
          function d(e) {
            if (e < 24) return e;
            if (24 === e) return l();
            if (25 === e) return p();
            if (26 === e) return f();
            if (27 === e) return f() * o + f();
            if (31 === e) return -1;
            throw "Invalid length encoding";
          }
          function y(e) {
            var t = l();
            if (255 === t) return -1;
            var n = d(31 & t);
            if (n < 0 || t >> 5 !== e) throw "Invalid indefinite length element";
            return n;
          }
          function g(e, t) {
            for (var n = 0; n < t; ++n) {
              var r = l();
              128 & r && (r < 224 ? (r = (31 & r) << 6 | 63 & l(), t -= 1) : r < 240 ? (r = (15 & r) << 12 | (63 & l()) << 6 | 63 & l(), t -= 2) : (r = (15 & r) << 18 | (63 & l()) << 12 | (63 & l()) << 6 | 63 & l(), t -= 3)), r < 65536 ? e.push(r) : (r -= 65536, e.push(55296 | r >> 10), e.push(56320 | 1023 & r));
            }
          }
          "function" != typeof t && (t = function (e) {
            return e;
          }), "function" != typeof i && (i = function () {
            return n;
          });
          var b = function e() {
            var o,
              f,
              b = l(),
              v = b >> 5,
              m = 31 & b;
            if (7 === v) switch (m) {
              case 25:
                return function () {
                  var e = new ArrayBuffer(4),
                    t = new DataView(e),
                    n = p(),
                    o = 32768 & n,
                    i = 31744 & n,
                    a = 1023 & n;
                  if (31744 === i) i = 261120;else if (0 !== i) i += 114688;else if (0 !== a) return a * r;
                  return t.setUint32(0, o << 16 | i << 13 | a << 13), t.getFloat32(0);
                }();
              case 26:
                return u(a.getFloat32(s), 4);
              case 27:
                return u(a.getFloat64(s), 8);
            }
            if ((f = d(m)) < 0 && (v < 2 || 6 < v)) throw "Invalid length";
            switch (v) {
              case 0:
                return f;
              case 1:
                return -1 - f;
              case 2:
                if (f < 0) {
                  for (var _ = [], O = 0; (f = y(v)) >= 0;) O += f, _.push(c(f));
                  var S = new Uint8Array(O),
                    P = 0;
                  for (o = 0; o < _.length; ++o) S.set(_[o], P), P += _[o].length;
                  return S;
                }
                return c(f);
              case 3:
                var w = [];
                if (f < 0) for (; (f = y(v)) >= 0;) g(w, f);else g(w, f);
                return String.fromCharCode.apply(null, w);
              case 4:
                var E;
                if (f < 0) for (E = []; !h();) E.push(e());else for (E = new Array(f), o = 0; o < f; ++o) E[o] = e();
                return E;
              case 5:
                var T = {};
                for (o = 0; o < f || f < 0 && !h(); ++o) {
                  T[e()] = e();
                }
                return T;
              case 6:
                return t(e(), f);
              case 7:
                switch (f) {
                  case 20:
                    return !1;
                  case 21:
                    return !0;
                  case 22:
                    return null;
                  case 23:
                    return n;
                  default:
                    return i(f);
                }
            }
          }();
          if (s !== e.byteLength) throw "Remaining bytes";
          return b;
        }
      };
      e.exports ? e.exports = a : t.CBOR || (t.CBOR = a);
    }(c);
  }(p);
  var f = p.exports,
    h = {
      exports: {}
    };
  /*! lil-uuid - v0.1 - MIT License - https://github.com/lil-js/uuid */
  !function (e, t) {
    !function (e) {
      var t = "0.1.0",
        n = {
          3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
          4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
          5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
          all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
        };
      function r() {
        var e,
          t,
          n = "";
        for (e = 0; e < 32; e++) t = 16 * Math.random() | 0, 8 !== e && 12 !== e && 16 !== e && 20 !== e || (n += "-"), n += (12 === e ? 4 : 16 === e ? 3 & t | 8 : t).toString(16);
        return n;
      }
      function o(e, t) {
        var r = n[t || "all"];
        return r && r.test(e) || !1;
      }
      r.isUUID = o, r.VERSION = t, e.uuid = r, e.isUUID = o;
    }(t), null !== e && (e.exports = t.uuid);
  }(h, h.exports);
  var d = h.exports,
    y = function () {
      return d.uuid ? d.uuid() : d();
    },
    g = function () {
      function e(e) {
        var t,
          n,
          r,
          o = e.setup;
        if ((this || _global)._PNSDKSuffix = {}, (this || _global).instanceId = "pn-".concat(y()), (this || _global).secretKey = o.secretKey || o.secret_key, (this || _global).subscribeKey = o.subscribeKey || o.subscribe_key, (this || _global).publishKey = o.publishKey || o.publish_key, (this || _global).sdkName = o.sdkName, (this || _global).sdkFamily = o.sdkFamily, (this || _global).partnerId = o.partnerId, this.setAuthKey(o.authKey), (this || _global).cryptoModule = o.cryptoModule, this.setFilterExpression(o.filterExpression), "string" != typeof o.origin && !Array.isArray(o.origin) && void 0 !== o.origin) throw new Error("Origin must be either undefined, a string or a list of strings.");
        if ((this || _global).origin = o.origin || Array.from({
          length: 20
        }, function (e, t) {
          return "ps".concat(t + 1, ".pndsn.com");
        }), (this || _global).secure = o.ssl || !1, (this || _global).restore = o.restore || !1, (this || _global).proxy = o.proxy, (this || _global).keepAlive = o.keepAlive, (this || _global).keepAliveSettings = o.keepAliveSettings, (this || _global).autoNetworkDetection = o.autoNetworkDetection || !1, (this || _global).dedupeOnSubscribe = o.dedupeOnSubscribe || !1, (this || _global).maximumCacheSize = o.maximumCacheSize || 100, (this || _global).customEncrypt = o.customEncrypt, (this || _global).customDecrypt = o.customDecrypt, (this || _global).fileUploadPublishRetryLimit = null !== (t = o.fileUploadPublishRetryLimit) && void 0 !== t ? t : 5, (this || _global).useRandomIVs = null === (n = o.useRandomIVs) || void 0 === n || n, (this || _global).enableSubscribeBeta = null !== (r = o.enableSubscribeBeta) && void 0 !== r && r, "undefined" != typeof location && "https:" === location.protocol && ((this || _global).secure = !0), (this || _global).logVerbosity = o.logVerbosity || !1, (this || _global).suppressLeaveEvents = o.suppressLeaveEvents || !1, (this || _global).announceFailedHeartbeats = o.announceFailedHeartbeats || !0, (this || _global).announceSuccessfulHeartbeats = o.announceSuccessfulHeartbeats || !1, (this || _global).useInstanceId = o.useInstanceId || !1, (this || _global).useRequestId = o.useRequestId || !1, (this || _global).requestMessageCountThreshold = o.requestMessageCountThreshold, this.setTransactionTimeout(o.transactionalRequestTimeout || 15000), this.setSubscribeTimeout(o.subscribeRequestTimeout || 310000), this.setSendBeaconConfig(o.useSendBeacon || !0), o.presenceTimeout ? this.setPresenceTimeout(o.presenceTimeout) : (this || _global)._presenceTimeout = 300, null != o.heartbeatInterval && this.setHeartbeatInterval(o.heartbeatInterval), "string" == typeof o.userId) {
          if ("string" == typeof o.uuid) throw new Error("Only one of the following configuration options has to be provided: `uuid` or `userId`");
          this.setUserId(o.userId);
        } else {
          if ("string" != typeof o.uuid) throw new Error("One of the following configuration options has to be provided: `uuid` or `userId`");
          this.setUUID(o.uuid);
        }
        this.setCipherKey(o.cipherKey, o);
      }
      return e.prototype.getAuthKey = function () {
        return (this || _global).authKey;
      }, e.prototype.setAuthKey = function (e) {
        return (this || _global).authKey = e, this || _global;
      }, e.prototype.setCipherKey = function (e, t, n) {
        var r;
        return (this || _global).cipherKey = e, (this || _global).cipherKey && ((this || _global).cryptoModule = null !== (r = t.cryptoModule) && void 0 !== r ? r : t.initCryptoModule({
          cipherKey: (this || _global).cipherKey,
          useRandomIVs: (this || _global).useRandomIVs
        }), n && (n.cryptoModule = (this || _global).cryptoModule)), this || _global;
      }, e.prototype.getUUID = function () {
        return (this || _global).UUID;
      }, e.prototype.setUUID = function (e) {
        if (!e || "string" != typeof e || 0 === e.trim().length) throw new Error("Missing uuid parameter. Provide a valid string uuid");
        return (this || _global).UUID = e, this || _global;
      }, e.prototype.getUserId = function () {
        return (this || _global).UUID;
      }, e.prototype.setUserId = function (e) {
        if (!e || "string" != typeof e || 0 === e.trim().length) throw new Error("Missing or invalid userId parameter. Provide a valid string userId");
        return (this || _global).UUID = e, this || _global;
      }, e.prototype.getFilterExpression = function () {
        return (this || _global).filterExpression;
      }, e.prototype.setFilterExpression = function (e) {
        return (this || _global).filterExpression = e, this || _global;
      }, e.prototype.getPresenceTimeout = function () {
        return (this || _global)._presenceTimeout;
      }, e.prototype.setPresenceTimeout = function (e) {
        return e >= 20 ? (this || _global)._presenceTimeout = e : ((this || _global)._presenceTimeout = 20, console.log("WARNING: Presence timeout is less than the minimum. Using minimum value: ", (this || _global)._presenceTimeout)), this.setHeartbeatInterval((this || _global)._presenceTimeout / 2 - 1), this || _global;
      }, e.prototype.setProxy = function (e) {
        (this || _global).proxy = e;
      }, e.prototype.getHeartbeatInterval = function () {
        return (this || _global)._heartbeatInterval;
      }, e.prototype.setHeartbeatInterval = function (e) {
        return (this || _global)._heartbeatInterval = e, this || _global;
      }, e.prototype.getSubscribeTimeout = function () {
        return (this || _global)._subscribeRequestTimeout;
      }, e.prototype.setSubscribeTimeout = function (e) {
        return (this || _global)._subscribeRequestTimeout = e, this || _global;
      }, e.prototype.getTransactionTimeout = function () {
        return (this || _global)._transactionalRequestTimeout;
      }, e.prototype.setTransactionTimeout = function (e) {
        return (this || _global)._transactionalRequestTimeout = e, this || _global;
      }, e.prototype.isSendBeaconEnabled = function () {
        return (this || _global)._useSendBeacon;
      }, e.prototype.setSendBeaconConfig = function (e) {
        return (this || _global)._useSendBeacon = e, this || _global;
      }, e.prototype.getVersion = function () {
        return "7.4.0";
      }, e.prototype._addPnsdkSuffix = function (e, t) {
        (this || _global)._PNSDKSuffix[e] = t;
      }, e.prototype._getPnsdkSuffix = function (e) {
        var t = this || _global;
        return Object.keys((this || _global)._PNSDKSuffix).reduce(function (n, r) {
          return n + e + t._PNSDKSuffix[r];
        }, "");
      }, e;
    }();
  function b(e) {
    var t = e.replace(/==?$/, ""),
      n = Math.floor(t.length / 4 * 3),
      r = new ArrayBuffer(n),
      o = new Uint8Array(r),
      i = 0;
    function a() {
      var e = t.charAt(i++),
        n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(e);
      if (-1 === n) throw new Error("Illegal character at ".concat(i, ": ").concat(t.charAt(i - 1)));
      return n;
    }
    for (var s = 0; s < n; s += 3) {
      var u = a(),
        c = a(),
        l = a(),
        p = a(),
        f = (63 & u) << 2 | c >> 4,
        h = (15 & c) << 4 | l >> 2,
        d = (3 & l) << 6 | p >> 0;
      o[s] = f, 64 != l && (o[s + 1] = h), 64 != p && (o[s + 2] = d);
    }
    return r;
  }
  function v(e) {
    for (var t, n = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = new Uint8Array(e), i = o.byteLength, a = i % 3, s = i - a, u = 0; u < s; u += 3) n += r[(16515072 & (t = o[u] << 16 | o[u + 1] << 8 | o[u + 2])) >> 18] + r[(258048 & t) >> 12] + r[(4032 & t) >> 6] + r[63 & t];
    return 1 == a ? n += r[(252 & (t = o[s])) >> 2] + r[(3 & t) << 4] + "==" : 2 == a && (n += r[(64512 & (t = o[s] << 8 | o[s + 1])) >> 10] + r[(1008 & t) >> 4] + r[(15 & t) << 2] + "="), n;
  }
  var m,
    _,
    O,
    S,
    P,
    w = w || function (e, t) {
      var n = {},
        r = n.lib = {},
        o = function () {},
        i = r.Base = {
          extend: function (e) {
            o.prototype = this || _global;
            var t = new o();
            return e && t.mixIn(e), t.hasOwnProperty("init") || (t.init = function () {
              t.$super.init.apply(this || _global, arguments);
            }), t.init.prototype = t, t.$super = this || _global, t;
          },
          create: function () {
            var e = this.extend();
            return e.init.apply(e, arguments), e;
          },
          init: function () {},
          mixIn: function (e) {
            for (var t in e) e.hasOwnProperty(t) && ((this || _global)[t] = e[t]);
            e.hasOwnProperty("toString") && ((this || _global).toString = e.toString);
          },
          clone: function () {
            return (this || _global).init.prototype.extend(this || _global);
          }
        },
        a = r.WordArray = i.extend({
          init: function (e, t) {
            e = (this || _global).words = e || [], (this || _global).sigBytes = null != t ? t : 4 * e.length;
          },
          toString: function (e) {
            return (e || u).stringify(this || _global);
          },
          concat: function (e) {
            var t = (this || _global).words,
              n = e.words,
              r = (this || _global).sigBytes;
            if (e = e.sigBytes, this.clamp(), r % 4) for (var o = 0; o < e; o++) t[r + o >>> 2] |= (n[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 24 - (r + o) % 4 * 8;else if (65535 < n.length) for (o = 0; o < e; o += 4) t[r + o >>> 2] = n[o >>> 2];else t.push.apply(t, n);
            return (this || _global).sigBytes += e, this || _global;
          },
          clamp: function () {
            var t = (this || _global).words,
              n = (this || _global).sigBytes;
            t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = e.ceil(n / 4);
          },
          clone: function () {
            var e = i.clone.call(this || _global);
            return e.words = (this || _global).words.slice(0), e;
          },
          random: function (t) {
            for (var n = [], r = 0; r < t; r += 4) n.push(4294967296 * e.random() | 0);
            return new a.init(n, t);
          }
        }),
        s = n.enc = {},
        u = s.Hex = {
          stringify: function (e) {
            var t = e.words;
            e = e.sigBytes;
            for (var n = [], r = 0; r < e; r++) {
              var o = t[r >>> 2] >>> 24 - r % 4 * 8 & 255;
              n.push((o >>> 4).toString(16)), n.push((15 & o).toString(16));
            }
            return n.join("");
          },
          parse: function (e) {
            for (var t = e.length, n = [], r = 0; r < t; r += 2) n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
            return new a.init(n, t / 2);
          }
        },
        c = s.Latin1 = {
          stringify: function (e) {
            var t = e.words;
            e = e.sigBytes;
            for (var n = [], r = 0; r < e; r++) n.push(String.fromCharCode(t[r >>> 2] >>> 24 - r % 4 * 8 & 255));
            return n.join("");
          },
          parse: function (e) {
            for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
            return new a.init(n, t);
          }
        },
        l = s.Utf8 = {
          stringify: function (e) {
            try {
              return decodeURIComponent(escape(c.stringify(e)));
            } catch (e) {
              throw Error("Malformed UTF-8 data");
            }
          },
          parse: function (e) {
            return c.parse(unescape(encodeURIComponent(e)));
          }
        },
        p = r.BufferedBlockAlgorithm = i.extend({
          reset: function () {
            (this || _global)._data = new a.init(), (this || _global)._nDataBytes = 0;
          },
          _append: function (e) {
            "string" == typeof e && (e = l.parse(e)), (this || _global)._data.concat(e), (this || _global)._nDataBytes += e.sigBytes;
          },
          _process: function (t) {
            var n = (this || _global)._data,
              r = n.words,
              o = n.sigBytes,
              i = (this || _global).blockSize,
              s = o / (4 * i);
            if (t = (s = t ? e.ceil(s) : e.max((0 | s) - (this || _global)._minBufferSize, 0)) * i, o = e.min(4 * t, o), t) {
              for (var u = 0; u < t; u += i) this._doProcessBlock(r, u);
              u = r.splice(0, t), n.sigBytes -= o;
            }
            return new a.init(u, o);
          },
          clone: function () {
            var e = i.clone.call(this || _global);
            return e._data = (this || _global)._data.clone(), e;
          },
          _minBufferSize: 0
        });
      r.Hasher = p.extend({
        cfg: i.extend(),
        init: function (e) {
          (this || _global).cfg = (this || _global).cfg.extend(e), this.reset();
        },
        reset: function () {
          p.reset.call(this || _global), this._doReset();
        },
        update: function (e) {
          return this._append(e), this._process(), this || _global;
        },
        finalize: function (e) {
          return e && this._append(e), this._doFinalize();
        },
        blockSize: 16,
        _createHelper: function (e) {
          return function (t, n) {
            return new e.init(n).finalize(t);
          };
        },
        _createHmacHelper: function (e) {
          return function (t, n) {
            return new f.HMAC.init(e, n).finalize(t);
          };
        }
      });
      var f = n.algo = {};
      return n;
    }(Math);
  !function (e) {
    for (var t = w, n = (o = t.lib).WordArray, r = o.Hasher, o = t.algo, i = [], a = [], s = function (e) {
        return 4294967296 * (e - (0 | e)) | 0;
      }, u = 2, c = 0; 64 > c;) {
      var l;
      e: {
        l = u;
        for (var p = e.sqrt(l), f = 2; f <= p; f++) if (!(l % f)) {
          l = !1;
          break e;
        }
        l = !0;
      }
      l && (8 > c && (i[c] = s(e.pow(u, 0.5))), a[c] = s(e.pow(u, 1 / 3)), c++), u++;
    }
    var h = [];
    o = o.SHA256 = r.extend({
      _doReset: function () {
        (this || _global)._hash = new n.init(i.slice(0));
      },
      _doProcessBlock: function (e, t) {
        for (var n = (this || _global)._hash.words, r = n[0], o = n[1], i = n[2], s = n[3], u = n[4], c = n[5], l = n[6], p = n[7], f = 0; 64 > f; f++) {
          if (16 > f) h[f] = 0 | e[t + f];else {
            var d = h[f - 15],
              y = h[f - 2];
            h[f] = ((d << 25 | d >>> 7) ^ (d << 14 | d >>> 18) ^ d >>> 3) + h[f - 7] + ((y << 15 | y >>> 17) ^ (y << 13 | y >>> 19) ^ y >>> 10) + h[f - 16];
          }
          d = p + ((u << 26 | u >>> 6) ^ (u << 21 | u >>> 11) ^ (u << 7 | u >>> 25)) + (u & c ^ ~u & l) + a[f] + h[f], y = ((r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22)) + (r & o ^ r & i ^ o & i), p = l, l = c, c = u, u = s + d | 0, s = i, i = o, o = r, r = d + y | 0;
        }
        n[0] = n[0] + r | 0, n[1] = n[1] + o | 0, n[2] = n[2] + i | 0, n[3] = n[3] + s | 0, n[4] = n[4] + u | 0, n[5] = n[5] + c | 0, n[6] = n[6] + l | 0, n[7] = n[7] + p | 0;
      },
      _doFinalize: function () {
        var t = (this || _global)._data,
          n = t.words,
          r = 8 * (this || _global)._nDataBytes,
          o = 8 * t.sigBytes;
        return n[o >>> 5] |= 128 << 24 - o % 32, n[14 + (o + 64 >>> 9 << 4)] = e.floor(r / 4294967296), n[15 + (o + 64 >>> 9 << 4)] = r, t.sigBytes = 4 * n.length, this._process(), (this || _global)._hash;
      },
      clone: function () {
        var e = r.clone.call(this || _global);
        return e._hash = (this || _global)._hash.clone(), e;
      }
    });
    t.SHA256 = r._createHelper(o), t.HmacSHA256 = r._createHmacHelper(o);
  }(Math), _ = (m = w).enc.Utf8, m.algo.HMAC = m.lib.Base.extend({
    init: function (e, t) {
      e = (this || _global)._hasher = new e.init(), "string" == typeof t && (t = _.parse(t));
      var n = e.blockSize,
        r = 4 * n;
      t.sigBytes > r && (t = e.finalize(t)), t.clamp();
      for (var o = (this || _global)._oKey = t.clone(), i = (this || _global)._iKey = t.clone(), a = o.words, s = i.words, u = 0; u < n; u++) a[u] ^= 1549556828, s[u] ^= 909522486;
      o.sigBytes = i.sigBytes = r, this.reset();
    },
    reset: function () {
      var e = (this || _global)._hasher;
      e.reset(), e.update((this || _global)._iKey);
    },
    update: function (e) {
      return (this || _global)._hasher.update(e), this || _global;
    },
    finalize: function (e) {
      var t = (this || _global)._hasher;
      return e = t.finalize(e), t.reset(), t.finalize((this || _global)._oKey.clone().concat(e));
    }
  }), S = (O = w).lib.WordArray, O.enc.Base64 = {
    stringify: function (e) {
      var t = e.words,
        n = e.sigBytes,
        r = (this || _global)._map;
      e.clamp(), e = [];
      for (var o = 0; o < n; o += 3) for (var i = (t[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (t[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | t[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, a = 0; 4 > a && o + 0.75 * a < n; a++) e.push(r.charAt(i >>> 6 * (3 - a) & 63));
      if (t = r.charAt(64)) for (; e.length % 4;) e.push(t);
      return e.join("");
    },
    parse: function (e) {
      var t = e.length,
        n = (this || _global)._map;
      (r = n.charAt(64)) && -1 != (r = e.indexOf(r)) && (t = r);
      for (var r = [], o = 0, i = 0; i < t; i++) if (i % 4) {
        var a = n.indexOf(e.charAt(i - 1)) << i % 4 * 2,
          s = n.indexOf(e.charAt(i)) >>> 6 - i % 4 * 2;
        r[o >>> 2] |= (a | s) << 24 - o % 4 * 8, o++;
      }
      return S.create(r, o);
    },
    _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
  }, function (e) {
    function t(e, t, n, r, o, i, a) {
      return ((e = e + (t & n | ~t & r) + o + a) << i | e >>> 32 - i) + t;
    }
    function n(e, t, n, r, o, i, a) {
      return ((e = e + (t & r | n & ~r) + o + a) << i | e >>> 32 - i) + t;
    }
    function r(e, t, n, r, o, i, a) {
      return ((e = e + (t ^ n ^ r) + o + a) << i | e >>> 32 - i) + t;
    }
    function o(e, t, n, r, o, i, a) {
      return ((e = e + (n ^ (t | ~r)) + o + a) << i | e >>> 32 - i) + t;
    }
    for (var i = w, a = (u = i.lib).WordArray, s = u.Hasher, u = i.algo, c = [], l = 0; 64 > l; l++) c[l] = 4294967296 * e.abs(e.sin(l + 1)) | 0;
    u = u.MD5 = s.extend({
      _doReset: function () {
        (this || _global)._hash = new a.init([1732584193, 4023233417, 2562383102, 271733878]);
      },
      _doProcessBlock: function (e, i) {
        for (var a = 0; 16 > a; a++) {
          var s = e[u = i + a];
          e[u] = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8);
        }
        a = (this || _global)._hash.words;
        var u = e[i + 0],
          l = (s = e[i + 1], e[i + 2]),
          p = e[i + 3],
          f = e[i + 4],
          h = e[i + 5],
          d = e[i + 6],
          y = e[i + 7],
          g = e[i + 8],
          b = e[i + 9],
          v = e[i + 10],
          m = e[i + 11],
          _ = e[i + 12],
          O = e[i + 13],
          S = e[i + 14],
          P = e[i + 15],
          w = t(w = a[0], A = a[1], T = a[2], E = a[3], u, 7, c[0]),
          E = t(E, w, A, T, s, 12, c[1]),
          T = t(T, E, w, A, l, 17, c[2]),
          A = t(A, T, E, w, p, 22, c[3]);
        w = t(w, A, T, E, f, 7, c[4]), E = t(E, w, A, T, h, 12, c[5]), T = t(T, E, w, A, d, 17, c[6]), A = t(A, T, E, w, y, 22, c[7]), w = t(w, A, T, E, g, 7, c[8]), E = t(E, w, A, T, b, 12, c[9]), T = t(T, E, w, A, v, 17, c[10]), A = t(A, T, E, w, m, 22, c[11]), w = t(w, A, T, E, _, 7, c[12]), E = t(E, w, A, T, O, 12, c[13]), T = t(T, E, w, A, S, 17, c[14]), w = n(w, A = t(A, T, E, w, P, 22, c[15]), T, E, s, 5, c[16]), E = n(E, w, A, T, d, 9, c[17]), T = n(T, E, w, A, m, 14, c[18]), A = n(A, T, E, w, u, 20, c[19]), w = n(w, A, T, E, h, 5, c[20]), E = n(E, w, A, T, v, 9, c[21]), T = n(T, E, w, A, P, 14, c[22]), A = n(A, T, E, w, f, 20, c[23]), w = n(w, A, T, E, b, 5, c[24]), E = n(E, w, A, T, S, 9, c[25]), T = n(T, E, w, A, p, 14, c[26]), A = n(A, T, E, w, g, 20, c[27]), w = n(w, A, T, E, O, 5, c[28]), E = n(E, w, A, T, l, 9, c[29]), T = n(T, E, w, A, y, 14, c[30]), w = r(w, A = n(A, T, E, w, _, 20, c[31]), T, E, h, 4, c[32]), E = r(E, w, A, T, g, 11, c[33]), T = r(T, E, w, A, m, 16, c[34]), A = r(A, T, E, w, S, 23, c[35]), w = r(w, A, T, E, s, 4, c[36]), E = r(E, w, A, T, f, 11, c[37]), T = r(T, E, w, A, y, 16, c[38]), A = r(A, T, E, w, v, 23, c[39]), w = r(w, A, T, E, O, 4, c[40]), E = r(E, w, A, T, u, 11, c[41]), T = r(T, E, w, A, p, 16, c[42]), A = r(A, T, E, w, d, 23, c[43]), w = r(w, A, T, E, b, 4, c[44]), E = r(E, w, A, T, _, 11, c[45]), T = r(T, E, w, A, P, 16, c[46]), w = o(w, A = r(A, T, E, w, l, 23, c[47]), T, E, u, 6, c[48]), E = o(E, w, A, T, y, 10, c[49]), T = o(T, E, w, A, S, 15, c[50]), A = o(A, T, E, w, h, 21, c[51]), w = o(w, A, T, E, _, 6, c[52]), E = o(E, w, A, T, p, 10, c[53]), T = o(T, E, w, A, v, 15, c[54]), A = o(A, T, E, w, s, 21, c[55]), w = o(w, A, T, E, g, 6, c[56]), E = o(E, w, A, T, P, 10, c[57]), T = o(T, E, w, A, d, 15, c[58]), A = o(A, T, E, w, O, 21, c[59]), w = o(w, A, T, E, f, 6, c[60]), E = o(E, w, A, T, m, 10, c[61]), T = o(T, E, w, A, l, 15, c[62]), A = o(A, T, E, w, b, 21, c[63]);
        a[0] = a[0] + w | 0, a[1] = a[1] + A | 0, a[2] = a[2] + T | 0, a[3] = a[3] + E | 0;
      },
      _doFinalize: function () {
        var t = (this || _global)._data,
          n = t.words,
          r = 8 * (this || _global)._nDataBytes,
          o = 8 * t.sigBytes;
        n[o >>> 5] |= 128 << 24 - o % 32;
        var i = e.floor(r / 4294967296);
        for (n[15 + (o + 64 >>> 9 << 4)] = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8), n[14 + (o + 64 >>> 9 << 4)] = 16711935 & (r << 8 | r >>> 24) | 4278255360 & (r << 24 | r >>> 8), t.sigBytes = 4 * (n.length + 1), this._process(), n = (t = (this || _global)._hash).words, r = 0; 4 > r; r++) o = n[r], n[r] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8);
        return t;
      },
      clone: function () {
        var e = s.clone.call(this || _global);
        return e._hash = (this || _global)._hash.clone(), e;
      }
    }), i.MD5 = s._createHelper(u), i.HmacMD5 = s._createHmacHelper(u);
  }(Math), function () {
    var e,
      t = w,
      n = (e = t.lib).Base,
      r = e.WordArray,
      o = (e = t.algo).EvpKDF = n.extend({
        cfg: n.extend({
          keySize: 4,
          hasher: e.MD5,
          iterations: 1
        }),
        init: function (e) {
          (this || _global).cfg = (this || _global).cfg.extend(e);
        },
        compute: function (e, t) {
          for (var n = (s = (this || _global).cfg).hasher.create(), o = r.create(), i = o.words, a = s.keySize, s = s.iterations; i.length < a;) {
            u && n.update(u);
            var u = n.update(e).finalize(t);
            n.reset();
            for (var c = 1; c < s; c++) u = n.finalize(u), n.reset();
            o.concat(u);
          }
          return o.sigBytes = 4 * a, o;
        }
      });
    t.EvpKDF = function (e, t, n) {
      return o.create(n).compute(e, t);
    };
  }(), w.lib.Cipher || function (e) {
    var t = (h = w).lib,
      n = t.Base,
      r = t.WordArray,
      o = t.BufferedBlockAlgorithm,
      i = h.enc.Base64,
      a = h.algo.EvpKDF,
      s = t.Cipher = o.extend({
        cfg: n.extend(),
        createEncryptor: function (e, t) {
          return this.create((this || _global)._ENC_XFORM_MODE, e, t);
        },
        createDecryptor: function (e, t) {
          return this.create((this || _global)._DEC_XFORM_MODE, e, t);
        },
        init: function (e, t, n) {
          (this || _global).cfg = (this || _global).cfg.extend(n), (this || _global)._xformMode = e, (this || _global)._key = t, this.reset();
        },
        reset: function () {
          o.reset.call(this || _global), this._doReset();
        },
        process: function (e) {
          return this._append(e), this._process();
        },
        finalize: function (e) {
          return e && this._append(e), this._doFinalize();
        },
        keySize: 4,
        ivSize: 4,
        _ENC_XFORM_MODE: 1,
        _DEC_XFORM_MODE: 2,
        _createHelper: function (e) {
          return {
            encrypt: function (t, n, r) {
              return ("string" == typeof n ? d : f).encrypt(e, t, n, r);
            },
            decrypt: function (t, n, r) {
              return ("string" == typeof n ? d : f).decrypt(e, t, n, r);
            }
          };
        }
      });
    t.StreamCipher = s.extend({
      _doFinalize: function () {
        return this._process(!0);
      },
      blockSize: 1
    });
    var u = h.mode = {},
      c = function (e, t, n) {
        var r = (this || _global)._iv;
        r ? (this || _global)._iv = undefined : r = (this || _global)._prevBlock;
        for (var o = 0; o < n; o++) e[t + o] ^= r[o];
      },
      l = (t.BlockCipherMode = n.extend({
        createEncryptor: function (e, t) {
          return (this || _global).Encryptor.create(e, t);
        },
        createDecryptor: function (e, t) {
          return (this || _global).Decryptor.create(e, t);
        },
        init: function (e, t) {
          (this || _global)._cipher = e, (this || _global)._iv = t;
        }
      })).extend();
    l.Encryptor = l.extend({
      processBlock: function (e, t) {
        var n = (this || _global)._cipher,
          r = n.blockSize;
        c.call(this || _global, e, t, r), n.encryptBlock(e, t), (this || _global)._prevBlock = e.slice(t, t + r);
      }
    }), l.Decryptor = l.extend({
      processBlock: function (e, t) {
        var n = (this || _global)._cipher,
          r = n.blockSize,
          o = e.slice(t, t + r);
        n.decryptBlock(e, t), c.call(this || _global, e, t, r), (this || _global)._prevBlock = o;
      }
    }), u = u.CBC = l, l = (h.pad = {}).Pkcs7 = {
      pad: function (e, t) {
        for (var n, o = (n = (n = 4 * t) - e.sigBytes % n) << 24 | n << 16 | n << 8 | n, i = [], a = 0; a < n; a += 4) i.push(o);
        n = r.create(i, n), e.concat(n);
      },
      unpad: function (e) {
        e.sigBytes -= 255 & e.words[e.sigBytes - 1 >>> 2];
      }
    }, t.BlockCipher = s.extend({
      cfg: s.cfg.extend({
        mode: u,
        padding: l
      }),
      reset: function () {
        s.reset.call(this || _global);
        var e = (t = (this || _global).cfg).iv,
          t = t.mode;
        if ((this || _global)._xformMode == (this || _global)._ENC_XFORM_MODE) var n = t.createEncryptor;else n = t.createDecryptor, (this || _global)._minBufferSize = 1;
        (this || _global)._mode = n.call(t, this || _global, e && e.words);
      },
      _doProcessBlock: function (e, t) {
        (this || _global)._mode.processBlock(e, t);
      },
      _doFinalize: function () {
        var e = (this || _global).cfg.padding;
        if ((this || _global)._xformMode == (this || _global)._ENC_XFORM_MODE) {
          e.pad((this || _global)._data, (this || _global).blockSize);
          var t = this._process(!0);
        } else t = this._process(!0), e.unpad(t);
        return t;
      },
      blockSize: 4
    });
    var p = t.CipherParams = n.extend({
        init: function (e) {
          this.mixIn(e);
        },
        toString: function (e) {
          return (e || (this || _global).formatter).stringify(this || _global);
        }
      }),
      f = (u = (h.format = {}).OpenSSL = {
        stringify: function (e) {
          var t = e.ciphertext;
          return ((e = e.salt) ? r.create([1398893684, 1701076831]).concat(e).concat(t) : t).toString(i);
        },
        parse: function (e) {
          var t = (e = i.parse(e)).words;
          if (1398893684 == t[0] && 1701076831 == t[1]) {
            var n = r.create(t.slice(2, 4));
            t.splice(0, 4), e.sigBytes -= 16;
          }
          return p.create({
            ciphertext: e,
            salt: n
          });
        }
      }, t.SerializableCipher = n.extend({
        cfg: n.extend({
          format: u
        }),
        encrypt: function (e, t, n, r) {
          r = (this || _global).cfg.extend(r);
          var o = e.createEncryptor(n, r);
          return t = o.finalize(t), o = o.cfg, p.create({
            ciphertext: t,
            key: n,
            iv: o.iv,
            algorithm: e,
            mode: o.mode,
            padding: o.padding,
            blockSize: e.blockSize,
            formatter: r.format
          });
        },
        decrypt: function (e, t, n, r) {
          return r = (this || _global).cfg.extend(r), t = this._parse(t, r.format), e.createDecryptor(n, r).finalize(t.ciphertext);
        },
        _parse: function (e, t) {
          return "string" == typeof e ? t.parse(e, this || _global) : e;
        }
      })),
      h = (h.kdf = {}).OpenSSL = {
        execute: function (e, t, n, o) {
          return o || (o = r.random(8)), e = a.create({
            keySize: t + n
          }).compute(e, o), n = r.create(e.words.slice(t), 4 * n), e.sigBytes = 4 * t, p.create({
            key: e,
            iv: n,
            salt: o
          });
        }
      },
      d = t.PasswordBasedCipher = f.extend({
        cfg: f.cfg.extend({
          kdf: h
        }),
        encrypt: function (e, t, n, r) {
          return n = (r = (this || _global).cfg.extend(r)).kdf.execute(n, e.keySize, e.ivSize), r.iv = n.iv, (e = f.encrypt.call(this || _global, e, t, n.key, r)).mixIn(n), e;
        },
        decrypt: function (e, t, n, r) {
          return r = (this || _global).cfg.extend(r), t = this._parse(t, r.format), n = r.kdf.execute(n, e.keySize, e.ivSize, t.salt), r.iv = n.iv, f.decrypt.call(this || _global, e, t, n.key, r);
        }
      });
  }(), function () {
    for (var e = w, t = e.lib.BlockCipher, n = e.algo, r = [], o = [], i = [], a = [], s = [], u = [], c = [], l = [], p = [], f = [], h = [], d = 0; 256 > d; d++) h[d] = 128 > d ? d << 1 : d << 1 ^ 283;
    var y = 0,
      g = 0;
    for (d = 0; 256 > d; d++) {
      var b = (b = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4) >>> 8 ^ 255 & b ^ 99;
      r[y] = b, o[b] = y;
      var v = h[y],
        m = h[v],
        _ = h[m],
        O = 257 * h[b] ^ 16843008 * b;
      i[y] = O << 24 | O >>> 8, a[y] = O << 16 | O >>> 16, s[y] = O << 8 | O >>> 24, u[y] = O, O = 16843009 * _ ^ 65537 * m ^ 257 * v ^ 16843008 * y, c[b] = O << 24 | O >>> 8, l[b] = O << 16 | O >>> 16, p[b] = O << 8 | O >>> 24, f[b] = O, y ? (y = v ^ h[h[h[_ ^ v]]], g ^= h[h[g]]) : y = g = 1;
    }
    var S = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
    n = n.AES = t.extend({
      _doReset: function () {
        for (var e = (n = (this || _global)._key).words, t = n.sigBytes / 4, n = 4 * (((this || _global)._nRounds = t + 6) + 1), o = (this || _global)._keySchedule = [], i = 0; i < n; i++) if (i < t) o[i] = e[i];else {
          var a = o[i - 1];
          i % t ? 6 < t && 4 == i % t && (a = r[a >>> 24] << 24 | r[a >>> 16 & 255] << 16 | r[a >>> 8 & 255] << 8 | r[255 & a]) : (a = r[(a = a << 8 | a >>> 24) >>> 24] << 24 | r[a >>> 16 & 255] << 16 | r[a >>> 8 & 255] << 8 | r[255 & a], a ^= S[i / t | 0] << 24), o[i] = o[i - t] ^ a;
        }
        for (e = (this || _global)._invKeySchedule = [], t = 0; t < n; t++) i = n - t, a = t % 4 ? o[i] : o[i - 4], e[t] = 4 > t || 4 >= i ? a : c[r[a >>> 24]] ^ l[r[a >>> 16 & 255]] ^ p[r[a >>> 8 & 255]] ^ f[r[255 & a]];
      },
      encryptBlock: function (e, t) {
        this._doCryptBlock(e, t, (this || _global)._keySchedule, i, a, s, u, r);
      },
      decryptBlock: function (e, t) {
        var n = e[t + 1];
        e[t + 1] = e[t + 3], e[t + 3] = n, this._doCryptBlock(e, t, (this || _global)._invKeySchedule, c, l, p, f, o), n = e[t + 1], e[t + 1] = e[t + 3], e[t + 3] = n;
      },
      _doCryptBlock: function (e, t, n, r, o, i, a, s) {
        for (var u = (this || _global)._nRounds, c = e[t] ^ n[0], l = e[t + 1] ^ n[1], p = e[t + 2] ^ n[2], f = e[t + 3] ^ n[3], h = 4, d = 1; d < u; d++) {
          var y = r[c >>> 24] ^ o[l >>> 16 & 255] ^ i[p >>> 8 & 255] ^ a[255 & f] ^ n[h++],
            g = r[l >>> 24] ^ o[p >>> 16 & 255] ^ i[f >>> 8 & 255] ^ a[255 & c] ^ n[h++],
            b = r[p >>> 24] ^ o[f >>> 16 & 255] ^ i[c >>> 8 & 255] ^ a[255 & l] ^ n[h++];
          f = r[f >>> 24] ^ o[c >>> 16 & 255] ^ i[l >>> 8 & 255] ^ a[255 & p] ^ n[h++], c = y, l = g, p = b;
        }
        y = (s[c >>> 24] << 24 | s[l >>> 16 & 255] << 16 | s[p >>> 8 & 255] << 8 | s[255 & f]) ^ n[h++], g = (s[l >>> 24] << 24 | s[p >>> 16 & 255] << 16 | s[f >>> 8 & 255] << 8 | s[255 & c]) ^ n[h++], b = (s[p >>> 24] << 24 | s[f >>> 16 & 255] << 16 | s[c >>> 8 & 255] << 8 | s[255 & l]) ^ n[h++], f = (s[f >>> 24] << 24 | s[c >>> 16 & 255] << 16 | s[l >>> 8 & 255] << 8 | s[255 & p]) ^ n[h++], e[t] = y, e[t + 1] = g, e[t + 2] = b, e[t + 3] = f;
      },
      keySize: 8
    });
    e.AES = t._createHelper(n);
  }(), w.mode.ECB = ((P = w.lib.BlockCipherMode.extend()).Encryptor = P.extend({
    processBlock: function (e, t) {
      (this || _global)._cipher.encryptBlock(e, t);
    }
  }), P.Decryptor = P.extend({
    processBlock: function (e, t) {
      (this || _global)._cipher.decryptBlock(e, t);
    }
  }), P);
  var E = w;
  function T(e) {
    var t,
      n = [];
    for (t = 0; t < e.length; t += 1) n[t / 4 | 0] |= e[t] << 24 - 8 * t;
    return E.lib.WordArray.create(n, e.length);
  }
  var A = function () {
      function e(e) {
        var t = e.config;
        (this || _global)._config = t, (this || _global)._iv = "0123456789012345", (this || _global)._allowedKeyEncodings = ["hex", "utf8", "base64", "binary"], (this || _global)._allowedKeyLengths = [128, 256], (this || _global)._allowedModes = ["ecb", "cbc"], (this || _global)._defaultOptions = {
          encryptKey: !0,
          keyEncoding: "utf8",
          keyLength: 256,
          mode: "cbc"
        };
      }
      return e.prototype.HMACSHA256 = function (e) {
        return E.HmacSHA256(e, (this || _global)._config.secretKey).toString(E.enc.Base64);
      }, e.prototype.SHA256 = function (e) {
        return E.SHA256(e).toString(E.enc.Hex);
      }, e.prototype._parseOptions = function (e) {
        var t = e || {};
        return t.hasOwnProperty("encryptKey") || (t.encryptKey = (this || _global)._defaultOptions.encryptKey), t.hasOwnProperty("keyEncoding") || (t.keyEncoding = (this || _global)._defaultOptions.keyEncoding), t.hasOwnProperty("keyLength") || (t.keyLength = (this || _global)._defaultOptions.keyLength), t.hasOwnProperty("mode") || (t.mode = (this || _global)._defaultOptions.mode), -1 === (this || _global)._allowedKeyEncodings.indexOf(t.keyEncoding.toLowerCase()) && (t.keyEncoding = (this || _global)._defaultOptions.keyEncoding), -1 === (this || _global)._allowedKeyLengths.indexOf(parseInt(t.keyLength, 10)) && (t.keyLength = (this || _global)._defaultOptions.keyLength), -1 === (this || _global)._allowedModes.indexOf(t.mode.toLowerCase()) && (t.mode = (this || _global)._defaultOptions.mode), t;
      }, e.prototype._decodeKey = function (e, t) {
        return "base64" === t.keyEncoding ? E.enc.Base64.parse(e) : "hex" === t.keyEncoding ? E.enc.Hex.parse(e) : e;
      }, e.prototype._getPaddedKey = function (e, t) {
        return e = this._decodeKey(e, t), t.encryptKey ? E.enc.Utf8.parse(this.SHA256(e).slice(0, 32)) : e;
      }, e.prototype._getMode = function (e) {
        return "ecb" === e.mode ? E.mode.ECB : E.mode.CBC;
      }, e.prototype._getIV = function (e) {
        return "cbc" === e.mode ? E.enc.Utf8.parse((this || _global)._iv) : null;
      }, e.prototype._getRandomIV = function () {
        return E.lib.WordArray.random(16);
      }, e.prototype.encrypt = function (e, t, n) {
        return (this || _global)._config.customEncrypt ? (this || _global)._config.customEncrypt(e) : this.pnEncrypt(e, t, n);
      }, e.prototype.decrypt = function (e, t, n) {
        return (this || _global)._config.customDecrypt ? (this || _global)._config.customDecrypt(e) : this.pnDecrypt(e, t, n);
      }, e.prototype.pnEncrypt = function (e, t, n) {
        if (!t && !(this || _global)._config.cipherKey) return e;
        n = this._parseOptions(n);
        var r = this._getMode(n),
          o = this._getPaddedKey(t || (this || _global)._config.cipherKey, n);
        if ((this || _global)._config.useRandomIVs) {
          var i = this._getRandomIV(),
            a = E.AES.encrypt(e, o, {
              iv: i,
              mode: r
            }).ciphertext;
          return i.clone().concat(a.clone()).toString(E.enc.Base64);
        }
        var s = this._getIV(n);
        return E.AES.encrypt(e, o, {
          iv: s,
          mode: r
        }).ciphertext.toString(E.enc.Base64) || e;
      }, e.prototype.pnDecrypt = function (e, t, n) {
        if (!t && !(this || _global)._config.cipherKey) return e;
        n = this._parseOptions(n);
        var r = this._getMode(n),
          o = this._getPaddedKey(t || (this || _global)._config.cipherKey, n);
        if ((this || _global)._config.useRandomIVs) {
          var i = T((u = new Uint8ClampedArray(b(e))).slice(0, 16)),
            a = T(u.slice(16));
          try {
            var s = E.AES.decrypt({
              ciphertext: a
            }, o, {
              iv: i,
              mode: r
            }).toString(E.enc.Utf8);
            return JSON.parse(s);
          } catch (e) {
            return null;
          }
        } else {
          i = this._getIV(n);
          try {
            var u = E.enc.Base64.parse(e);
            s = E.AES.decrypt({
              ciphertext: u
            }, o, {
              iv: i,
              mode: r
            }).toString(E.enc.Utf8);
            return JSON.parse(s);
          } catch (e) {
            return null;
          }
        }
      }, e;
    }(),
    N = function () {
      function e(e) {
        var t = e.timeEndpoint;
        (this || _global)._timeEndpoint = t;
      }
      return e.prototype.onReconnection = function (e) {
        (this || _global)._reconnectionCallback = e;
      }, e.prototype.startPolling = function () {
        (this || _global)._timeTimer = setInterval((this || _global)._performTimeLoop.bind(this || _global), 3000);
      }, e.prototype.stopPolling = function () {
        clearInterval((this || _global)._timeTimer);
      }, e.prototype._performTimeLoop = function () {
        var e = this || _global;
        this._timeEndpoint(function (t) {
          t.error || (clearInterval(e._timeTimer), e._reconnectionCallback());
        });
      }, e;
    }(),
    k = function () {
      function e(e) {
        var t = e.config;
        (this || _global).hashHistory = [], (this || _global)._config = t;
      }
      return e.prototype.getKey = function (e) {
        var t = function (e) {
            var t = 0;
            if (0 === e.length) return t;
            for (var n = 0; n < e.length; n += 1) t = (t << 5) - t + e.charCodeAt(n), t &= t;
            return t;
          }(JSON.stringify(e.payload)).toString(),
          n = e.publishMetaData.publishTimetoken;
        return "".concat(n, "-").concat(t);
      }, e.prototype.isDuplicate = function (e) {
        return (this || _global).hashHistory.includes(this.getKey(e));
      }, e.prototype.addEntry = function (e) {
        (this || _global).hashHistory.length >= (this || _global)._config.maximumCacheSize && (this || _global).hashHistory.shift(), (this || _global).hashHistory.push(this.getKey(e));
      }, e.prototype.clearHistory = function () {
        (this || _global).hashHistory = [];
      }, e;
    }();
  function C(e) {
    return encodeURIComponent(e).replace(/[!~*'()]/g, function (e) {
      return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
    });
  }
  function j(e) {
    return function (e) {
      var t = [];
      return Object.keys(e).forEach(function (e) {
        return t.push(e);
      }), t;
    }(e).sort();
  }
  var M = {
      signPamFromParams: function (e) {
        return j(e).map(function (t) {
          return "".concat(t, "=").concat(C(e[t]));
        }).join("&");
      },
      endsWith: function (e, t) {
        return -1 !== e.indexOf(t, (this || _global).length - t.length);
      },
      createPromise: function () {
        var e, t;
        return {
          promise: new Promise(function (n, r) {
            e = n, t = r;
          }),
          reject: t,
          fulfill: e
        };
      },
      encodeString: C,
      stringToArrayBuffer: function (e) {
        for (var t = new ArrayBuffer(2 * e.length), n = new Uint16Array(t), r = 0, o = e.length; r < o; r++) n[r] = e.charCodeAt(r);
        return t;
      }
    },
    R = {
      PNNetworkUpCategory: "PNNetworkUpCategory",
      PNNetworkDownCategory: "PNNetworkDownCategory",
      PNNetworkIssuesCategory: "PNNetworkIssuesCategory",
      PNTimeoutCategory: "PNTimeoutCategory",
      PNBadRequestCategory: "PNBadRequestCategory",
      PNAccessDeniedCategory: "PNAccessDeniedCategory",
      PNUnknownCategory: "PNUnknownCategory",
      PNReconnectedCategory: "PNReconnectedCategory",
      PNConnectedCategory: "PNConnectedCategory",
      PNRequestMessageCountExceededCategory: "PNRequestMessageCountExceededCategory"
    },
    U = function () {
      function e(e) {
        var t = e.subscribeEndpoint,
          n = e.leaveEndpoint,
          r = e.heartbeatEndpoint,
          o = e.setStateEndpoint,
          i = e.timeEndpoint,
          a = e.getFileUrl,
          s = e.config,
          u = e.crypto,
          c = e.listenerManager,
          l = e.cryptoModule;
        (this || _global)._listenerManager = c, (this || _global)._config = s, (this || _global)._leaveEndpoint = n, (this || _global)._heartbeatEndpoint = r, (this || _global)._setStateEndpoint = o, (this || _global)._subscribeEndpoint = t, (this || _global)._getFileUrl = a, (this || _global)._crypto = u, (this || _global)._cryptoModule = l, (this || _global)._channels = {}, (this || _global)._presenceChannels = {}, (this || _global)._heartbeatChannels = {}, (this || _global)._heartbeatChannelGroups = {}, (this || _global)._channelGroups = {}, (this || _global)._presenceChannelGroups = {}, (this || _global)._pendingChannelSubscriptions = [], (this || _global)._pendingChannelGroupSubscriptions = [], (this || _global)._currentTimetoken = 0, (this || _global)._lastTimetoken = 0, (this || _global)._storedTimetoken = null, (this || _global)._subscriptionStatusAnnounced = !1, (this || _global)._isOnline = !0, (this || _global)._reconnectionManager = new N({
          timeEndpoint: i
        }), (this || _global)._dedupingManager = new k({
          config: s
        }), (this || _global)._cryptoModule && ((this || _global)._decoder = new TextDecoder());
      }
      return e.prototype.adaptStateChange = function (e, t) {
        var n = this || _global,
          r = e.state,
          o = e.channels,
          i = void 0 === o ? [] : o,
          a = e.channelGroups,
          s = void 0 === a ? [] : a,
          u = e.withHeartbeat,
          c = void 0 !== u && u;
        if (i.forEach(function (e) {
          e in n._channels && (n._channels[e].state = r);
        }), s.forEach(function (e) {
          e in n._channelGroups && (n._channelGroups[e].state = r);
        }), c) {
          var l = {};
          return i.forEach(function (e) {
            return l[e] = r;
          }), s.forEach(function (e) {
            return l[e] = r;
          }), this._heartbeatEndpoint({
            channels: i,
            channelGroups: s,
            state: l
          }, t);
        }
        return this._setStateEndpoint({
          state: r,
          channels: i,
          channelGroups: s
        }, t);
      }, e.prototype.adaptPresenceChange = function (e) {
        var t = this || _global,
          n = e.connected,
          r = e.channels,
          o = void 0 === r ? [] : r,
          i = e.channelGroups,
          a = void 0 === i ? [] : i;
        n ? (o.forEach(function (e) {
          t._heartbeatChannels[e] = {
            state: {}
          };
        }), a.forEach(function (e) {
          t._heartbeatChannelGroups[e] = {
            state: {}
          };
        })) : (o.forEach(function (e) {
          e in t._heartbeatChannels && delete t._heartbeatChannels[e];
        }), a.forEach(function (e) {
          e in t._heartbeatChannelGroups && delete t._heartbeatChannelGroups[e];
        }), !1 === (this || _global)._config.suppressLeaveEvents && this._leaveEndpoint({
          channels: o,
          channelGroups: a
        }, function (e) {
          t._listenerManager.announceStatus(e);
        })), this.reconnect();
      }, e.prototype.adaptSubscribeChange = function (e) {
        var t = this || _global,
          n = e.timetoken,
          r = e.channels,
          o = void 0 === r ? [] : r,
          i = e.channelGroups,
          a = void 0 === i ? [] : i,
          s = e.withPresence,
          u = void 0 !== s && s,
          c = e.withHeartbeats,
          l = void 0 !== c && c;
        (this || _global)._config.subscribeKey && "" !== (this || _global)._config.subscribeKey ? (n && ((this || _global)._lastTimetoken = (this || _global)._currentTimetoken, (this || _global)._currentTimetoken = n), "0" !== (this || _global)._currentTimetoken && 0 !== (this || _global)._currentTimetoken && ((this || _global)._storedTimetoken = (this || _global)._currentTimetoken, (this || _global)._currentTimetoken = 0), o.forEach(function (e) {
          t._channels[e] = {
            state: {}
          }, u && (t._presenceChannels[e] = {}), (l || t._config.getHeartbeatInterval()) && (t._heartbeatChannels[e] = {}), t._pendingChannelSubscriptions.push(e);
        }), a.forEach(function (e) {
          t._channelGroups[e] = {
            state: {}
          }, u && (t._presenceChannelGroups[e] = {}), (l || t._config.getHeartbeatInterval()) && (t._heartbeatChannelGroups[e] = {}), t._pendingChannelGroupSubscriptions.push(e);
        }), (this || _global)._subscriptionStatusAnnounced = !1, this.reconnect()) : console && console.log && console.log("subscribe key missing; aborting subscribe");
      }, e.prototype.adaptUnsubscribeChange = function (e, t) {
        var n = this || _global,
          r = e.channels,
          o = void 0 === r ? [] : r,
          i = e.channelGroups,
          a = void 0 === i ? [] : i,
          s = [],
          u = [];
        o.forEach(function (e) {
          e in n._channels && (delete n._channels[e], s.push(e), e in n._heartbeatChannels && delete n._heartbeatChannels[e]), e in n._presenceChannels && (delete n._presenceChannels[e], s.push(e));
        }), a.forEach(function (e) {
          e in n._channelGroups && (delete n._channelGroups[e], u.push(e), e in n._heartbeatChannelGroups && delete n._heartbeatChannelGroups[e]), e in n._presenceChannelGroups && (delete n._presenceChannelGroups[e], u.push(e));
        }), 0 === s.length && 0 === u.length || (!1 !== (this || _global)._config.suppressLeaveEvents || t || this._leaveEndpoint({
          channels: s,
          channelGroups: u
        }, function (e) {
          e.affectedChannels = s, e.affectedChannelGroups = u, e.currentTimetoken = n._currentTimetoken, e.lastTimetoken = n._lastTimetoken, n._listenerManager.announceStatus(e);
        }), 0 === Object.keys((this || _global)._channels).length && 0 === Object.keys((this || _global)._presenceChannels).length && 0 === Object.keys((this || _global)._channelGroups).length && 0 === Object.keys((this || _global)._presenceChannelGroups).length && ((this || _global)._lastTimetoken = 0, (this || _global)._currentTimetoken = 0, (this || _global)._storedTimetoken = null, (this || _global)._region = null, (this || _global)._reconnectionManager.stopPolling()), this.reconnect());
      }, e.prototype.unsubscribeAll = function (e) {
        this.adaptUnsubscribeChange({
          channels: this.getSubscribedChannels(),
          channelGroups: this.getSubscribedChannelGroups()
        }, e);
      }, e.prototype.getHeartbeatChannels = function () {
        return Object.keys((this || _global)._heartbeatChannels);
      }, e.prototype.getHeartbeatChannelGroups = function () {
        return Object.keys((this || _global)._heartbeatChannelGroups);
      }, e.prototype.getSubscribedChannels = function () {
        return Object.keys((this || _global)._channels);
      }, e.prototype.getSubscribedChannelGroups = function () {
        return Object.keys((this || _global)._channelGroups);
      }, e.prototype.reconnect = function () {
        this._startSubscribeLoop(), this._registerHeartbeatTimer();
      }, e.prototype.disconnect = function () {
        this._stopSubscribeLoop(), this._stopHeartbeatTimer(), (this || _global)._reconnectionManager.stopPolling();
      }, e.prototype._registerHeartbeatTimer = function () {
        this._stopHeartbeatTimer(), 0 !== (this || _global)._config.getHeartbeatInterval() && void 0 !== (this || _global)._config.getHeartbeatInterval() && (this._performHeartbeatLoop(), (this || _global)._heartbeatTimer = setInterval((this || _global)._performHeartbeatLoop.bind(this || _global), 1000 * (this || _global)._config.getHeartbeatInterval()));
      }, e.prototype._stopHeartbeatTimer = function () {
        (this || _global)._heartbeatTimer && (clearInterval((this || _global)._heartbeatTimer), (this || _global)._heartbeatTimer = null);
      }, e.prototype._performHeartbeatLoop = function () {
        var e = this || _global,
          t = this.getHeartbeatChannels(),
          n = this.getHeartbeatChannelGroups(),
          r = {};
        if (0 !== t.length || 0 !== n.length) {
          this.getSubscribedChannels().forEach(function (t) {
            var n = e._channels[t].state;
            Object.keys(n).length && (r[t] = n);
          }), this.getSubscribedChannelGroups().forEach(function (t) {
            var n = e._channelGroups[t].state;
            Object.keys(n).length && (r[t] = n);
          });
          this._heartbeatEndpoint({
            channels: t,
            channelGroups: n,
            state: r
          }, function (t) {
            t.error && e._config.announceFailedHeartbeats && e._listenerManager.announceStatus(t), t.error && e._config.autoNetworkDetection && e._isOnline && (e._isOnline = !1, e.disconnect(), e._listenerManager.announceNetworkDown(), e.reconnect()), !t.error && e._config.announceSuccessfulHeartbeats && e._listenerManager.announceStatus(t);
          }.bind(this || _global));
        }
      }, e.prototype._startSubscribeLoop = function () {
        var e = this || _global;
        this._stopSubscribeLoop();
        var t = {},
          n = [],
          r = [];
        if (Object.keys((this || _global)._channels).forEach(function (r) {
          var o = e._channels[r].state;
          Object.keys(o).length && (t[r] = o), n.push(r);
        }), Object.keys((this || _global)._presenceChannels).forEach(function (e) {
          n.push("".concat(e, "-pnpres"));
        }), Object.keys((this || _global)._channelGroups).forEach(function (n) {
          var o = e._channelGroups[n].state;
          Object.keys(o).length && (t[n] = o), r.push(n);
        }), Object.keys((this || _global)._presenceChannelGroups).forEach(function (e) {
          r.push("".concat(e, "-pnpres"));
        }), 0 !== n.length || 0 !== r.length) {
          var o = {
            channels: n,
            channelGroups: r,
            state: t,
            timetoken: (this || _global)._currentTimetoken,
            filterExpression: (this || _global)._config.filterExpression,
            region: (this || _global)._region
          };
          (this || _global)._subscribeCall = this._subscribeEndpoint(o, (this || _global)._processSubscribeResponse.bind(this || _global));
        }
      }, e.prototype._processSubscribeResponse = function (e, t) {
        var o = this || _global;
        if (e.error) {
          if (e.errorData && "Aborted" === e.errorData.message) return;
          e.category === R.PNTimeoutCategory ? this._startSubscribeLoop() : e.category === R.PNNetworkIssuesCategory ? (this.disconnect(), e.error && (this || _global)._config.autoNetworkDetection && (this || _global)._isOnline && ((this || _global)._isOnline = !1, (this || _global)._listenerManager.announceNetworkDown()), (this || _global)._reconnectionManager.onReconnection(function () {
            o._config.autoNetworkDetection && !o._isOnline && (o._isOnline = !0, o._listenerManager.announceNetworkUp()), o.reconnect(), o._subscriptionStatusAnnounced = !0;
            var t = {
              category: R.PNReconnectedCategory,
              operation: e.operation,
              lastTimetoken: o._lastTimetoken,
              currentTimetoken: o._currentTimetoken
            };
            o._listenerManager.announceStatus(t);
          }), (this || _global)._reconnectionManager.startPolling(), (this || _global)._listenerManager.announceStatus(e)) : e.category === R.PNBadRequestCategory ? (this._stopHeartbeatTimer(), (this || _global)._listenerManager.announceStatus(e)) : (this || _global)._listenerManager.announceStatus(e);
        } else {
          if ((this || _global)._storedTimetoken ? ((this || _global)._currentTimetoken = (this || _global)._storedTimetoken, (this || _global)._storedTimetoken = null) : ((this || _global)._lastTimetoken = (this || _global)._currentTimetoken, (this || _global)._currentTimetoken = t.metadata.timetoken), !(this || _global)._subscriptionStatusAnnounced) {
            var i = {};
            i.category = R.PNConnectedCategory, i.operation = e.operation, i.affectedChannels = (this || _global)._pendingChannelSubscriptions, i.subscribedChannels = this.getSubscribedChannels(), i.affectedChannelGroups = (this || _global)._pendingChannelGroupSubscriptions, i.lastTimetoken = (this || _global)._lastTimetoken, i.currentTimetoken = (this || _global)._currentTimetoken, (this || _global)._subscriptionStatusAnnounced = !0, (this || _global)._listenerManager.announceStatus(i), (this || _global)._pendingChannelSubscriptions = [], (this || _global)._pendingChannelGroupSubscriptions = [];
          }
          var a = t.messages || [],
            s = (this || _global)._config,
            u = s.requestMessageCountThreshold,
            c = s.dedupeOnSubscribe;
          if (u && a.length >= u) {
            var l = {};
            l.category = R.PNRequestMessageCountExceededCategory, l.operation = e.operation, (this || _global)._listenerManager.announceStatus(l);
          }
          a.forEach(function (e) {
            var t = e.channel,
              i = e.subscriptionMatch,
              a = e.publishMetaData;
            if (t === i && (i = null), c) {
              if (o._dedupingManager.isDuplicate(e)) return;
              o._dedupingManager.addEntry(e);
            }
            if (M.endsWith(e.channel, "-pnpres")) (y = {
              channel: null,
              subscription: null
            }).actualChannel = null != i ? t : null, y.subscribedChannel = null != i ? i : t, t && (y.channel = t.substring(0, t.lastIndexOf("-pnpres"))), i && (y.subscription = i.substring(0, i.lastIndexOf("-pnpres"))), y.action = e.payload.action, y.state = e.payload.data, y.timetoken = a.publishTimetoken, y.occupancy = e.payload.occupancy, y.uuid = e.payload.uuid, y.timestamp = e.payload.timestamp, e.payload.join && (y.join = e.payload.join), e.payload.leave && (y.leave = e.payload.leave), e.payload.timeout && (y.timeout = e.payload.timeout), o._listenerManager.announcePresence(y);else if (1 === e.messageType) {
              (y = {
                channel: null,
                subscription: null
              }).channel = t, y.subscription = i, y.timetoken = a.publishTimetoken, y.publisher = e.issuingClientId, e.userMetadata && (y.userMetadata = e.userMetadata), y.message = e.payload, o._listenerManager.announceSignal(y);
            } else if (2 === e.messageType) {
              if ((y = {
                channel: null,
                subscription: null
              }).channel = t, y.subscription = i, y.timetoken = a.publishTimetoken, y.publisher = e.issuingClientId, e.userMetadata && (y.userMetadata = e.userMetadata), y.message = {
                event: e.payload.event,
                type: e.payload.type,
                data: e.payload.data
              }, o._listenerManager.announceObjects(y), "uuid" === e.payload.type) {
                var s = o._renameChannelField(y);
                o._listenerManager.announceUser(n(n({}, s), {
                  message: n(n({}, s.message), {
                    event: o._renameEvent(s.message.event),
                    type: "user"
                  })
                }));
              } else if ("channel" === e.payload.type) {
                s = o._renameChannelField(y);
                o._listenerManager.announceSpace(n(n({}, s), {
                  message: n(n({}, s.message), {
                    event: o._renameEvent(s.message.event),
                    type: "space"
                  })
                }));
              } else if ("membership" === e.payload.type) {
                var u = (s = o._renameChannelField(y)).message.data,
                  l = u.uuid,
                  p = u.channel,
                  f = r(u, ["uuid", "channel"]);
                f.user = l, f.space = p, o._listenerManager.announceMembership(n(n({}, s), {
                  message: n(n({}, s.message), {
                    event: o._renameEvent(s.message.event),
                    data: f
                  })
                }));
              }
            } else if (3 === e.messageType) {
              (y = {}).channel = t, y.subscription = i, y.timetoken = a.publishTimetoken, y.publisher = e.issuingClientId, y.data = {
                messageTimetoken: e.payload.data.messageTimetoken,
                actionTimetoken: e.payload.data.actionTimetoken,
                type: e.payload.data.type,
                uuid: e.issuingClientId,
                value: e.payload.data.value
              }, y.event = e.payload.event, o._listenerManager.announceMessageAction(y);
            } else if (4 === e.messageType) {
              (y = {}).channel = t, y.subscription = i, y.timetoken = a.publishTimetoken, y.publisher = e.issuingClientId;
              var h = e.payload;
              if (o._cryptoModule) {
                var d = void 0;
                try {
                  d = (g = o._cryptoModule.decrypt(e.payload)) instanceof ArrayBuffer ? JSON.parse(o._decoder.decode(g)) : g;
                } catch (e) {
                  d = null, console && console.log && console.log("decryption error", e.message);
                }
                null !== d && (h = d);
              }
              e.userMetadata && (y.userMetadata = e.userMetadata), y.message = h.message, y.file = {
                id: h.file.id,
                name: h.file.name,
                url: o._getFileUrl({
                  id: h.file.id,
                  name: h.file.name,
                  channel: t
                })
              }, o._listenerManager.announceFile(y);
            } else {
              var y;
              if ((y = {
                channel: null,
                subscription: null
              }).actualChannel = null != i ? t : null, y.subscribedChannel = null != i ? i : t, y.channel = t, y.subscription = i, y.timetoken = a.publishTimetoken, y.publisher = e.issuingClientId, e.userMetadata && (y.userMetadata = e.userMetadata), o._cryptoModule) {
                d = void 0;
                try {
                  var g;
                  d = (g = o._cryptoModule.decrypt(e.payload)) instanceof ArrayBuffer ? JSON.parse(o._decoder.decode(g)) : g;
                } catch (e) {
                  d = null, console && console.log && console.log("decryption error", e.message);
                }
                y.message = null != d ? d : e.payload;
              } else y.message = e.payload;
              o._listenerManager.announceMessage(y);
            }
          }), (this || _global)._region = t.metadata.region, this._startSubscribeLoop();
        }
      }, e.prototype._stopSubscribeLoop = function () {
        (this || _global)._subscribeCall && ("function" == typeof (this || _global)._subscribeCall.abort && (this || _global)._subscribeCall.abort(), (this || _global)._subscribeCall = null);
      }, e.prototype._renameEvent = function (e) {
        return "set" === e ? "updated" : "removed";
      }, e.prototype._renameChannelField = function (e) {
        var t = e.channel,
          n = r(e, ["channel"]);
        return n.spaceId = t, n;
      }, e;
    }(),
    I = {
      PNTimeOperation: "PNTimeOperation",
      PNHistoryOperation: "PNHistoryOperation",
      PNDeleteMessagesOperation: "PNDeleteMessagesOperation",
      PNFetchMessagesOperation: "PNFetchMessagesOperation",
      PNMessageCounts: "PNMessageCountsOperation",
      PNSubscribeOperation: "PNSubscribeOperation",
      PNUnsubscribeOperation: "PNUnsubscribeOperation",
      PNPublishOperation: "PNPublishOperation",
      PNSignalOperation: "PNSignalOperation",
      PNAddMessageActionOperation: "PNAddActionOperation",
      PNRemoveMessageActionOperation: "PNRemoveMessageActionOperation",
      PNGetMessageActionsOperation: "PNGetMessageActionsOperation",
      PNCreateUserOperation: "PNCreateUserOperation",
      PNUpdateUserOperation: "PNUpdateUserOperation",
      PNDeleteUserOperation: "PNDeleteUserOperation",
      PNGetUserOperation: "PNGetUsersOperation",
      PNGetUsersOperation: "PNGetUsersOperation",
      PNCreateSpaceOperation: "PNCreateSpaceOperation",
      PNUpdateSpaceOperation: "PNUpdateSpaceOperation",
      PNDeleteSpaceOperation: "PNDeleteSpaceOperation",
      PNGetSpaceOperation: "PNGetSpacesOperation",
      PNGetSpacesOperation: "PNGetSpacesOperation",
      PNGetMembersOperation: "PNGetMembersOperation",
      PNUpdateMembersOperation: "PNUpdateMembersOperation",
      PNGetMembershipsOperation: "PNGetMembershipsOperation",
      PNUpdateMembershipsOperation: "PNUpdateMembershipsOperation",
      PNListFilesOperation: "PNListFilesOperation",
      PNGenerateUploadUrlOperation: "PNGenerateUploadUrlOperation",
      PNPublishFileOperation: "PNPublishFileOperation",
      PNGetFileUrlOperation: "PNGetFileUrlOperation",
      PNDownloadFileOperation: "PNDownloadFileOperation",
      PNGetAllUUIDMetadataOperation: "PNGetAllUUIDMetadataOperation",
      PNGetUUIDMetadataOperation: "PNGetUUIDMetadataOperation",
      PNSetUUIDMetadataOperation: "PNSetUUIDMetadataOperation",
      PNRemoveUUIDMetadataOperation: "PNRemoveUUIDMetadataOperation",
      PNGetAllChannelMetadataOperation: "PNGetAllChannelMetadataOperation",
      PNGetChannelMetadataOperation: "PNGetChannelMetadataOperation",
      PNSetChannelMetadataOperation: "PNSetChannelMetadataOperation",
      PNRemoveChannelMetadataOperation: "PNRemoveChannelMetadataOperation",
      PNSetMembersOperation: "PNSetMembersOperation",
      PNSetMembershipsOperation: "PNSetMembershipsOperation",
      PNPushNotificationEnabledChannelsOperation: "PNPushNotificationEnabledChannelsOperation",
      PNRemoveAllPushNotificationsOperation: "PNRemoveAllPushNotificationsOperation",
      PNWhereNowOperation: "PNWhereNowOperation",
      PNSetStateOperation: "PNSetStateOperation",
      PNHereNowOperation: "PNHereNowOperation",
      PNGetStateOperation: "PNGetStateOperation",
      PNHeartbeatOperation: "PNHeartbeatOperation",
      PNChannelGroupsOperation: "PNChannelGroupsOperation",
      PNRemoveGroupOperation: "PNRemoveGroupOperation",
      PNChannelsForGroupOperation: "PNChannelsForGroupOperation",
      PNAddChannelsToGroupOperation: "PNAddChannelsToGroupOperation",
      PNRemoveChannelsFromGroupOperation: "PNRemoveChannelsFromGroupOperation",
      PNAccessManagerGrant: "PNAccessManagerGrant",
      PNAccessManagerGrantToken: "PNAccessManagerGrantToken",
      PNAccessManagerAudit: "PNAccessManagerAudit",
      PNAccessManagerRevokeToken: "PNAccessManagerRevokeToken",
      PNHandshakeOperation: "PNHandshakeOperation",
      PNReceiveMessagesOperation: "PNReceiveMessagesOperation"
    },
    x = function () {
      function e(e) {
        (this || _global)._maximumSamplesCount = 100, (this || _global)._trackedLatencies = {}, (this || _global)._latencies = {}, (this || _global)._maximumSamplesCount = e.maximumSamplesCount || (this || _global)._maximumSamplesCount;
      }
      return e.prototype.operationsLatencyForRequest = function () {
        var e = this || _global,
          t = {};
        return Object.keys((this || _global)._latencies).forEach(function (n) {
          var r = e._latencies[n],
            o = e._averageLatency(r);
          o > 0 && (t["l_".concat(n)] = o);
        }), t;
      }, e.prototype.startLatencyMeasure = function (e, t) {
        e !== I.PNSubscribeOperation && t && ((this || _global)._trackedLatencies[t] = Date.now());
      }, e.prototype.stopLatencyMeasure = function (e, t) {
        if (e !== I.PNSubscribeOperation && t) {
          var n = this._endpointName(e),
            r = (this || _global)._latencies[n],
            o = (this || _global)._trackedLatencies[t];
          r || ((this || _global)._latencies[n] = [], r = (this || _global)._latencies[n]), r.push(Date.now() - o), r.length > (this || _global)._maximumSamplesCount && r.splice(0, r.length - (this || _global)._maximumSamplesCount), delete (this || _global)._trackedLatencies[t];
        }
      }, e.prototype._averageLatency = function (e) {
        return Math.floor(e.reduce(function (e, t) {
          return e + t;
        }, 0) / e.length);
      }, e.prototype._endpointName = function (e) {
        var t = null;
        switch (e) {
          case I.PNPublishOperation:
            t = "pub";
            break;
          case I.PNSignalOperation:
            t = "sig";
            break;
          case I.PNHistoryOperation:
          case I.PNFetchMessagesOperation:
          case I.PNDeleteMessagesOperation:
          case I.PNMessageCounts:
            t = "hist";
            break;
          case I.PNUnsubscribeOperation:
          case I.PNWhereNowOperation:
          case I.PNHereNowOperation:
          case I.PNHeartbeatOperation:
          case I.PNSetStateOperation:
          case I.PNGetStateOperation:
            t = "pres";
            break;
          case I.PNAddChannelsToGroupOperation:
          case I.PNRemoveChannelsFromGroupOperation:
          case I.PNChannelGroupsOperation:
          case I.PNRemoveGroupOperation:
          case I.PNChannelsForGroupOperation:
            t = "cg";
            break;
          case I.PNPushNotificationEnabledChannelsOperation:
          case I.PNRemoveAllPushNotificationsOperation:
            t = "push";
            break;
          case I.PNCreateUserOperation:
          case I.PNUpdateUserOperation:
          case I.PNDeleteUserOperation:
          case I.PNGetUserOperation:
          case I.PNGetUsersOperation:
          case I.PNCreateSpaceOperation:
          case I.PNUpdateSpaceOperation:
          case I.PNDeleteSpaceOperation:
          case I.PNGetSpaceOperation:
          case I.PNGetSpacesOperation:
          case I.PNGetMembersOperation:
          case I.PNUpdateMembersOperation:
          case I.PNGetMembershipsOperation:
          case I.PNUpdateMembershipsOperation:
            t = "obj";
            break;
          case I.PNAddMessageActionOperation:
          case I.PNRemoveMessageActionOperation:
          case I.PNGetMessageActionsOperation:
            t = "msga";
            break;
          case I.PNAccessManagerGrant:
          case I.PNAccessManagerAudit:
            t = "pam";
            break;
          case I.PNAccessManagerGrantToken:
          case I.PNAccessManagerRevokeToken:
            t = "pamv3";
            break;
          default:
            t = "time";
        }
        return t;
      }, e;
    }(),
    D = function () {
      function e(e, t, n) {
        (this || _global)._payload = e, this._setDefaultPayloadStructure(), (this || _global).title = t, (this || _global).body = n;
      }
      return Object.defineProperty(e.prototype, "payload", {
        get: function () {
          return (this || _global)._payload;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "title", {
        set: function (e) {
          (this || _global)._title = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "subtitle", {
        set: function (e) {
          (this || _global)._subtitle = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "body", {
        set: function (e) {
          (this || _global)._body = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "badge", {
        set: function (e) {
          (this || _global)._badge = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sound", {
        set: function (e) {
          (this || _global)._sound = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype._setDefaultPayloadStructure = function () {}, e.prototype.toObject = function () {
        return {};
      }, e;
    }(),
    F = function (e) {
      function r() {
        return null !== e && e.apply(this || _global, arguments) || this || _global;
      }
      return t(r, e), Object.defineProperty(r.prototype, "configurations", {
        set: function (e) {
          e && e.length && ((this || _global)._configurations = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "notification", {
        get: function () {
          return (this || _global)._payload.aps;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "title", {
        get: function () {
          return (this || _global)._title;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.aps.alert.title = e, (this || _global)._title = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "subtitle", {
        get: function () {
          return (this || _global)._subtitle;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.aps.alert.subtitle = e, (this || _global)._subtitle = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "body", {
        get: function () {
          return (this || _global)._body;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.aps.alert.body = e, (this || _global)._body = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "badge", {
        get: function () {
          return (this || _global)._badge;
        },
        set: function (e) {
          null != e && ((this || _global)._payload.aps.badge = e, (this || _global)._badge = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "sound", {
        get: function () {
          return (this || _global)._sound;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.aps.sound = e, (this || _global)._sound = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "silent", {
        set: function (e) {
          (this || _global)._isSilent = e;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype._setDefaultPayloadStructure = function () {
        (this || _global)._payload.aps = {
          alert: {}
        };
      }, r.prototype.toObject = function () {
        var e = this || _global,
          t = n({}, (this || _global)._payload),
          r = t.aps,
          o = r.alert;
        if ((this || _global)._isSilent && (r["content-available"] = 1), "apns2" === (this || _global)._apnsPushType) {
          if (!(this || _global)._configurations || !(this || _global)._configurations.length) throw new ReferenceError("APNS2 configuration is missing");
          var i = [];
          (this || _global)._configurations.forEach(function (t) {
            i.push(e._objectFromAPNS2Configuration(t));
          }), i.length && (t.pn_push = i);
        }
        return o && Object.keys(o).length || delete r.alert, (this || _global)._isSilent && (delete r.alert, delete r.badge, delete r.sound, o = {}), (this || _global)._isSilent || Object.keys(o).length ? t : null;
      }, r.prototype._objectFromAPNS2Configuration = function (e) {
        var t = this || _global;
        if (!e.targets || !e.targets.length) throw new ReferenceError("At least one APNS2 target should be provided");
        var n = [];
        e.targets.forEach(function (e) {
          n.push(t._objectFromAPNSTarget(e));
        });
        var r = e.collapseId,
          o = e.expirationDate,
          i = {
            auth_method: "token",
            targets: n,
            version: "v2"
          };
        return r && r.length && (i.collapse_id = r), o && (i.expiration = o.toISOString()), i;
      }, r.prototype._objectFromAPNSTarget = function (e) {
        if (!e.topic || !e.topic.length) throw new TypeError("Target 'topic' undefined.");
        var t = e.topic,
          n = e.environment,
          r = void 0 === n ? "development" : n,
          o = e.excludedDevices,
          i = void 0 === o ? [] : o,
          a = {
            topic: t,
            environment: r
          };
        return i.length && (a.excluded_devices = i), a;
      }, r;
    }(D),
    G = function (e) {
      function r() {
        return null !== e && e.apply(this || _global, arguments) || this || _global;
      }
      return t(r, e), Object.defineProperty(r.prototype, "backContent", {
        get: function () {
          return (this || _global)._backContent;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.back_content = e, (this || _global)._backContent = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "backTitle", {
        get: function () {
          return (this || _global)._backTitle;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.back_title = e, (this || _global)._backTitle = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "count", {
        get: function () {
          return (this || _global)._count;
        },
        set: function (e) {
          null != e && ((this || _global)._payload.count = e, (this || _global)._count = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "title", {
        get: function () {
          return (this || _global)._title;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.title = e, (this || _global)._title = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "type", {
        get: function () {
          return (this || _global)._type;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.type = e, (this || _global)._type = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "subtitle", {
        get: function () {
          return (this || _global).backTitle;
        },
        set: function (e) {
          (this || _global).backTitle = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "body", {
        get: function () {
          return (this || _global).backContent;
        },
        set: function (e) {
          (this || _global).backContent = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "badge", {
        get: function () {
          return (this || _global).count;
        },
        set: function (e) {
          (this || _global).count = e;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.toObject = function () {
        return Object.keys((this || _global)._payload).length ? n({}, (this || _global)._payload) : null;
      }, r;
    }(D),
    L = function (e) {
      function o() {
        return null !== e && e.apply(this || _global, arguments) || this || _global;
      }
      return t(o, e), Object.defineProperty(o.prototype, "notification", {
        get: function () {
          return (this || _global)._payload.notification;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "data", {
        get: function () {
          return (this || _global)._payload.data;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "title", {
        get: function () {
          return (this || _global)._title;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.notification.title = e, (this || _global)._title = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "body", {
        get: function () {
          return (this || _global)._body;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.notification.body = e, (this || _global)._body = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "sound", {
        get: function () {
          return (this || _global)._sound;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.notification.sound = e, (this || _global)._sound = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "icon", {
        get: function () {
          return (this || _global)._icon;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.notification.icon = e, (this || _global)._icon = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "tag", {
        get: function () {
          return (this || _global)._tag;
        },
        set: function (e) {
          e && e.length && ((this || _global)._payload.notification.tag = e, (this || _global)._tag = e);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(o.prototype, "silent", {
        set: function (e) {
          (this || _global)._isSilent = e;
        },
        enumerable: !1,
        configurable: !0
      }), o.prototype._setDefaultPayloadStructure = function () {
        (this || _global)._payload.notification = {}, (this || _global)._payload.data = {};
      }, o.prototype.toObject = function () {
        var e = n({}, (this || _global)._payload.data),
          t = null,
          o = {};
        if (Object.keys((this || _global)._payload).length > 2) {
          var i = (this || _global)._payload;
          i.notification, i.data;
          var a = r(i, ["notification", "data"]);
          e = n(n({}, e), a);
        }
        return (this || _global)._isSilent ? e.notification = (this || _global)._payload.notification : t = (this || _global)._payload.notification, Object.keys(e).length && (o.data = e), t && Object.keys(t).length && (o.notification = t), Object.keys(o).length ? o : null;
      }, o;
    }(D),
    K = function () {
      function e(e, t) {
        (this || _global)._payload = {
          apns: {},
          mpns: {},
          fcm: {}
        }, (this || _global)._title = e, (this || _global)._body = t, (this || _global).apns = new F((this || _global)._payload.apns, e, t), (this || _global).mpns = new G((this || _global)._payload.mpns, e, t), (this || _global).fcm = new L((this || _global)._payload.fcm, e, t);
      }
      return Object.defineProperty(e.prototype, "debugging", {
        set: function (e) {
          (this || _global)._debugging = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "title", {
        get: function () {
          return (this || _global)._title;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "body", {
        get: function () {
          return (this || _global)._body;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "subtitle", {
        get: function () {
          return (this || _global)._subtitle;
        },
        set: function (e) {
          (this || _global)._subtitle = e, (this || _global).apns.subtitle = e, (this || _global).mpns.subtitle = e, (this || _global).fcm.subtitle = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "badge", {
        get: function () {
          return (this || _global)._badge;
        },
        set: function (e) {
          (this || _global)._badge = e, (this || _global).apns.badge = e, (this || _global).mpns.badge = e, (this || _global).fcm.badge = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sound", {
        get: function () {
          return (this || _global)._sound;
        },
        set: function (e) {
          (this || _global)._sound = e, (this || _global).apns.sound = e, (this || _global).mpns.sound = e, (this || _global).fcm.sound = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.buildPayload = function (e) {
        var t = {};
        if (e.includes("apns") || e.includes("apns2")) {
          (this || _global).apns._apnsPushType = e.includes("apns") ? "apns" : "apns2";
          var n = (this || _global).apns.toObject();
          n && Object.keys(n).length && (t.pn_apns = n);
        }
        if (e.includes("mpns")) {
          var r = (this || _global).mpns.toObject();
          r && Object.keys(r).length && (t.pn_mpns = r);
        }
        if (e.includes("fcm")) {
          var o = (this || _global).fcm.toObject();
          o && Object.keys(o).length && (t.pn_gcm = o);
        }
        return Object.keys(t).length && (this || _global)._debugging && (t.pn_debug = !0), t;
      }, e;
    }(),
    B = function () {
      function e() {
        (this || _global)._listeners = [];
      }
      return e.prototype.addListener = function (e) {
        (this || _global)._listeners.push(e);
      }, e.prototype.removeListener = function (e) {
        var t = [];
        (this || _global)._listeners.forEach(function (n) {
          n !== e && t.push(n);
        }), (this || _global)._listeners = t;
      }, e.prototype.removeAllListeners = function () {
        (this || _global)._listeners = [];
      }, e.prototype.announcePresence = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.presence && t.presence(e);
        });
      }, e.prototype.announceStatus = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.status && t.status(e);
        });
      }, e.prototype.announceMessage = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.message && t.message(e);
        });
      }, e.prototype.announceSignal = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.signal && t.signal(e);
        });
      }, e.prototype.announceMessageAction = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.messageAction && t.messageAction(e);
        });
      }, e.prototype.announceFile = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.file && t.file(e);
        });
      }, e.prototype.announceObjects = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.objects && t.objects(e);
        });
      }, e.prototype.announceUser = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.user && t.user(e);
        });
      }, e.prototype.announceSpace = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.space && t.space(e);
        });
      }, e.prototype.announceMembership = function (e) {
        (this || _global)._listeners.forEach(function (t) {
          t.membership && t.membership(e);
        });
      }, e.prototype.announceNetworkUp = function () {
        var e = {};
        e.category = R.PNNetworkUpCategory, this.announceStatus(e);
      }, e.prototype.announceNetworkDown = function () {
        var e = {};
        e.category = R.PNNetworkDownCategory, this.announceStatus(e);
      }, e;
    }(),
    H = function () {
      function e(e, t) {
        (this || _global)._config = e, (this || _global)._cbor = t;
      }
      return e.prototype.setToken = function (e) {
        e && e.length > 0 ? (this || _global)._token = e : (this || _global)._token = void 0;
      }, e.prototype.getToken = function () {
        return (this || _global)._token;
      }, e.prototype.extractPermissions = function (e) {
        var t = {
          read: !1,
          write: !1,
          manage: !1,
          delete: !1,
          get: !1,
          update: !1,
          join: !1
        };
        return 128 == (128 & e) && (t.join = !0), 64 == (64 & e) && (t.update = !0), 32 == (32 & e) && (t.get = !0), 8 == (8 & e) && (t.delete = !0), 4 == (4 & e) && (t.manage = !0), 2 == (2 & e) && (t.write = !0), 1 == (1 & e) && (t.read = !0), t;
      }, e.prototype.parseToken = function (e) {
        var t = this || _global,
          n = (this || _global)._cbor.decodeToken(e);
        if (void 0 !== n) {
          var r = n.res.uuid ? Object.keys(n.res.uuid) : [],
            o = Object.keys(n.res.chan),
            i = Object.keys(n.res.grp),
            a = n.pat.uuid ? Object.keys(n.pat.uuid) : [],
            s = Object.keys(n.pat.chan),
            u = Object.keys(n.pat.grp),
            c = {
              version: n.v,
              timestamp: n.t,
              ttl: n.ttl,
              authorized_uuid: n.uuid
            },
            l = r.length > 0,
            p = o.length > 0,
            f = i.length > 0;
          (l || p || f) && (c.resources = {}, l && (c.resources.uuids = {}, r.forEach(function (e) {
            c.resources.uuids[e] = t.extractPermissions(n.res.uuid[e]);
          })), p && (c.resources.channels = {}, o.forEach(function (e) {
            c.resources.channels[e] = t.extractPermissions(n.res.chan[e]);
          })), f && (c.resources.groups = {}, i.forEach(function (e) {
            c.resources.groups[e] = t.extractPermissions(n.res.grp[e]);
          })));
          var h = a.length > 0,
            d = s.length > 0,
            y = u.length > 0;
          return (h || d || y) && (c.patterns = {}, h && (c.patterns.uuids = {}, a.forEach(function (e) {
            c.patterns.uuids[e] = t.extractPermissions(n.pat.uuid[e]);
          })), d && (c.patterns.channels = {}, s.forEach(function (e) {
            c.patterns.channels[e] = t.extractPermissions(n.pat.chan[e]);
          })), y && (c.patterns.groups = {}, u.forEach(function (e) {
            c.patterns.groups[e] = t.extractPermissions(n.pat.grp[e]);
          }))), Object.keys(n.meta).length > 0 && (c.meta = n.meta), c.signature = n.sig, c;
        }
      }, e;
    }(),
    q = function (e) {
      function n(t, n) {
        var r = (this || _global).constructor,
          o = e.call(this || _global, t) || this || _global;
        return o.name = o.constructor.name, o.status = n, o.message = t, Object.setPrototypeOf(o, r.prototype), o;
      }
      return t(n, e), n;
    }(Error);
  function z(e) {
    return (t = {
      message: e
    }).type = "validationError", t.error = !0, t;
    var t;
  }
  function V(e, t, n) {
    return e.usePost && e.usePost(t, n) ? e.postURL(t, n) : e.usePatch && e.usePatch(t, n) ? e.patchURL(t, n) : e.useGetFile && e.useGetFile(t, n) ? e.getFileURL(t, n) : e.getURL(t, n);
  }
  function W(e) {
    if (e.sdkName) return e.sdkName;
    var t = "PubNub-JS-".concat(e.sdkFamily);
    e.partnerId && (t += "-".concat(e.partnerId)), t += "/".concat(e.getVersion());
    var n = e._getPnsdkSuffix(" ");
    return n.length > 0 && (t += n), t;
  }
  function J(e, t, n) {
    return t.usePost && t.usePost(e, n) ? "POST" : t.usePatch && t.usePatch(e, n) ? "PATCH" : t.useDelete && t.useDelete(e, n) ? "DELETE" : t.useGetFile && t.useGetFile(e, n) ? "GETFILE" : "GET";
  }
  function $(e, t, n, r, o) {
    var i = e.config,
      a = e.crypto,
      s = J(e, o, r);
    n.timestamp = Math.floor(new Date().getTime() / 1000), "PNPublishOperation" === o.getOperation() && o.usePost && o.usePost(e, r) && (s = "GET"), "GETFILE" === s && (s = "GET");
    var u = "".concat(s, "\n").concat(i.publishKey, "\n").concat(t, "\n").concat(M.signPamFromParams(n), "\n");
    if ("POST" === s) u += "string" == typeof (c = o.postPayload(e, r)) ? c : JSON.stringify(c);else if ("PATCH" === s) {
      var c;
      u += "string" == typeof (c = o.patchPayload(e, r)) ? c : JSON.stringify(c);
    }
    var l = "v2.".concat(a.HMACSHA256(u));
    l = (l = (l = l.replace(/\+/g, "-")).replace(/\//g, "_")).replace(/=+$/, ""), n.signature = l;
  }
  function Q(e, t) {
    for (var r = [], o = 2; o < arguments.length; o++) r[o - 2] = arguments[o];
    var i = e.networking,
      a = e.config,
      s = e.telemetryManager,
      u = e.tokenManager,
      c = y(),
      l = null,
      p = null,
      f = {};
    t.getOperation() === I.PNTimeOperation || t.getOperation() === I.PNChannelGroupsOperation ? l = r[0] : (f = r[0], l = r[1]), "undefined" == typeof Promise || l || (p = M.createPromise());
    var h = t.validateParams(e, f);
    if (h) return l ? l(z(h)) : p ? (p.reject(new q("Validation failed, check status for details", z(h))), p.promise) : void 0;
    var d,
      g = t.prepareParams(e, f),
      b = V(t, e, f),
      v = {
        url: b,
        operation: t.getOperation(),
        timeout: t.getRequestTimeout(e),
        headers: t.getRequestHeaders ? t.getRequestHeaders() : {},
        ignoreBody: "function" == typeof t.ignoreBody && t.ignoreBody(e),
        forceBuffered: "function" == typeof t.forceBuffered ? t.forceBuffered(e, f) : null,
        abortSignal: "function" == typeof t.getAbortSignal ? t.getAbortSignal(e, f) : null
      };
    g.uuid = a.UUID, g.pnsdk = W(a);
    var m = s.operationsLatencyForRequest();
    if (Object.keys(m).length && (g = n(n({}, g), m)), a.useInstanceId && (g.instanceid = a.instanceId), a.useRequestId && (g.requestid = c), t.isAuthSupported()) {
      var _ = u.getToken() || a.getAuthKey();
      _ && (g.auth = _);
    }
    a.secretKey && $(e, b, g, f, t);
    var O = function (n, r) {
      if (n.error) return t.handleError && t.handleError(e, f, n), void (l ? l(n) : p && p.reject(new q("PubNub call failed, check status for details", n)));
      s.stopLatencyMeasure(t.getOperation(), c);
      var o = t.handleResponse(e, r, f);
      "function" != typeof (null == o ? void 0 : o.then) && (o = Promise.resolve(o)), o.then(function (e) {
        l ? l(n, e) : p && p.fulfill(e);
      }).catch(function (e) {
        if (l) {
          var n = e;
          t.getOperation() === I.PNSubscribeOperation && (n = {
            statusCode: 400,
            error: !0,
            operation: t.getOperation(),
            errorData: e,
            category: R.PNUnknownCategory
          }), l(n, null);
        } else p && p.reject(new q("PubNub call failed, check status for details", e));
      });
    };
    if (s.startLatencyMeasure(t.getOperation(), c), "POST" === J(e, t, f)) {
      var S = t.postPayload(e, f);
      d = i.POST(g, S, v, O);
    } else if ("PATCH" === J(e, t, f)) {
      S = t.patchPayload(e, f);
      d = i.PATCH(g, S, v, O);
    } else d = "DELETE" === J(e, t, f) ? i.DELETE(g, v, O) : "GETFILE" === J(e, t, f) ? i.GETFILE(g, v, O) : i.GET(g, v, O);
    return t.getOperation() === I.PNSubscribeOperation ? d : p ? p.promise : void 0;
  }
  var X = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNAddChannelsToGroupOperation;
    },
    validateParams: function (e, t) {
      var n = t.channels,
        r = t.channelGroup,
        o = e.config;
      return r ? n && 0 !== n.length ? o.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Channels" : "Missing Channel Group";
    },
    getURL: function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(M.encodeString(n));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.channels;
      return {
        add: (void 0 === n ? [] : n).join(",")
      };
    },
    handleResponse: function () {
      return {};
    }
  });
  var Y = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNRemoveChannelsFromGroupOperation;
    },
    validateParams: function (e, t) {
      var n = t.channels,
        r = t.channelGroup,
        o = e.config;
      return r ? n && 0 !== n.length ? o.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Channels" : "Missing Channel Group";
    },
    getURL: function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(M.encodeString(n));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.channels;
      return {
        remove: (void 0 === n ? [] : n).join(",")
      };
    },
    handleResponse: function () {
      return {};
    }
  });
  var Z = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNRemoveGroupOperation;
    },
    validateParams: function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return n ? r.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Channel Group";
    },
    getURL: function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(M.encodeString(n), "/remove");
    },
    isAuthSupported: function () {
      return !0;
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    prepareParams: function () {
      return {};
    },
    handleResponse: function () {
      return {};
    }
  });
  var ee = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNChannelGroupsOperation;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e) {
      var t = e.config;
      return "/v1/channel-registration/sub-key/".concat(t.subscribeKey, "/channel-group");
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function () {
      return {};
    },
    handleResponse: function (e, t) {
      return {
        groups: t.payload.groups
      };
    }
  });
  var te = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNChannelsForGroupOperation;
    },
    validateParams: function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return n ? r.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Channel Group";
    },
    getURL: function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(M.encodeString(n));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function () {
      return {};
    },
    handleResponse: function (e, t) {
      return {
        channels: t.payload.channels
      };
    }
  });
  var ne = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNPushNotificationEnabledChannelsOperation;
    },
    validateParams: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = t.channels,
        i = t.topic,
        a = e.config;
      return n ? r ? "apns2" !== r || i ? o && 0 !== o.length ? a.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Channels" : "Missing APNS2 topic" : "Missing GW Type (pushGateway: gcm, apns or apns2)" : "Missing Device ID (device)";
    },
    getURL: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = e.config;
      return "apns2" === r ? "/v2/push/sub-key/".concat(o.subscribeKey, "/devices-apns2/").concat(n) : "/v1/push/sub-key/".concat(o.subscribeKey, "/devices/").concat(n);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var r = t.pushGateway,
        o = t.channels,
        i = void 0 === o ? [] : o,
        a = t.environment,
        s = void 0 === a ? "development" : a,
        u = t.topic,
        c = {
          type: r,
          add: i.join(",")
        };
      return "apns2" === r && delete (c = n(n({}, c), {
        environment: s,
        topic: u
      })).type, c;
    },
    handleResponse: function () {
      return {};
    }
  });
  var re = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNPushNotificationEnabledChannelsOperation;
    },
    validateParams: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = t.channels,
        i = t.topic,
        a = e.config;
      return n ? r ? "apns2" !== r || i ? o && 0 !== o.length ? a.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Channels" : "Missing APNS2 topic" : "Missing GW Type (pushGateway: gcm, apns or apns2)" : "Missing Device ID (device)";
    },
    getURL: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = e.config;
      return "apns2" === r ? "/v2/push/sub-key/".concat(o.subscribeKey, "/devices-apns2/").concat(n) : "/v1/push/sub-key/".concat(o.subscribeKey, "/devices/").concat(n);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var r = t.pushGateway,
        o = t.channels,
        i = void 0 === o ? [] : o,
        a = t.environment,
        s = void 0 === a ? "development" : a,
        u = t.topic,
        c = {
          type: r,
          remove: i.join(",")
        };
      return "apns2" === r && delete (c = n(n({}, c), {
        environment: s,
        topic: u
      })).type, c;
    },
    handleResponse: function () {
      return {};
    }
  });
  var oe = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNPushNotificationEnabledChannelsOperation;
    },
    validateParams: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = t.topic,
        i = e.config;
      return n ? r ? "apns2" !== r || o ? i.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing APNS2 topic" : "Missing GW Type (pushGateway: gcm, apns or apns2)" : "Missing Device ID (device)";
    },
    getURL: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = e.config;
      return "apns2" === r ? "/v2/push/sub-key/".concat(o.subscribeKey, "/devices-apns2/").concat(n) : "/v1/push/sub-key/".concat(o.subscribeKey, "/devices/").concat(n);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var r = t.pushGateway,
        o = t.environment,
        i = void 0 === o ? "development" : o,
        a = t.topic,
        s = {
          type: r
        };
      return "apns2" === r && delete (s = n(n({}, s), {
        environment: i,
        topic: a
      })).type, s;
    },
    handleResponse: function (e, t) {
      return {
        channels: t
      };
    }
  });
  var ie = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNRemoveAllPushNotificationsOperation;
    },
    validateParams: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = t.topic,
        i = e.config;
      return n ? r ? "apns2" !== r || o ? i.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing APNS2 topic" : "Missing GW Type (pushGateway: gcm, apns or apns2)" : "Missing Device ID (device)";
    },
    getURL: function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        o = e.config;
      return "apns2" === r ? "/v2/push/sub-key/".concat(o.subscribeKey, "/devices-apns2/").concat(n, "/remove") : "/v1/push/sub-key/".concat(o.subscribeKey, "/devices/").concat(n, "/remove");
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var r = t.pushGateway,
        o = t.environment,
        i = void 0 === o ? "development" : o,
        a = t.topic,
        s = {
          type: r
        };
      return "apns2" === r && delete (s = n(n({}, s), {
        environment: i,
        topic: a
      })).type, s;
    },
    handleResponse: function () {
      return {};
    }
  });
  var ae = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNUnsubscribeOperation;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.channels,
        o = void 0 === r ? [] : r,
        i = o.length > 0 ? o.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(i), "/leave");
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        o = {};
      return r.length > 0 && (o["channel-group"] = r.join(",")), o;
    },
    handleResponse: function () {
      return {};
    }
  });
  var se = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNWhereNowOperation;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.uuid,
        o = void 0 === r ? n.UUID : r;
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/uuid/").concat(M.encodeString(o));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function () {
      return {};
    },
    handleResponse: function (e, t) {
      return t.payload ? {
        channels: t.payload.channels
      } : {
        channels: []
      };
    }
  });
  var ue = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNHeartbeatOperation;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.channels,
        o = void 0 === r ? [] : r,
        i = o.length > 0 ? o.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(i), "/heartbeat");
    },
    isAuthSupported: function () {
      return !0;
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    prepareParams: function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        o = t.state,
        i = void 0 === o ? {} : o,
        a = e.config,
        s = {};
      return r.length > 0 && (s["channel-group"] = r.join(",")), s.state = JSON.stringify(i), s.heartbeat = a.getPresenceTimeout(), s;
    },
    handleResponse: function () {
      return {};
    }
  });
  var ce = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNGetStateOperation;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.uuid,
        o = void 0 === r ? n.UUID : r,
        i = t.channels,
        a = void 0 === i ? [] : i,
        s = a.length > 0 ? a.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(s), "/uuid/").concat(o);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        o = {};
      return r.length > 0 && (o["channel-group"] = r.join(",")), o;
    },
    handleResponse: function (e, t, n) {
      var r = n.channels,
        o = void 0 === r ? [] : r,
        i = n.channelGroups,
        a = void 0 === i ? [] : i,
        s = {};
      return 1 === o.length && 0 === a.length ? s[o[0]] = t.payload : s = t.payload, {
        channels: s
      };
    }
  });
  var le = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNSetStateOperation;
    },
    validateParams: function (e, t) {
      var n = e.config,
        r = t.state,
        o = t.channels,
        i = void 0 === o ? [] : o,
        a = t.channelGroups,
        s = void 0 === a ? [] : a;
      return r ? n.subscribeKey ? 0 === i.length && 0 === s.length ? "Please provide a list of channels and/or channel-groups" : void 0 : "Missing Subscribe Key" : "Missing State";
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.channels,
        o = void 0 === r ? [] : r,
        i = o.length > 0 ? o.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(i), "/uuid/").concat(M.encodeString(n.UUID), "/data");
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.state,
        r = t.channelGroups,
        o = void 0 === r ? [] : r,
        i = {};
      return i.state = JSON.stringify(n), o.length > 0 && (i["channel-group"] = o.join(",")), i;
    },
    handleResponse: function (e, t) {
      return {
        state: t.payload
      };
    }
  });
  var pe = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNHereNowOperation;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.channels,
        o = void 0 === r ? [] : r,
        i = t.channelGroups,
        a = void 0 === i ? [] : i,
        s = "/v2/presence/sub-key/".concat(n.subscribeKey);
      if (o.length > 0 || a.length > 0) {
        var u = o.length > 0 ? o.join(",") : ",";
        s += "/channel/".concat(M.encodeString(u));
      }
      return s;
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var r = t.channelGroups,
        o = void 0 === r ? [] : r,
        i = t.includeUUIDs,
        a = void 0 === i || i,
        s = t.includeState,
        u = void 0 !== s && s,
        c = t.queryParameters,
        l = void 0 === c ? {} : c,
        p = {};
      return a || (p.disable_uuids = 1), u && (p.state = 1), o.length > 0 && (p["channel-group"] = o.join(",")), p = n(n({}, p), l);
    },
    handleResponse: function (e, t, n) {
      var r = n.channels,
        o = void 0 === r ? [] : r,
        i = n.channelGroups,
        a = void 0 === i ? [] : i,
        s = n.includeUUIDs,
        u = void 0 === s || s,
        c = n.includeState,
        l = void 0 !== c && c;
      return o.length > 1 || a.length > 0 || 0 === a.length && 0 === o.length ? function () {
        var e = {};
        return e.totalChannels = t.payload.total_channels, e.totalOccupancy = t.payload.total_occupancy, e.channels = {}, Object.keys(t.payload.channels).forEach(function (n) {
          var r = t.payload.channels[n],
            o = [];
          return e.channels[n] = {
            occupants: o,
            name: n,
            occupancy: r.occupancy
          }, u && r.uuids.forEach(function (e) {
            l ? o.push({
              state: e.state,
              uuid: e.uuid
            }) : o.push({
              state: null,
              uuid: e
            });
          }), e;
        }), e;
      }() : function () {
        var e = {},
          n = [];
        return e.totalChannels = 1, e.totalOccupancy = t.occupancy, e.channels = {}, e.channels[o[0]] = {
          occupants: n,
          name: o[0],
          occupancy: t.occupancy
        }, u && t.uuids && t.uuids.forEach(function (e) {
          l ? n.push({
            state: e.state,
            uuid: e.uuid
          }) : n.push({
            state: null,
            uuid: e
          });
        }), e;
      }();
    },
    handleError: function (e, t, n) {
      402 !== n.statusCode || this.getURL(e, t).includes("channel") || (n.errorData.message = "You have tried to perform a Global Here Now operation, your keyset configuration does not support that. Please provide a channel, or enable the Global Here Now feature from the Portal.");
    }
  });
  var fe = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNAddMessageActionOperation;
    },
    validateParams: function (e, t) {
      var n = e.config,
        r = t.action,
        o = t.channel;
      return t.messageTimetoken ? n.subscribeKey ? o ? r ? r.value ? r.type ? r.type.length > 15 ? "Action.type value exceed maximum length of 15" : void 0 : "Missing Action.type" : "Missing Action.value" : "Missing Action" : "Missing message channel" : "Missing Subscribe Key" : "Missing message timetoken";
    },
    usePost: function () {
      return !0;
    },
    postURL: function (e, t) {
      var n = e.config,
        r = t.channel,
        o = t.messageTimetoken;
      return "/v1/message-actions/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(r), "/message/").concat(o);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    getRequestHeaders: function () {
      return {
        "Content-Type": "application/json"
      };
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function () {
      return {};
    },
    postPayload: function (e, t) {
      return t.action;
    },
    handleResponse: function (e, t) {
      return {
        data: t.data
      };
    }
  });
  var he = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNRemoveMessageActionOperation;
    },
    validateParams: function (e, t) {
      var n = e.config,
        r = t.channel,
        o = t.actionTimetoken;
      return t.messageTimetoken ? o ? n.subscribeKey ? r ? void 0 : "Missing message channel" : "Missing Subscribe Key" : "Missing action timetoken" : "Missing message timetoken";
    },
    useDelete: function () {
      return !0;
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.channel,
        o = t.actionTimetoken,
        i = t.messageTimetoken;
      return "/v1/message-actions/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(r), "/message/").concat(i, "/action/").concat(o);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function () {
      return {};
    },
    handleResponse: function (e, t) {
      return {
        data: t.data
      };
    }
  });
  var de = Object.freeze({
      __proto__: null,
      getOperation: function () {
        return I.PNGetMessageActionsOperation;
      },
      validateParams: function (e, t) {
        var n = e.config,
          r = t.channel;
        return n.subscribeKey ? r ? void 0 : "Missing message channel" : "Missing Subscribe Key";
      },
      getURL: function (e, t) {
        var n = e.config,
          r = t.channel;
        return "/v1/message-actions/".concat(n.subscribeKey, "/channel/").concat(M.encodeString(r));
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n = t.limit,
          r = t.start,
          o = t.end,
          i = {};
        return n && (i.limit = n), r && (i.start = r), o && (i.end = o), i;
      },
      handleResponse: function (e, t) {
        var n = {
          data: t.data,
          start: null,
          end: null
        };
        return n.data.length && (n.end = n.data[n.data.length - 1].actionTimetoken, n.start = n.data[0].actionTimetoken), n;
      }
    }),
    ye = {
      getOperation: function () {
        return I.PNListFilesOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.channel)) return "channel can't be empty";
      },
      getURL: function (e, t) {
        var n = e.config;
        return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel), "/files");
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n = {};
        return t.limit && (n.limit = t.limit), t.next && (n.next = t.next), n;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          next: t.next,
          count: t.count
        };
      }
    },
    ge = {
      getOperation: function () {
        return I.PNGenerateUploadUrlOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channel) ? (null == t ? void 0 : t.name) ? void 0 : "name can't be empty" : "channel can't be empty";
      },
      usePost: function () {
        return !0;
      },
      postURL: function (e, t) {
        var n = e.config;
        return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel), "/generate-upload-url");
      },
      postPayload: function (e, t) {
        return {
          name: t.name
        };
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function () {
        return {};
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          file_upload_request: t.file_upload_request
        };
      }
    },
    be = {
      getOperation: function () {
        return I.PNPublishFileOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channel) ? (null == t ? void 0 : t.fileId) ? (null == t ? void 0 : t.fileName) ? void 0 : "file name can't be empty" : "file id can't be empty" : "channel can't be empty";
      },
      getURL: function (e, t) {
        var n = e.config,
          r = n.publishKey,
          o = n.subscribeKey,
          i = function (e, t) {
            var n = JSON.stringify(t);
            if (e.cryptoModule) {
              var r = e.cryptoModule.encrypt(n);
              n = "string" == typeof r ? r : v(r), n = JSON.stringify(n);
            }
            return n || "";
          }(e, {
            message: t.message,
            file: {
              name: t.fileName,
              id: t.fileId
            }
          });
        return "/v1/files/publish-file/".concat(r, "/").concat(o, "/0/").concat(M.encodeString(t.channel), "/0/").concat(M.encodeString(i));
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n = {};
        return t.ttl && (n.ttl = t.ttl), void 0 !== t.storeInHistory && (n.store = t.storeInHistory ? "1" : "0"), t.meta && "object" == typeof t.meta && (n.meta = JSON.stringify(t.meta)), n;
      },
      handleResponse: function (e, t) {
        return {
          timetoken: t[2]
        };
      }
    },
    ve = function (e) {
      var t = function (e) {
        var t = this || _global,
          n = e.generateUploadUrl,
          r = e.publishFile,
          a = e.modules,
          s = a.PubNubFile,
          u = a.config,
          c = a.cryptography,
          l = a.cryptoModule,
          p = a.networking;
        return function (e) {
          var a = e.channel,
            f = e.file,
            h = e.message,
            d = e.cipherKey,
            y = e.meta,
            g = e.ttl,
            b = e.storeInHistory;
          return o(t, void 0, void 0, function () {
            var e, t, o, v, m, _, O, S, P, w, E, T, A, N, k, C, j, M, R, U, I, x, D, F, G, L, K, B, H;
            return i(this || _global, function (i) {
              switch (i.label) {
                case 0:
                  if (!a) throw new q("Validation failed, check status for details", z("channel can't be empty"));
                  if (!f) throw new q("Validation failed, check status for details", z("file can't be empty"));
                  return e = s.create(f), [4, n({
                    channel: a,
                    name: e.name
                  })];
                case 1:
                  return t = i.sent(), o = t.file_upload_request, v = o.url, m = o.form_fields, _ = t.data, O = _.id, S = _.name, s.supportsEncryptFile && (d || l) ? null != d ? [3, 3] : [4, l.encryptFile(e, s)] : [3, 6];
                case 2:
                  return P = i.sent(), [3, 5];
                case 3:
                  return [4, c.encryptFile(d, e, s)];
                case 4:
                  P = i.sent(), i.label = 5;
                case 5:
                  e = P, i.label = 6;
                case 6:
                  w = m, e.mimeType && (w = m.map(function (t) {
                    return "Content-Type" === t.key ? {
                      key: t.key,
                      value: e.mimeType
                    } : t;
                  })), i.label = 7;
                case 7:
                  return i.trys.push([7, 21,, 22]), s.supportsFileUri && f.uri ? (A = (T = p).POSTFILE, N = [v, w], [4, e.toFileUri()]) : [3, 10];
                case 8:
                  return [4, A.apply(T, N.concat([i.sent()]))];
                case 9:
                  return E = i.sent(), [3, 20];
                case 10:
                  return s.supportsFile ? (C = (k = p).POSTFILE, j = [v, w], [4, e.toFile()]) : [3, 13];
                case 11:
                  return [4, C.apply(k, j.concat([i.sent()]))];
                case 12:
                  return E = i.sent(), [3, 20];
                case 13:
                  return s.supportsBuffer ? (R = (M = p).POSTFILE, U = [v, w], [4, e.toBuffer()]) : [3, 16];
                case 14:
                  return [4, R.apply(M, U.concat([i.sent()]))];
                case 15:
                  return E = i.sent(), [3, 20];
                case 16:
                  return s.supportsBlob ? (x = (I = p).POSTFILE, D = [v, w], [4, e.toBlob()]) : [3, 19];
                case 17:
                  return [4, x.apply(I, D.concat([i.sent()]))];
                case 18:
                  return E = i.sent(), [3, 20];
                case 19:
                  throw new Error("Unsupported environment");
                case 20:
                  return [3, 22];
                case 21:
                  throw (F = i.sent()).response && "string" == typeof F.response.text ? (G = F.response.text, L = /<Message>(.*)<\/Message>/gi.exec(G), new q(L ? "Upload to bucket failed: ".concat(L[1]) : "Upload to bucket failed.", F)) : new q("Upload to bucket failed.", F);
                case 22:
                  if (204 !== E.status) throw new q("Upload to bucket was unsuccessful", E);
                  K = u.fileUploadPublishRetryLimit, B = !1, H = {
                    timetoken: "0"
                  }, i.label = 23;
                case 23:
                  return i.trys.push([23, 25,, 26]), [4, r({
                    channel: a,
                    message: h,
                    fileId: O,
                    fileName: S,
                    meta: y,
                    storeInHistory: b,
                    ttl: g
                  })];
                case 24:
                  return H = i.sent(), B = !0, [3, 26];
                case 25:
                  return i.sent(), K -= 1, [3, 26];
                case 26:
                  if (!B && K > 0) return [3, 23];
                  i.label = 27;
                case 27:
                  if (B) return [2, {
                    timetoken: H.timetoken,
                    id: O,
                    name: S
                  }];
                  throw new q("Publish failed. You may want to execute that operation manually using pubnub.publishFile", {
                    channel: a,
                    id: O,
                    name: S
                  });
              }
            });
          });
        };
      }(e);
      return function (e, n) {
        var r = t(e);
        return "function" == typeof n ? (r.then(function (e) {
          return n(null, e);
        }).catch(function (e) {
          return n(e, null);
        }), r) : r;
      };
    },
    me = function (e, t) {
      var n = t.channel,
        r = t.id,
        o = t.name,
        i = e.config,
        a = e.networking,
        s = e.tokenManager;
      if (!n) throw new q("Validation failed, check status for details", z("channel can't be empty"));
      if (!r) throw new q("Validation failed, check status for details", z("file id can't be empty"));
      if (!o) throw new q("Validation failed, check status for details", z("file name can't be empty"));
      var u = "/v1/files/".concat(i.subscribeKey, "/channels/").concat(M.encodeString(n), "/files/").concat(r, "/").concat(o),
        c = {};
      c.uuid = i.getUUID(), c.pnsdk = W(i);
      var l = s.getToken() || i.getAuthKey();
      l && (c.auth = l), i.secretKey && $(e, u, c, {}, {
        getOperation: function () {
          return "PubNubGetFileUrlOperation";
        }
      });
      var p = Object.keys(c).map(function (e) {
        return "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(c[e]));
      }).join("&");
      return "" !== p ? "".concat(a.getStandardOrigin()).concat(u, "?").concat(p) : "".concat(a.getStandardOrigin()).concat(u);
    },
    _e = {
      getOperation: function () {
        return I.PNDownloadFileOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channel) ? (null == t ? void 0 : t.name) ? (null == t ? void 0 : t.id) ? void 0 : "id can't be empty" : "name can't be empty" : "channel can't be empty";
      },
      useGetFile: function () {
        return !0;
      },
      getFileURL: function (e, t) {
        var n = e.config;
        return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel), "/files/").concat(t.id, "/").concat(t.name);
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      ignoreBody: function () {
        return !0;
      },
      forceBuffered: function () {
        return !0;
      },
      prepareParams: function () {
        return {};
      },
      handleResponse: function (e, t, n) {
        var r = e.PubNubFile,
          a = e.config,
          s = e.cryptography,
          u = e.cryptoModule;
        return o(void 0, void 0, void 0, function () {
          var e, o, c, l;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return e = t.response.body, r.supportsEncryptFile && (n.cipherKey || u) ? null != n.cipherKey ? [3, 2] : [4, u.decryptFile(r.create({
                  data: e,
                  name: n.name
                }), r)] : [3, 5];
              case 1:
                return o = i.sent().data, [3, 4];
              case 2:
                return [4, s.decrypt(null !== (c = n.cipherKey) && void 0 !== c ? c : a.cipherKey, e)];
              case 3:
                o = i.sent(), i.label = 4;
              case 4:
                e = o, i.label = 5;
              case 5:
                return [2, r.create({
                  data: e,
                  name: null !== (l = t.response.name) && void 0 !== l ? l : n.name,
                  mimeType: t.response.type
                })];
            }
          });
        });
      }
    },
    Oe = {
      getOperation: function () {
        return I.PNListFilesOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channel) ? (null == t ? void 0 : t.id) ? (null == t ? void 0 : t.name) ? void 0 : "file name can't be empty" : "file id can't be empty" : "channel can't be empty";
      },
      useDelete: function () {
        return !0;
      },
      getURL: function (e, t) {
        var n = e.config;
        return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel), "/files/").concat(t.id, "/").concat(t.name);
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function () {
        return {};
      },
      handleResponse: function (e, t) {
        return {
          status: t.status
        };
      }
    },
    Se = {
      getOperation: function () {
        return I.PNGetAllUUIDMetadataOperation;
      },
      validateParams: function () {},
      getURL: function (e) {
        var t = e.config;
        return "/v2/objects/".concat(t.subscribeKey, "/uuids");
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          u,
          c,
          l,
          p,
          f = {
            include: ["status", "type"]
          };
        return (null == t ? void 0 : t.include) && (null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && f.include.push("custom"), f.include = f.include.join(","), (null === (r = null == t ? void 0 : t.include) || void 0 === r ? void 0 : r.totalCount) && (f.count = null === (o = t.include) || void 0 === o ? void 0 : o.totalCount), (null === (i = null == t ? void 0 : t.page) || void 0 === i ? void 0 : i.next) && (f.start = null === (a = t.page) || void 0 === a ? void 0 : a.next), (null === (u = null == t ? void 0 : t.page) || void 0 === u ? void 0 : u.prev) && (f.end = null === (c = t.page) || void 0 === c ? void 0 : c.prev), (null == t ? void 0 : t.filter) && (f.filter = t.filter), f.limit = null !== (l = null == t ? void 0 : t.limit) && void 0 !== l ? l : 100, (null == t ? void 0 : t.sort) && (f.sort = Object.entries(null !== (p = t.sort) && void 0 !== p ? p : {}).map(function (e) {
          var t = s(e, 2),
            n = t[0],
            r = t[1];
          return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
        })), f;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          totalCount: t.totalCount,
          next: t.next,
          prev: t.prev
        };
      }
    },
    Pe = {
      getOperation: function () {
        return I.PNGetUUIDMetadataOperation;
      },
      validateParams: function () {},
      getURL: function (e, t) {
        var n,
          r = e.config;
        return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(M.encodeString(null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()));
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o = e.config,
          i = {};
        return i.uuid = null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : o.getUUID(), i.include = ["status", "type", "custom"], (null == t ? void 0 : t.include) && !1 === (null === (r = t.include) || void 0 === r ? void 0 : r.customFields) && i.include.pop(), i.include = i.include.join(","), i;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    },
    we = {
      getOperation: function () {
        return I.PNSetUUIDMetadataOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.data)) return "Data cannot be empty";
      },
      usePatch: function () {
        return !0;
      },
      patchURL: function (e, t) {
        var n,
          r = e.config;
        return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(M.encodeString(null !== (n = t.uuid) && void 0 !== n ? n : r.getUUID()));
      },
      patchPayload: function (e, t) {
        return t.data;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o = e.config,
          i = {};
        return i.uuid = null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : o.getUUID(), i.include = ["status", "type", "custom"], (null == t ? void 0 : t.include) && !1 === (null === (r = t.include) || void 0 === r ? void 0 : r.customFields) && i.include.pop(), i.include = i.include.join(","), i;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    },
    Ee = {
      getOperation: function () {
        return I.PNRemoveUUIDMetadataOperation;
      },
      validateParams: function () {},
      getURL: function (e, t) {
        var n,
          r = e.config;
        return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(M.encodeString(null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()));
      },
      useDelete: function () {
        return !0;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r = e.config;
        return {
          uuid: null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()
        };
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    },
    Te = {
      getOperation: function () {
        return I.PNGetAllChannelMetadataOperation;
      },
      validateParams: function () {},
      getURL: function (e) {
        var t = e.config;
        return "/v2/objects/".concat(t.subscribeKey, "/channels");
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          u,
          c,
          l,
          p,
          f = {
            include: ["status", "type"]
          };
        return (null == t ? void 0 : t.include) && (null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && f.include.push("custom"), f.include = f.include.join(","), (null === (r = null == t ? void 0 : t.include) || void 0 === r ? void 0 : r.totalCount) && (f.count = null === (o = t.include) || void 0 === o ? void 0 : o.totalCount), (null === (i = null == t ? void 0 : t.page) || void 0 === i ? void 0 : i.next) && (f.start = null === (a = t.page) || void 0 === a ? void 0 : a.next), (null === (u = null == t ? void 0 : t.page) || void 0 === u ? void 0 : u.prev) && (f.end = null === (c = t.page) || void 0 === c ? void 0 : c.prev), (null == t ? void 0 : t.filter) && (f.filter = t.filter), f.limit = null !== (l = null == t ? void 0 : t.limit) && void 0 !== l ? l : 100, (null == t ? void 0 : t.sort) && (f.sort = Object.entries(null !== (p = t.sort) && void 0 !== p ? p : {}).map(function (e) {
          var t = s(e, 2),
            n = t[0],
            r = t[1];
          return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
        })), f;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          totalCount: t.totalCount,
          prev: t.prev,
          next: t.next
        };
      }
    },
    Ae = {
      getOperation: function () {
        return I.PNGetChannelMetadataOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.channel)) return "Channel cannot be empty";
      },
      getURL: function (e, t) {
        var n = e.config;
        return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel));
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r = {
            include: ["status", "type", "custom"]
          };
        return (null == t ? void 0 : t.include) && !1 === (null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && r.include.pop(), r.include = r.include.join(","), r;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    },
    Ne = {
      getOperation: function () {
        return I.PNSetChannelMetadataOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channel) ? (null == t ? void 0 : t.data) ? void 0 : "Data cannot be empty" : "Channel cannot be empty";
      },
      usePatch: function () {
        return !0;
      },
      patchURL: function (e, t) {
        var n = e.config;
        return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel));
      },
      patchPayload: function (e, t) {
        return t.data;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r = {
            include: ["status", "type", "custom"]
          };
        return (null == t ? void 0 : t.include) && !1 === (null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && r.include.pop(), r.include = r.include.join(","), r;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    },
    ke = {
      getOperation: function () {
        return I.PNRemoveChannelMetadataOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.channel)) return "Channel cannot be empty";
      },
      getURL: function (e, t) {
        var n = e.config;
        return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel));
      },
      useDelete: function () {
        return !0;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function () {
        return {};
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    },
    Ce = {
      getOperation: function () {
        return I.PNGetMembersOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.channel)) return "UUID cannot be empty";
      },
      getURL: function (e, t) {
        var n = e.config;
        return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel), "/uuids");
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          u,
          c,
          l,
          p,
          f,
          h,
          d,
          y = {
            include: ["uuid.status", "uuid.type", "type"]
          };
        return (null == t ? void 0 : t.include) && ((null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && y.include.push("custom"), (null === (r = t.include) || void 0 === r ? void 0 : r.customUUIDFields) && y.include.push("uuid.custom"), (null === (i = null === (o = t.include) || void 0 === o ? void 0 : o.UUIDFields) || void 0 === i || i) && y.include.push("uuid")), y.include = y.include.join(","), (null === (a = null == t ? void 0 : t.include) || void 0 === a ? void 0 : a.totalCount) && (y.count = null === (u = t.include) || void 0 === u ? void 0 : u.totalCount), (null === (c = null == t ? void 0 : t.page) || void 0 === c ? void 0 : c.next) && (y.start = null === (l = t.page) || void 0 === l ? void 0 : l.next), (null === (p = null == t ? void 0 : t.page) || void 0 === p ? void 0 : p.prev) && (y.end = null === (f = t.page) || void 0 === f ? void 0 : f.prev), (null == t ? void 0 : t.filter) && (y.filter = t.filter), y.limit = null !== (h = null == t ? void 0 : t.limit) && void 0 !== h ? h : 100, (null == t ? void 0 : t.sort) && (y.sort = Object.entries(null !== (d = t.sort) && void 0 !== d ? d : {}).map(function (e) {
          var t = s(e, 2),
            n = t[0],
            r = t[1];
          return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
        })), y;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          totalCount: t.totalCount,
          prev: t.prev,
          next: t.next
        };
      }
    },
    je = {
      getOperation: function () {
        return I.PNSetMembersOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channel) ? (null == t ? void 0 : t.uuids) && 0 !== (null == t ? void 0 : t.uuids.length) ? void 0 : "UUIDs cannot be empty" : "Channel cannot be empty";
      },
      usePatch: function () {
        return !0;
      },
      patchURL: function (e, t) {
        var n = e.config;
        return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(M.encodeString(t.channel), "/uuids");
      },
      patchPayload: function (e, t) {
        var n;
        return (n = {
          set: [],
          delete: []
        })[t.type] = t.uuids.map(function (e) {
          return "string" == typeof e ? {
            uuid: {
              id: e
            }
          } : {
            uuid: {
              id: e.id
            },
            custom: e.custom,
            status: e.status
          };
        }), n;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          u,
          c,
          l,
          p,
          f = {
            include: ["uuid.status", "uuid.type", "type"]
          };
        return (null == t ? void 0 : t.include) && ((null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && f.include.push("custom"), (null === (r = t.include) || void 0 === r ? void 0 : r.customUUIDFields) && f.include.push("uuid.custom"), (null === (o = t.include) || void 0 === o ? void 0 : o.UUIDFields) && f.include.push("uuid")), f.include = f.include.join(","), (null === (i = null == t ? void 0 : t.include) || void 0 === i ? void 0 : i.totalCount) && (f.count = !0), (null === (a = null == t ? void 0 : t.page) || void 0 === a ? void 0 : a.next) && (f.start = null === (u = t.page) || void 0 === u ? void 0 : u.next), (null === (c = null == t ? void 0 : t.page) || void 0 === c ? void 0 : c.prev) && (f.end = null === (l = t.page) || void 0 === l ? void 0 : l.prev), (null == t ? void 0 : t.filter) && (f.filter = t.filter), null != t.limit && (f.limit = t.limit), (null == t ? void 0 : t.sort) && (f.sort = Object.entries(null !== (p = t.sort) && void 0 !== p ? p : {}).map(function (e) {
          var t = s(e, 2),
            n = t[0],
            r = t[1];
          return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
        })), f;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          totalCount: t.totalCount,
          prev: t.prev,
          next: t.next
        };
      }
    },
    Me = {
      getOperation: function () {
        return I.PNGetMembershipsOperation;
      },
      validateParams: function () {},
      getURL: function (e, t) {
        var n,
          r = e.config;
        return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(M.encodeString(null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()), "/channels");
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          u,
          c,
          l,
          p,
          f,
          h,
          d = {
            include: ["channel.status", "channel.type", "status"]
          };
        return (null == t ? void 0 : t.include) && ((null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && d.include.push("custom"), (null === (r = t.include) || void 0 === r ? void 0 : r.customChannelFields) && d.include.push("channel.custom"), (null === (o = t.include) || void 0 === o ? void 0 : o.channelFields) && d.include.push("channel")), d.include = d.include.join(","), (null === (i = null == t ? void 0 : t.include) || void 0 === i ? void 0 : i.totalCount) && (d.count = null === (a = t.include) || void 0 === a ? void 0 : a.totalCount), (null === (u = null == t ? void 0 : t.page) || void 0 === u ? void 0 : u.next) && (d.start = null === (c = t.page) || void 0 === c ? void 0 : c.next), (null === (l = null == t ? void 0 : t.page) || void 0 === l ? void 0 : l.prev) && (d.end = null === (p = t.page) || void 0 === p ? void 0 : p.prev), (null == t ? void 0 : t.filter) && (d.filter = t.filter), d.limit = null !== (f = null == t ? void 0 : t.limit) && void 0 !== f ? f : 100, (null == t ? void 0 : t.sort) && (d.sort = Object.entries(null !== (h = t.sort) && void 0 !== h ? h : {}).map(function (e) {
          var t = s(e, 2),
            n = t[0],
            r = t[1];
          return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
        })), d;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          totalCount: t.totalCount,
          prev: t.prev,
          next: t.next
        };
      }
    },
    Re = {
      getOperation: function () {
        return I.PNSetMembershipsOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.channels) || 0 === (null == t ? void 0 : t.channels.length)) return "Channels cannot be empty";
      },
      usePatch: function () {
        return !0;
      },
      patchURL: function (e, t) {
        var n,
          r = e.config;
        return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(M.encodeString(null !== (n = t.uuid) && void 0 !== n ? n : r.getUUID()), "/channels");
      },
      patchPayload: function (e, t) {
        var n;
        return (n = {
          set: [],
          delete: []
        })[t.type] = t.channels.map(function (e) {
          return "string" == typeof e ? {
            channel: {
              id: e
            }
          } : {
            channel: {
              id: e.id
            },
            custom: e.custom,
            status: e.status
          };
        }), n;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          u,
          c,
          l,
          p,
          f = {
            include: ["channel.status", "channel.type", "status"]
          };
        return (null == t ? void 0 : t.include) && ((null === (n = t.include) || void 0 === n ? void 0 : n.customFields) && f.include.push("custom"), (null === (r = t.include) || void 0 === r ? void 0 : r.customChannelFields) && f.include.push("channel.custom"), (null === (o = t.include) || void 0 === o ? void 0 : o.channelFields) && f.include.push("channel")), f.include = f.include.join(","), (null === (i = null == t ? void 0 : t.include) || void 0 === i ? void 0 : i.totalCount) && (f.count = !0), (null === (a = null == t ? void 0 : t.page) || void 0 === a ? void 0 : a.next) && (f.start = null === (u = t.page) || void 0 === u ? void 0 : u.next), (null === (c = null == t ? void 0 : t.page) || void 0 === c ? void 0 : c.prev) && (f.end = null === (l = t.page) || void 0 === l ? void 0 : l.prev), (null == t ? void 0 : t.filter) && (f.filter = t.filter), null != t.limit && (f.limit = t.limit), (null == t ? void 0 : t.sort) && (f.sort = Object.entries(null !== (p = t.sort) && void 0 !== p ? p : {}).map(function (e) {
          var t = s(e, 2),
            n = t[0],
            r = t[1];
          return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
        })), f;
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data,
          totalCount: t.totalCount,
          prev: t.prev,
          next: t.next
        };
      }
    };
  var Ue = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNAccessManagerAudit;
    },
    validateParams: function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    },
    getURL: function (e) {
      var t = e.config;
      return "/v2/auth/audit/sub-key/".concat(t.subscribeKey);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !1;
    },
    prepareParams: function (e, t) {
      var n = t.channel,
        r = t.channelGroup,
        o = t.authKeys,
        i = void 0 === o ? [] : o,
        a = {};
      return n && (a.channel = n), r && (a["channel-group"] = r), i.length > 0 && (a.auth = i.join(",")), a;
    },
    handleResponse: function (e, t) {
      return t.payload;
    }
  });
  var Ie = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNAccessManagerGrant;
    },
    validateParams: function (e, t) {
      var n = e.config;
      return n.subscribeKey ? n.publishKey ? n.secretKey ? null == t.uuids || t.authKeys ? null == t.uuids || null == t.channels && null == t.channelGroups ? void 0 : "Both channel/channelgroup and uuid cannot be used in the same request" : "authKeys are required for grant request on uuids" : "Missing Secret Key" : "Missing Publish Key" : "Missing Subscribe Key";
    },
    getURL: function (e) {
      var t = e.config;
      return "/v2/auth/grant/sub-key/".concat(t.subscribeKey);
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !1;
    },
    prepareParams: function (e, t) {
      var n = t.channels,
        r = void 0 === n ? [] : n,
        o = t.channelGroups,
        i = void 0 === o ? [] : o,
        a = t.uuids,
        s = void 0 === a ? [] : a,
        u = t.ttl,
        c = t.read,
        l = void 0 !== c && c,
        p = t.write,
        f = void 0 !== p && p,
        h = t.manage,
        d = void 0 !== h && h,
        y = t.get,
        g = void 0 !== y && y,
        b = t.join,
        v = void 0 !== b && b,
        m = t.update,
        _ = void 0 !== m && m,
        O = t.authKeys,
        S = void 0 === O ? [] : O,
        P = t.delete,
        w = {};
      return w.r = l ? "1" : "0", w.w = f ? "1" : "0", w.m = d ? "1" : "0", w.d = P ? "1" : "0", w.g = g ? "1" : "0", w.j = v ? "1" : "0", w.u = _ ? "1" : "0", r.length > 0 && (w.channel = r.join(",")), i.length > 0 && (w["channel-group"] = i.join(",")), S.length > 0 && (w.auth = S.join(",")), s.length > 0 && (w["target-uuid"] = s.join(",")), (u || 0 === u) && (w.ttl = u), w;
    },
    handleResponse: function () {
      return {};
    }
  });
  function xe(e) {
    var t,
      n,
      r,
      o,
      i = void 0 !== (null == e ? void 0 : e.authorizedUserId),
      a = void 0 !== (null === (t = null == e ? void 0 : e.resources) || void 0 === t ? void 0 : t.users),
      s = void 0 !== (null === (n = null == e ? void 0 : e.resources) || void 0 === n ? void 0 : n.spaces),
      u = void 0 !== (null === (r = null == e ? void 0 : e.patterns) || void 0 === r ? void 0 : r.users),
      c = void 0 !== (null === (o = null == e ? void 0 : e.patterns) || void 0 === o ? void 0 : o.spaces);
    return u || a || c || s || i;
  }
  function De(e) {
    var t = 0;
    return e.join && (t |= 128), e.update && (t |= 64), e.get && (t |= 32), e.delete && (t |= 8), e.manage && (t |= 4), e.write && (t |= 2), e.read && (t |= 1), t;
  }
  function Fe(e, t) {
    if (xe(t)) return function (e, t) {
      var n = t.ttl,
        r = t.resources,
        o = t.patterns,
        i = t.meta,
        a = t.authorizedUserId,
        s = {
          ttl: 0,
          permissions: {
            resources: {
              channels: {},
              groups: {},
              uuids: {},
              users: {},
              spaces: {}
            },
            patterns: {
              channels: {},
              groups: {},
              uuids: {},
              users: {},
              spaces: {}
            },
            meta: {}
          }
        };
      if (r) {
        var u = r.users,
          c = r.spaces,
          l = r.groups;
        u && Object.keys(u).forEach(function (e) {
          s.permissions.resources.uuids[e] = De(u[e]);
        }), c && Object.keys(c).forEach(function (e) {
          s.permissions.resources.channels[e] = De(c[e]);
        }), l && Object.keys(l).forEach(function (e) {
          s.permissions.resources.groups[e] = De(l[e]);
        });
      }
      if (o) {
        var p = o.users,
          f = o.spaces,
          h = o.groups;
        p && Object.keys(p).forEach(function (e) {
          s.permissions.patterns.uuids[e] = De(p[e]);
        }), f && Object.keys(f).forEach(function (e) {
          s.permissions.patterns.channels[e] = De(f[e]);
        }), h && Object.keys(h).forEach(function (e) {
          s.permissions.patterns.groups[e] = De(h[e]);
        });
      }
      return (n || 0 === n) && (s.ttl = n), i && (s.permissions.meta = i), a && (s.permissions.uuid = "".concat(a)), s;
    }(0, t);
    var n = t.ttl,
      r = t.resources,
      o = t.patterns,
      i = t.meta,
      a = t.authorized_uuid,
      s = {
        ttl: 0,
        permissions: {
          resources: {
            channels: {},
            groups: {},
            uuids: {},
            users: {},
            spaces: {}
          },
          patterns: {
            channels: {},
            groups: {},
            uuids: {},
            users: {},
            spaces: {}
          },
          meta: {}
        }
      };
    if (r) {
      var u = r.uuids,
        c = r.channels,
        l = r.groups;
      u && Object.keys(u).forEach(function (e) {
        s.permissions.resources.uuids[e] = De(u[e]);
      }), c && Object.keys(c).forEach(function (e) {
        s.permissions.resources.channels[e] = De(c[e]);
      }), l && Object.keys(l).forEach(function (e) {
        s.permissions.resources.groups[e] = De(l[e]);
      });
    }
    if (o) {
      var p = o.uuids,
        f = o.channels,
        h = o.groups;
      p && Object.keys(p).forEach(function (e) {
        s.permissions.patterns.uuids[e] = De(p[e]);
      }), f && Object.keys(f).forEach(function (e) {
        s.permissions.patterns.channels[e] = De(f[e]);
      }), h && Object.keys(h).forEach(function (e) {
        s.permissions.patterns.groups[e] = De(h[e]);
      });
    }
    return (n || 0 === n) && (s.ttl = n), i && (s.permissions.meta = i), a && (s.permissions.uuid = "".concat(a)), s;
  }
  var Ge = Object.freeze({
      __proto__: null,
      getOperation: function () {
        return I.PNAccessManagerGrantToken;
      },
      extractPermissions: De,
      validateParams: function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          s,
          u = e.config;
        if (!u.subscribeKey) return "Missing Subscribe Key";
        if (!u.publishKey) return "Missing Publish Key";
        if (!u.secretKey) return "Missing Secret Key";
        if (!t.resources && !t.patterns) return "Missing either Resources or Patterns.";
        var c = void 0 !== (null == t ? void 0 : t.authorized_uuid),
          l = void 0 !== (null === (n = null == t ? void 0 : t.resources) || void 0 === n ? void 0 : n.uuids),
          p = void 0 !== (null === (r = null == t ? void 0 : t.resources) || void 0 === r ? void 0 : r.channels),
          f = void 0 !== (null === (o = null == t ? void 0 : t.resources) || void 0 === o ? void 0 : o.groups),
          h = void 0 !== (null === (i = null == t ? void 0 : t.patterns) || void 0 === i ? void 0 : i.uuids),
          d = void 0 !== (null === (a = null == t ? void 0 : t.patterns) || void 0 === a ? void 0 : a.channels),
          y = void 0 !== (null === (s = null == t ? void 0 : t.patterns) || void 0 === s ? void 0 : s.groups),
          g = c || l || h || p || d || f || y;
        return xe(t) && g ? "Cannot mix `users`, `spaces` and `authorizedUserId` with `uuids`, `channels`, `groups` and `authorized_uuid`" : (!t.resources || t.resources.uuids && 0 !== Object.keys(t.resources.uuids).length || t.resources.channels && 0 !== Object.keys(t.resources.channels).length || t.resources.groups && 0 !== Object.keys(t.resources.groups).length || t.resources.users && 0 !== Object.keys(t.resources.users).length || t.resources.spaces && 0 !== Object.keys(t.resources.spaces).length) && (!t.patterns || t.patterns.uuids && 0 !== Object.keys(t.patterns.uuids).length || t.patterns.channels && 0 !== Object.keys(t.patterns.channels).length || t.patterns.groups && 0 !== Object.keys(t.patterns.groups).length || t.patterns.users && 0 !== Object.keys(t.patterns.users).length || t.patterns.spaces && 0 !== Object.keys(t.patterns.spaces).length) ? void 0 : "Missing values for either Resources or Patterns.";
      },
      postURL: function (e) {
        var t = e.config;
        return "/v3/pam/".concat(t.subscribeKey, "/grant");
      },
      usePost: function () {
        return !0;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !1;
      },
      prepareParams: function () {
        return {};
      },
      postPayload: function (e, t) {
        return Fe(0, t);
      },
      handleResponse: function (e, t) {
        return t.data.token;
      }
    }),
    Le = {
      getOperation: function () {
        return I.PNAccessManagerRevokeToken;
      },
      validateParams: function (e, t) {
        return e.config.secretKey ? t ? void 0 : "token can't be empty" : "Missing Secret Key";
      },
      getURL: function (e, t) {
        var n = e.config;
        return "/v3/pam/".concat(n.subscribeKey, "/grant/").concat(M.encodeString(t));
      },
      useDelete: function () {
        return !0;
      },
      getRequestTimeout: function (e) {
        return e.config.getTransactionTimeout();
      },
      isAuthSupported: function () {
        return !1;
      },
      prepareParams: function (e) {
        return {
          uuid: e.config.getUUID()
        };
      },
      handleResponse: function (e, t) {
        return {
          status: t.status,
          data: t.data
        };
      }
    };
  function Ke(e, t) {
    var n = JSON.stringify(t);
    if (e.cryptoModule) {
      var r = e.cryptoModule.encrypt(n);
      n = "string" == typeof r ? r : v(r), n = JSON.stringify(n);
    }
    return n || "";
  }
  var Be = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNPublishOperation;
    },
    validateParams: function (e, t) {
      var n = e.config,
        r = t.message;
      return t.channel ? r ? n.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Message" : "Missing Channel";
    },
    usePost: function (e, t) {
      var n = t.sendByPost;
      return void 0 !== n && n;
    },
    getURL: function (e, t) {
      var n = e.config,
        r = t.channel,
        o = Ke(e, t.message);
      return "/publish/".concat(n.publishKey, "/").concat(n.subscribeKey, "/0/").concat(M.encodeString(r), "/0/").concat(M.encodeString(o));
    },
    postURL: function (e, t) {
      var n = e.config,
        r = t.channel;
      return "/publish/".concat(n.publishKey, "/").concat(n.subscribeKey, "/0/").concat(M.encodeString(r), "/0");
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    postPayload: function (e, t) {
      return Ke(e, t.message);
    },
    prepareParams: function (e, t) {
      var n = t.meta,
        r = t.replicate,
        o = void 0 === r || r,
        i = t.storeInHistory,
        a = t.ttl,
        s = {};
      return null != i && (s.store = i ? "1" : "0"), a && (s.ttl = a), !1 === o && (s.norep = "true"), n && "object" == typeof n && (s.meta = JSON.stringify(n)), s;
    },
    handleResponse: function (e, t) {
      return {
        timetoken: t[2]
      };
    }
  });
  var He = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNSignalOperation;
    },
    validateParams: function (e, t) {
      var n = e.config,
        r = t.message;
      return t.channel ? r ? n.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing Message" : "Missing Channel";
    },
    getURL: function (e, t) {
      var n,
        r = e.config,
        o = t.channel,
        i = t.message,
        a = (n = i, JSON.stringify(n));
      return "/signal/".concat(r.publishKey, "/").concat(r.subscribeKey, "/0/").concat(M.encodeString(o), "/0/").concat(M.encodeString(a));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function () {
      return {};
    },
    handleResponse: function (e, t) {
      return {
        timetoken: t[2]
      };
    }
  });
  function qe(e, t) {
    if (!e.cryptoModule) return t;
    try {
      var n = e.cryptoModule.decrypt(t);
      return n instanceof ArrayBuffer ? JSON.parse(new TextDecoder().decode(n)) : n;
    } catch (e) {
      return console && console.log && console.log("decryption error", e.message), t;
    }
  }
  var ze = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNHistoryOperation;
    },
    validateParams: function (e, t) {
      var n = t.channel,
        r = e.config;
      return n ? r.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing channel";
    },
    getURL: function (e, t) {
      var n = t.channel,
        r = e.config;
      return "/v2/history/sub-key/".concat(r.subscribeKey, "/channel/").concat(M.encodeString(n));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.start,
        r = t.end,
        o = t.reverse,
        i = t.count,
        a = void 0 === i ? 100 : i,
        s = t.stringifiedTimeToken,
        u = void 0 !== s && s,
        c = t.includeMeta,
        l = void 0 !== c && c,
        p = {
          include_token: "true"
        };
      return p.count = a, n && (p.start = n), r && (p.end = r), u && (p.string_message_token = "true"), null != o && (p.reverse = o.toString()), l && (p.include_meta = "true"), p;
    },
    handleResponse: function (e, t) {
      var n = {
        messages: [],
        startTimeToken: t[1],
        endTimeToken: t[2]
      };
      return Array.isArray(t[0]) && t[0].forEach(function (t) {
        var r = {
          timetoken: t.timetoken,
          entry: qe(e, t.message)
        };
        t.meta && (r.meta = t.meta), n.messages.push(r);
      }), n;
    }
  });
  var Ve = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNDeleteMessagesOperation;
    },
    validateParams: function (e, t) {
      var n = t.channel,
        r = e.config;
      return n ? r.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing channel";
    },
    useDelete: function () {
      return !0;
    },
    getURL: function (e, t) {
      var n = t.channel,
        r = e.config;
      return "/v3/history/sub-key/".concat(r.subscribeKey, "/channel/").concat(M.encodeString(n));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.start,
        r = t.end,
        o = {};
      return n && (o.start = n), r && (o.end = r), o;
    },
    handleResponse: function (e, t) {
      return t.payload;
    }
  });
  var We = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNMessageCounts;
    },
    validateParams: function (e, t) {
      var n = t.channels,
        r = t.timetoken,
        o = t.channelTimetokens,
        i = e.config;
      return n ? r && o ? "timetoken and channelTimetokens are incompatible together" : o && o.length > 1 && n.length !== o.length ? "Length of channelTimetokens and channels do not match" : i.subscribeKey ? void 0 : "Missing Subscribe Key" : "Missing channel";
    },
    getURL: function (e, t) {
      var n = t.channels,
        r = e.config,
        o = n.join(",");
      return "/v3/history/sub-key/".concat(r.subscribeKey, "/message-counts/").concat(M.encodeString(o));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.timetoken,
        r = t.channelTimetokens,
        o = {};
      if (r && 1 === r.length) {
        var i = s(r, 1)[0];
        o.timetoken = i;
      } else r ? o.channelsTimetoken = r.join(",") : n && (o.timetoken = n);
      return o;
    },
    handleResponse: function (e, t) {
      return {
        channels: t.channels
      };
    }
  });
  var Je = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNFetchMessagesOperation;
    },
    validateParams: function (e, t) {
      var n = t.channels,
        r = t.includeMessageActions,
        o = void 0 !== r && r,
        i = e.config;
      if (!n || 0 === n.length) return "Missing channels";
      if (!i.subscribeKey) return "Missing Subscribe Key";
      if (o && n.length > 1) throw new TypeError("History can return actions data for a single channel only. Either pass a single channel or disable the includeMessageActions flag.");
    },
    getURL: function (e, t) {
      var n = t.channels,
        r = void 0 === n ? [] : n,
        o = t.includeMessageActions,
        i = void 0 !== o && o,
        a = e.config,
        s = i ? "history-with-actions" : "history",
        u = r.length > 0 ? r.join(",") : ",";
      return "/v3/".concat(s, "/sub-key/").concat(a.subscribeKey, "/channel/").concat(M.encodeString(u));
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    isAuthSupported: function () {
      return !0;
    },
    prepareParams: function (e, t) {
      var n = t.channels,
        r = t.start,
        o = t.end,
        i = t.includeMessageActions,
        a = t.count,
        s = t.stringifiedTimeToken,
        u = void 0 !== s && s,
        c = t.includeMeta,
        l = void 0 !== c && c,
        p = t.includeUuid,
        f = t.includeUUID,
        h = void 0 === f || f,
        d = t.includeMessageType,
        y = void 0 === d || d,
        g = {};
      return g.max = a || (n.length > 1 || !0 === i ? 25 : 100), r && (g.start = r), o && (g.end = o), u && (g.string_message_token = "true"), l && (g.include_meta = "true"), h && !1 !== p && (g.include_uuid = "true"), y && (g.include_message_type = "true"), g;
    },
    handleResponse: function (e, t) {
      var n = {
        channels: {}
      };
      return Object.keys(t.channels || {}).forEach(function (r) {
        n.channels[r] = [], (t.channels[r] || []).forEach(function (t) {
          var o = {};
          o.channel = r, o.timetoken = t.timetoken, o.message = function (e, t) {
            if (!e.cryptoModule) return t;
            try {
              var n = e.cryptoModule.decrypt(t);
              return n instanceof ArrayBuffer ? JSON.parse(new TextDecoder().decode(n)) : n;
            } catch (e) {
              return console && console.log && console.log("decryption error", e.message), t;
            }
          }(e, t.message), o.messageType = t.message_type, o.uuid = t.uuid, t.actions && (o.actions = t.actions, o.data = t.actions), t.meta && (o.meta = t.meta), n.channels[r].push(o);
        });
      }), t.more && (n.more = t.more), n;
    }
  });
  var $e = Object.freeze({
    __proto__: null,
    getOperation: function () {
      return I.PNTimeOperation;
    },
    getURL: function () {
      return "/time/0";
    },
    getRequestTimeout: function (e) {
      return e.config.getTransactionTimeout();
    },
    prepareParams: function () {
      return {};
    },
    isAuthSupported: function () {
      return !1;
    },
    handleResponse: function (e, t) {
      return {
        timetoken: t[0]
      };
    },
    validateParams: function () {}
  });
  var Qe = Object.freeze({
      __proto__: null,
      getOperation: function () {
        return I.PNSubscribeOperation;
      },
      validateParams: function (e) {
        if (!e.config.subscribeKey) return "Missing Subscribe Key";
      },
      getURL: function (e, t) {
        var n = e.config,
          r = t.channels,
          o = void 0 === r ? [] : r,
          i = o.length > 0 ? o.join(",") : ",";
        return "/v2/subscribe/".concat(n.subscribeKey, "/").concat(M.encodeString(i), "/0");
      },
      getRequestTimeout: function (e) {
        return e.config.getSubscribeTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n = e.config,
          r = t.state,
          o = t.channelGroups,
          i = void 0 === o ? [] : o,
          a = t.timetoken,
          s = t.filterExpression,
          u = t.region,
          c = {
            heartbeat: n.getPresenceTimeout()
          };
        return i.length > 0 && (c["channel-group"] = i.join(",")), s && s.length > 0 && (c["filter-expr"] = s), Object.keys(r).length && (c.state = JSON.stringify(r)), a && (c.tt = a), u && (c.tr = u), c;
      },
      handleResponse: function (e, t) {
        var n = [];
        t.m.forEach(function (e) {
          var t = {
              publishTimetoken: e.p.t,
              region: e.p.r
            },
            r = {
              shard: parseInt(e.a, 10),
              subscriptionMatch: e.b,
              channel: e.c,
              messageType: e.e,
              payload: e.d,
              flags: e.f,
              issuingClientId: e.i,
              subscribeKey: e.k,
              originationTimetoken: e.o,
              userMetadata: e.u,
              publishMetaData: t
            };
          n.push(r);
        });
        var r = {
          timetoken: t.t.t,
          region: t.t.r
        };
        return {
          messages: n,
          metadata: r
        };
      }
    }),
    Xe = {
      getOperation: function () {
        return I.PNHandshakeOperation;
      },
      validateParams: function (e, t) {
        if (!(null == t ? void 0 : t.channels) && !(null == t ? void 0 : t.channelGroups)) return "channels and channleGroups both should not be empty";
      },
      getURL: function (e, t) {
        var n = e.config,
          r = t.channels ? t.channels.join(",") : ",";
        return "/v2/subscribe/".concat(n.subscribeKey, "/").concat(M.encodeString(r), "/0");
      },
      getRequestTimeout: function (e) {
        return e.config.getSubscribeTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      prepareParams: function (e, t) {
        var n = {};
        return t.channelGroups && t.channelGroups.length > 0 && (n["channel-group"] = t.channelGroups.join(",")), n.tt = 0, n;
      },
      handleResponse: function (e, t) {
        return {
          region: t.t.r,
          timetoken: t.t.t
        };
      }
    },
    Ye = {
      getOperation: function () {
        return I.PNReceiveMessagesOperation;
      },
      validateParams: function (e, t) {
        return (null == t ? void 0 : t.channels) || (null == t ? void 0 : t.channelGroups) ? (null == t ? void 0 : t.timetoken) ? (null == t ? void 0 : t.region) ? void 0 : "region can not be empty" : "timetoken can not be empty" : "channels and channleGroups both should not be empty";
      },
      getURL: function (e, t) {
        var n = e.config,
          r = t.channels ? t.channels.join(",") : ",";
        return "/v2/subscribe/".concat(n.subscribeKey, "/").concat(M.encodeString(r), "/0");
      },
      getRequestTimeout: function (e) {
        return e.config.getSubscribeTimeout();
      },
      isAuthSupported: function () {
        return !0;
      },
      getAbortSignal: function (e, t) {
        return t.abortSignal;
      },
      prepareParams: function (e, t) {
        var n = {};
        return t.channelGroups && t.channelGroups.length > 0 && (n["channel-group"] = t.channelGroups.join(",")), n.tt = t.timetoken, n.tr = t.region, n;
      },
      handleResponse: function (e, t) {
        var n = [];
        return t.m.forEach(function (e) {
          var t = {
            shard: parseInt(e.a, 10),
            subscriptionMatch: e.b,
            channel: e.c,
            messageType: e.e,
            payload: e.d,
            flags: e.f,
            issuingClientId: e.i,
            subscribeKey: e.k,
            originationTimetoken: e.o,
            publishMetaData: {
              timetoken: e.p.t,
              region: e.p.r
            }
          };
          n.push(t);
        }), {
          messages: n,
          metadata: {
            region: t.t.r,
            timetoken: t.t.t
          }
        };
      }
    },
    Ze = function () {
      function e(e) {
        void 0 === e && (e = !1), (this || _global).sync = e, (this || _global).listeners = new Set();
      }
      return e.prototype.subscribe = function (e) {
        var t = this || _global;
        return (this || _global).listeners.add(e), function () {
          t.listeners.delete(e);
        };
      }, e.prototype.notify = function (e) {
        var t = this || _global,
          n = function () {
            t.listeners.forEach(function (t) {
              t(e);
            });
          };
        (this || _global).sync ? n() : setTimeout(n, 0);
      }, e;
    }(),
    et = function () {
      function e(e) {
        (this || _global).label = e, (this || _global).transitionMap = new Map(), (this || _global).enterEffects = [], (this || _global).exitEffects = [];
      }
      return e.prototype.transition = function (e, t) {
        var n;
        if ((this || _global).transitionMap.has(t.type)) return null === (n = (this || _global).transitionMap.get(t.type)) || void 0 === n ? void 0 : n(e, t);
      }, e.prototype.on = function (e, t) {
        return (this || _global).transitionMap.set(e, t), this || _global;
      }, e.prototype.with = function (e, t) {
        return [this || _global, e, null != t ? t : []];
      }, e.prototype.onEnter = function (e) {
        return (this || _global).enterEffects.push(e), this || _global;
      }, e.prototype.onExit = function (e) {
        return (this || _global).exitEffects.push(e), this || _global;
      }, e;
    }(),
    tt = function (e) {
      function n() {
        return null !== e && e.apply(this || _global, arguments) || this || _global;
      }
      return t(n, e), n.prototype.describe = function (e) {
        return new et(e);
      }, n.prototype.start = function (e, t) {
        (this || _global).currentState = e, (this || _global).currentContext = t, this.notify({
          type: "engineStarted",
          state: e,
          context: t
        });
      }, n.prototype.transition = function (e) {
        var t, n, r, o, i, u;
        if (!(this || _global).currentState) throw new Error("Start the engine first");
        this.notify({
          type: "eventReceived",
          event: e
        });
        var c = (this || _global).currentState.transition((this || _global).currentContext, e);
        if (c) {
          var l = s(c, 3),
            p = l[0],
            f = l[1],
            h = l[2];
          try {
            for (var d = a((this || _global).currentState.exitEffects), y = d.next(); !y.done; y = d.next()) {
              var g = y.value;
              this.notify({
                type: "invocationDispatched",
                invocation: g((this || _global).currentContext)
              });
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              y && !y.done && (n = d.return) && n.call(d);
            } finally {
              if (t) throw t.error;
            }
          }
          var b = (this || _global).currentState;
          (this || _global).currentState = p;
          var v = (this || _global).currentContext;
          (this || _global).currentContext = f, this.notify({
            type: "transitionDone",
            fromState: b,
            fromContext: v,
            toState: p,
            toContext: f,
            event: e
          });
          try {
            for (var m = a(h), _ = m.next(); !_.done; _ = m.next()) {
              g = _.value;
              this.notify({
                type: "invocationDispatched",
                invocation: g
              });
            }
          } catch (e) {
            r = {
              error: e
            };
          } finally {
            try {
              _ && !_.done && (o = m.return) && o.call(m);
            } finally {
              if (r) throw r.error;
            }
          }
          try {
            for (var O = a((this || _global).currentState.enterEffects), S = O.next(); !S.done; S = O.next()) {
              g = S.value;
              this.notify({
                type: "invocationDispatched",
                invocation: g((this || _global).currentContext)
              });
            }
          } catch (e) {
            i = {
              error: e
            };
          } finally {
            try {
              S && !S.done && (u = O.return) && u.call(O);
            } finally {
              if (i) throw i.error;
            }
          }
        }
      }, n;
    }(Ze),
    nt = function () {
      function e(e) {
        (this || _global).dependencies = e, (this || _global).instances = new Map(), (this || _global).handlers = new Map();
      }
      return e.prototype.on = function (e, t) {
        (this || _global).handlers.set(e, t);
      }, e.prototype.dispatch = function (e) {
        if ("CANCEL" !== e.type) {
          var t = (this || _global).handlers.get(e.type);
          if (!t) throw new Error("Unhandled invocation '".concat(e.type, "'"));
          var n = t(e.payload, (this || _global).dependencies);
          e.managed && (this || _global).instances.set(e.type, n), n.start();
        } else if ((this || _global).instances.has(e.payload)) {
          var r = (this || _global).instances.get(e.payload);
          null == r || r.cancel(), (this || _global).instances.delete(e.payload);
        }
      }, e;
    }();
  function rt(e, t) {
    var n = function () {
      for (var n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
      return {
        type: e,
        payload: null == t ? void 0 : t.apply(void 0, u([], s(n), !1))
      };
    };
    return n.type = e, n;
  }
  function ot(e, t) {
    var n = function () {
      for (var n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
      return {
        type: e,
        payload: t.apply(void 0, u([], s(n), !1)),
        managed: !0
      };
    };
    return n.type = e, n.cancel = {
      type: "CANCEL",
      payload: e,
      managed: !1
    }, n;
  }
  var it,
    at,
    st,
    ut = function (e) {
      function n() {
        var t = (this || _global).constructor,
          n = e.call(this || _global, "The operation was aborted.") || this || _global;
        return n.name = "AbortError", Object.setPrototypeOf(n, t.prototype), n;
      }
      return t(n, e), n;
    }(Error),
    ct = function (e) {
      function n() {
        var t = null !== e && e.apply(this || _global, arguments) || this || _global;
        return t._aborted = !1, t;
      }
      return t(n, e), Object.defineProperty(n.prototype, "aborted", {
        get: function () {
          return (this || _global)._aborted;
        },
        enumerable: !1,
        configurable: !0
      }), n.prototype.throwIfAborted = function () {
        if ((this || _global)._aborted) throw new ut();
      }, n.prototype.abort = function () {
        (this || _global)._aborted = !0, this.notify(new ut());
      }, n;
    }(Ze),
    lt = function (e) {
      function n(t, n, r) {
        var o = e.call(this || _global, t, n) || this || _global;
        return o.asyncFunction = r, o.abortSignal = new ct(), o;
      }
      return t(n, e), n.prototype.start = function () {
        this.asyncFunction((this || _global).payload, (this || _global).abortSignal, (this || _global).dependencies);
      }, n.prototype.cancel = function () {
        (this || _global).abortSignal.abort();
      }, n;
    }(function (e, t) {
      (this || _global).payload = e, (this || _global).dependencies = t;
    }),
    pt = function (e) {
      return function (t, n) {
        return new lt(t, n, e);
      };
    },
    ft = ot("HANDSHAKE", function (e, t) {
      return {
        channels: e,
        groups: t
      };
    }),
    ht = ot("RECEIVE_EVENTS", function (e, t, n) {
      return {
        channels: e,
        groups: t,
        cursor: n
      };
    }),
    dt = (at = function (e) {
      return e;
    }, st = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      return {
        type: it,
        payload: at.apply(void 0, u([], s(e), !1)),
        managed: !1
      };
    }, st.type = it = "EMIT_EVENTS", st),
    yt = ot("RECONNECT", function (e) {
      return e;
    }),
    gt = ot("HANDSHAKE_RECONNECT", function (e) {
      return e;
    }),
    bt = rt("SUBSCRIPTION_CHANGE", function (e, t) {
      return {
        channels: e,
        groups: t
      };
    }),
    vt = rt("DISCONNECT", function () {
      return {};
    }),
    mt = rt("RECONNECT", function () {
      return {};
    });
  rt("RESTORE", function (e, t, n, r) {
    return {
      channels: e,
      groups: t,
      timetoken: n,
      region: r
    };
  });
  var _t = rt("HANDSHAKING_SUCCESS", function (e) {
      return e;
    }),
    Ot = rt("HANDSHAKING_FAILURE", function (e) {
      return e;
    }),
    St = rt("HANDSHAKING_RECONNECTING_SUCCESS", function (e) {
      return {
        cursor: e
      };
    }),
    Pt = rt("HANDSHAKING_RECONNECTING_FAILURE", function (e) {
      return e;
    }),
    wt = rt("HANDSHAKING_RECONNECTING_GIVEUP", function () {
      return {};
    }),
    Et = rt("HANDSHAKING_RECONNECTING_RETRY", function () {
      return {};
    }),
    Tt = rt("RECEIVING_SUCCESS", function (e, t) {
      return {
        cursor: e,
        events: t
      };
    }),
    At = rt("RECEIVING_FAILURE", function (e) {
      return e;
    }),
    Nt = rt("RECONNECTING_SUCCESS", function (e, t) {
      return {
        cursor: e,
        events: t
      };
    }),
    kt = rt("RECONNECTING_FAILURE", function (e) {
      return e;
    }),
    Ct = rt("RECONNECTING_GIVEUP", function () {
      return {};
    }),
    jt = rt("RECONNECTING_RETRY", function () {
      return {};
    }),
    Mt = function (e) {
      function n(t, n) {
        var r = e.call(this || _global, n) || this || _global;
        return r.on(ft.type, pt(function (e, n, a) {
          var s = a.handshake;
          return o(r, void 0, void 0, function () {
            var r, o;
            return i(this || _global, function (i) {
              switch (i.label) {
                case 0:
                  n.throwIfAborted(), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, s({
                    abortSignal: n,
                    channels: e.channels,
                    channelGroups: e.groups
                  })];
                case 2:
                  return r = i.sent(), t.transition(_t(r)), [3, 4];
                case 3:
                  return (o = i.sent()) instanceof Error && "Aborted" === o.message ? [2] : o instanceof q ? [2, t.transition(Ot(o))] : [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        })), r.on(ht.type, pt(function (e, n, a) {
          var s = a.receiveEvents;
          return o(r, void 0, void 0, function () {
            var r, o;
            return i(this || _global, function (i) {
              switch (i.label) {
                case 0:
                  n.throwIfAborted(), i.label = 1;
                case 1:
                  return i.trys.push([1, 3,, 4]), [4, s({
                    abortSignal: n,
                    channels: e.channels,
                    channelGroups: e.groups,
                    timetoken: e.cursor.timetoken,
                    region: e.cursor.region
                  })];
                case 2:
                  return r = i.sent(), t.transition(Tt(r.metadata, r.messages)), [3, 4];
                case 3:
                  return (o = i.sent()) instanceof Error && "Aborted" === o.message ? [2] : o instanceof q ? [2, t.transition(At(o))] : [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        })), r.on(dt.type, pt(function (e, t, n) {
          return n.receiveEvents, o(r, void 0, void 0, function () {
            return i(this || _global, function (t) {
              return e.length > 0 && console.log(e), [2];
            });
          });
        })), r.on(yt.type, pt(function (e, n, a) {
          var s = a.receiveEvents,
            u = a.shouldRetry,
            c = a.getRetryDelay,
            l = a.delay;
          return o(r, void 0, void 0, function () {
            var r, o;
            return i(this || _global, function (i) {
              switch (i.label) {
                case 0:
                  return u(e.reason, e.attempts) ? (n.throwIfAborted(), [4, l(c(e.attempts))]) : [2, t.transition(Ct())];
                case 1:
                  i.sent(), n.throwIfAborted(), i.label = 2;
                case 2:
                  return i.trys.push([2, 4,, 5]), [4, s({
                    abortSignal: n,
                    channels: e.channels,
                    channelGroups: e.groups,
                    timetoken: e.cursor.timetoken,
                    region: e.cursor.region
                  })];
                case 3:
                  return r = i.sent(), [2, t.transition(Nt(r.metadata, r.messages))];
                case 4:
                  return (o = i.sent()) instanceof Error && "Aborted" === o.message ? [2] : o instanceof q ? [2, t.transition(kt(o))] : [3, 5];
                case 5:
                  return [2];
              }
            });
          });
        })), r.on(gt.type, pt(function (e, n, a) {
          var s = a.handshake,
            u = a.shouldRetry,
            c = a.getRetryDelay,
            l = a.delay;
          return o(r, void 0, void 0, function () {
            var r, o;
            return i(this || _global, function (i) {
              switch (i.label) {
                case 0:
                  return u(e.reason, e.attempts) ? (n.throwIfAborted(), [4, l(c(e.attempts))]) : [2, t.transition(wt())];
                case 1:
                  i.sent(), n.throwIfAborted(), i.label = 2;
                case 2:
                  return i.trys.push([2, 4,, 5]), [4, s({
                    abortSignal: n,
                    channels: e.channels,
                    channelGroups: e.groups
                  })];
                case 3:
                  return r = i.sent(), [2, t.transition(St(r.metadata))];
                case 4:
                  return (o = i.sent()) instanceof Error && "Aborted" === o.message ? [2] : o instanceof q ? [2, t.transition(Pt(o))] : [3, 5];
                case 5:
                  return [2];
              }
            });
          });
        })), r;
      }
      return t(n, e), n;
    }(nt),
    Rt = new et("STOPPED");
  Rt.on(bt.type, function (e, t) {
    return Rt.with({
      channels: t.payload.channels,
      groups: t.payload.groups
    });
  }), Rt.on(mt.type, function (e) {
    return Lt.with(n({}, e));
  });
  var Ut = new et("HANDSHAKE_FAILURE");
  Ut.on(Et.type, function (e) {
    return Gt.with(n(n({}, e), {
      attempts: 0
    }));
  }), Ut.on(vt.type, function (e) {
    return Rt.with({
      channels: e.channels,
      groups: e.groups
    });
  });
  var It = new et("STOPPED");
  It.on(bt.type, function (e, t) {
    return It.with({
      channels: t.payload.channels,
      groups: t.payload.groups,
      cursor: e.cursor
    });
  }), It.on(mt.type, function (e) {
    return Ft.with(n({}, e));
  });
  var xt = new et("RECEIVE_FAILURE");
  xt.on(jt.type, function (e) {
    return Dt.with(n(n({}, e), {
      attempts: 0
    }));
  }), xt.on(vt.type, function (e) {
    return It.with({
      channels: e.channels,
      groups: e.groups,
      cursor: e.cursor
    });
  });
  var Dt = new et("RECEIVE_RECONNECTING");
  Dt.onEnter(function (e) {
    return yt(e);
  }), Dt.onExit(function () {
    return yt.cancel;
  }), Dt.on(Nt.type, function (e, t) {
    return Ft.with({
      channels: e.channels,
      groups: e.groups,
      cursor: t.payload.cursor
    }, [dt(t.payload.events)]);
  }), Dt.on(kt.type, function (e, t) {
    return Dt.with(n(n({}, e), {
      attempts: e.attempts + 1,
      reason: t.payload
    }));
  }), Dt.on(Ct.type, function (e) {
    return xt.with({
      groups: e.groups,
      channels: e.channels,
      cursor: e.cursor,
      reason: e.reason
    });
  }), Dt.on(vt.type, function (e) {
    return It.with({
      channels: e.channels,
      groups: e.groups,
      cursor: e.cursor
    });
  });
  var Ft = new et("RECEIVING");
  Ft.onEnter(function (e) {
    return ht(e.channels, e.groups, e.cursor);
  }), Ft.onExit(function () {
    return ht.cancel;
  }), Ft.on(Tt.type, function (e, t) {
    return Ft.with(n(n({}, e), {
      cursor: t.payload.cursor
    }), [dt(t.payload.events)]);
  }), Ft.on(bt.type, function (e, t) {
    return 0 === t.payload.channels.length && 0 === t.payload.groups.length ? Kt.with(void 0) : Ft.with(n(n({}, e), {
      channels: t.payload.channels,
      groups: t.payload.groups
    }));
  }), Ft.on(At.type, function (e, t) {
    return Dt.with(n(n({}, e), {
      attempts: 0,
      reason: t.payload
    }));
  }), Ft.on(vt.type, function (e) {
    return It.with({
      channels: e.channels,
      groups: e.groups,
      cursor: e.cursor
    });
  });
  var Gt = new et("HANDSHAKE_RECONNECTING");
  Gt.onEnter(function (e) {
    return gt(e);
  }), Gt.onExit(function () {
    return yt.cancel;
  }), Gt.on(Nt.type, function (e, t) {
    return Ft.with({
      channels: e.channels,
      groups: e.groups,
      cursor: t.payload.cursor
    }, [dt(t.payload.events)]);
  }), Gt.on(kt.type, function (e, t) {
    return Gt.with(n(n({}, e), {
      attempts: e.attempts + 1,
      reason: t.payload
    }));
  }), Gt.on(Ct.type, function (e) {
    return Ut.with({
      groups: e.groups,
      channels: e.channels,
      reason: e.reason
    });
  }), Gt.on(vt.type, function (e) {
    return Rt.with({
      channels: e.channels,
      groups: e.groups
    });
  });
  var Lt = new et("HANDSHAKING");
  Lt.onEnter(function (e) {
    return ft(e.channels, e.groups);
  }), Lt.onExit(function () {
    return ft.cancel;
  }), Lt.on(bt.type, function (e, t) {
    return 0 === t.payload.channels.length && 0 === t.payload.groups.length ? Kt.with(void 0) : Lt.with({
      channels: t.payload.channels,
      groups: t.payload.groups
    });
  }), Lt.on(_t.type, function (e, t) {
    return Ft.with({
      channels: e.channels,
      groups: e.groups,
      cursor: t.payload
    });
  }), Lt.on(Ot.type, function (e, t) {
    return Gt.with(n(n({}, e), {
      attempts: 0,
      reason: t.payload
    }));
  }), Lt.on(vt.type, function (e) {
    return Rt.with({
      channels: e.channels,
      groups: e.groups
    });
  });
  var Kt = new et("UNSUBSCRIBED");
  Kt.on(bt.type, function (e, t) {
    return Lt.with({
      channels: t.payload.channels,
      groups: t.payload.groups
    });
  });
  var Bt = function () {
      function e(e) {
        var t = this || _global;
        (this || _global).engine = new tt(), (this || _global).channels = [], (this || _global).groups = [], (this || _global).dispatcher = new Mt((this || _global).engine, e), (this || _global).engine.subscribe(function (e) {
          "invocationDispatched" === e.type && t.dispatcher.dispatch(e.invocation);
        }), (this || _global).engine.start(Kt, void 0);
      }
      return Object.defineProperty(e.prototype, "_engine", {
        get: function () {
          return (this || _global).engine;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.subscribe = function (e) {
        var t = e.channels,
          n = e.groups;
        (this || _global).channels = u(u([], s((this || _global).channels), !1), s(null != t ? t : []), !1), (this || _global).groups = u(u([], s((this || _global).groups), !1), s(null != n ? n : []), !1), (this || _global).engine.transition(bt((this || _global).channels, (this || _global).groups));
      }, e.prototype.unsubscribe = function (e) {
        var t = e.channels,
          n = e.groups;
        (this || _global).channels = (this || _global).channels.filter(function (e) {
          var n;
          return null === (n = !(null == t ? void 0 : t.includes(e))) || void 0 === n || n;
        }), (this || _global).groups = (this || _global).groups.filter(function (e) {
          var t;
          return null === (t = !(null == n ? void 0 : n.includes(e))) || void 0 === t || t;
        }), (this || _global).engine.transition(bt((this || _global).channels.slice(0), (this || _global).groups.slice(0)));
      }, e.prototype.unsubscribeAll = function () {
        (this || _global).channels = [], (this || _global).groups = [], (this || _global).engine.transition(bt((this || _global).channels.slice(0), (this || _global).groups.slice(0)));
      }, e.prototype.reconnect = function () {
        (this || _global).engine.transition(mt());
      }, e.prototype.disconnect = function () {
        (this || _global).engine.transition(vt());
      }, e;
    }(),
    Ht = function () {
      function e(e) {
        var t = this || _global,
          r = e.networking,
          o = e.cbor,
          i = new g({
            setup: e
          });
        (this || _global)._config = i;
        var a = new A({
            config: i
          }),
          c = e.cryptography;
        r.init(i);
        var l = new H(i, o);
        (this || _global)._tokenManager = l;
        var p = new x({
          maximumSamplesCount: 60000
        });
        (this || _global)._telemetryManager = p;
        var f = (this || _global)._config.cryptoModule,
          h = {
            config: i,
            networking: r,
            crypto: a,
            cryptography: c,
            tokenManager: l,
            telemetryManager: p,
            PubNubFile: e.PubNubFile,
            cryptoModule: f
          };
        (this || _global).File = e.PubNubFile, (this || _global).encryptFile = function (e, t) {
          return 1 == arguments.length && "string" != typeof e && h.cryptoModule ? (t = e, h.cryptoModule.encryptFile(t, (this || _global).File)) : c.encryptFile(e, t, (this || _global).File);
        }, (this || _global).decryptFile = function (e, t) {
          return 1 == arguments.length && "string" != typeof e && h.cryptoModule ? (t = e, h.cryptoModule.decryptFile(t, (this || _global).File)) : c.decryptFile(e, t, (this || _global).File);
        };
        var d = Q.bind(this || _global, h, $e),
          y = Q.bind(this || _global, h, ae),
          b = Q.bind(this || _global, h, ue),
          m = Q.bind(this || _global, h, le),
          _ = Q.bind(this || _global, h, Qe),
          O = new B();
        if ((this || _global)._listenerManager = O, (this || _global).iAmHere = Q.bind(this || _global, h, ue), (this || _global).iAmAway = Q.bind(this || _global, h, ae), (this || _global).setPresenceState = Q.bind(this || _global, h, le), (this || _global).handshake = Q.bind(this || _global, h, Xe), (this || _global).receiveMessages = Q.bind(this || _global, h, Ye), !0 === i.enableSubscribeBeta) {
          var S = new Bt({
            handshake: (this || _global).handshake,
            receiveEvents: (this || _global).receiveMessages
          });
          (this || _global).subscribe = S.subscribe.bind(S), (this || _global).unsubscribe = S.unsubscribe.bind(S), (this || _global).eventEngine = S;
        } else {
          var P = new U({
            timeEndpoint: d,
            leaveEndpoint: y,
            heartbeatEndpoint: b,
            setStateEndpoint: m,
            subscribeEndpoint: _,
            crypto: h.crypto,
            config: h.config,
            listenerManager: O,
            getFileUrl: function (e) {
              return me(h, e);
            },
            cryptoModule: h.cryptoModule
          });
          (this || _global).subscribe = P.adaptSubscribeChange.bind(P), (this || _global).unsubscribe = P.adaptUnsubscribeChange.bind(P), (this || _global).disconnect = P.disconnect.bind(P), (this || _global).reconnect = P.reconnect.bind(P), (this || _global).unsubscribeAll = P.unsubscribeAll.bind(P), (this || _global).getSubscribedChannels = P.getSubscribedChannels.bind(P), (this || _global).getSubscribedChannelGroups = P.getSubscribedChannelGroups.bind(P), (this || _global).setState = P.adaptStateChange.bind(P), (this || _global).presence = P.adaptPresenceChange.bind(P), (this || _global).destroy = function (e) {
            P.unsubscribeAll(e), P.disconnect();
          };
        }
        (this || _global).addListener = O.addListener.bind(O), (this || _global).removeListener = O.removeListener.bind(O), (this || _global).removeAllListeners = O.removeAllListeners.bind(O), (this || _global).parseToken = l.parseToken.bind(l), (this || _global).setToken = l.setToken.bind(l), (this || _global).getToken = l.getToken.bind(l), (this || _global).channelGroups = {
          listGroups: Q.bind(this || _global, h, ee),
          listChannels: Q.bind(this || _global, h, te),
          addChannels: Q.bind(this || _global, h, X),
          removeChannels: Q.bind(this || _global, h, Y),
          deleteGroup: Q.bind(this || _global, h, Z)
        }, (this || _global).push = {
          addChannels: Q.bind(this || _global, h, ne),
          removeChannels: Q.bind(this || _global, h, re),
          deleteDevice: Q.bind(this || _global, h, ie),
          listChannels: Q.bind(this || _global, h, oe)
        }, (this || _global).hereNow = Q.bind(this || _global, h, pe), (this || _global).whereNow = Q.bind(this || _global, h, se), (this || _global).getState = Q.bind(this || _global, h, ce), (this || _global).grant = Q.bind(this || _global, h, Ie), (this || _global).grantToken = Q.bind(this || _global, h, Ge), (this || _global).audit = Q.bind(this || _global, h, Ue), (this || _global).revokeToken = Q.bind(this || _global, h, Le), (this || _global).publish = Q.bind(this || _global, h, Be), (this || _global).fire = function (e, n) {
          return e.replicate = !1, e.storeInHistory = !1, t.publish(e, n);
        }, (this || _global).signal = Q.bind(this || _global, h, He), (this || _global).history = Q.bind(this || _global, h, ze), (this || _global).deleteMessages = Q.bind(this || _global, h, Ve), (this || _global).messageCounts = Q.bind(this || _global, h, We), (this || _global).fetchMessages = Q.bind(this || _global, h, Je), (this || _global).addMessageAction = Q.bind(this || _global, h, fe), (this || _global).removeMessageAction = Q.bind(this || _global, h, he), (this || _global).getMessageActions = Q.bind(this || _global, h, de), (this || _global).listFiles = Q.bind(this || _global, h, ye);
        var w = Q.bind(this || _global, h, ge);
        (this || _global).publishFile = Q.bind(this || _global, h, be), (this || _global).sendFile = ve({
          generateUploadUrl: w,
          publishFile: (this || _global).publishFile,
          modules: h
        }), (this || _global).getFileUrl = function (e) {
          return me(h, e);
        }, (this || _global).downloadFile = Q.bind(this || _global, h, _e), (this || _global).deleteFile = Q.bind(this || _global, h, Oe), (this || _global).objects = {
          getAllUUIDMetadata: Q.bind(this || _global, h, Se),
          getUUIDMetadata: Q.bind(this || _global, h, Pe),
          setUUIDMetadata: Q.bind(this || _global, h, we),
          removeUUIDMetadata: Q.bind(this || _global, h, Ee),
          getAllChannelMetadata: Q.bind(this || _global, h, Te),
          getChannelMetadata: Q.bind(this || _global, h, Ae),
          setChannelMetadata: Q.bind(this || _global, h, Ne),
          removeChannelMetadata: Q.bind(this || _global, h, ke),
          getChannelMembers: Q.bind(this || _global, h, Ce),
          setChannelMembers: function (e) {
            for (var r = [], o = 1; o < arguments.length; o++) r[o - 1] = arguments[o];
            return Q.call.apply(Q, u([t, h, je, n({
              type: "set"
            }, e)], s(r), !1));
          },
          removeChannelMembers: function (e) {
            for (var r = [], o = 1; o < arguments.length; o++) r[o - 1] = arguments[o];
            return Q.call.apply(Q, u([t, h, je, n({
              type: "delete"
            }, e)], s(r), !1));
          },
          getMemberships: Q.bind(this || _global, h, Me),
          setMemberships: function (e) {
            for (var r = [], o = 1; o < arguments.length; o++) r[o - 1] = arguments[o];
            return Q.call.apply(Q, u([t, h, Re, n({
              type: "set"
            }, e)], s(r), !1));
          },
          removeMemberships: function (e) {
            for (var r = [], o = 1; o < arguments.length; o++) r[o - 1] = arguments[o];
            return Q.call.apply(Q, u([t, h, Re, n({
              type: "delete"
            }, e)], s(r), !1));
          }
        }, (this || _global).createUser = function (e) {
          return t.objects.setUUIDMetadata({
            uuid: e.userId,
            data: e.data,
            include: e.include
          });
        }, (this || _global).updateUser = (this || _global).createUser, (this || _global).removeUser = function (e) {
          return t.objects.removeUUIDMetadata({
            uuid: null == e ? void 0 : e.userId
          });
        }, (this || _global).fetchUser = function (e) {
          return t.objects.getUUIDMetadata({
            uuid: null == e ? void 0 : e.userId,
            include: null == e ? void 0 : e.include
          });
        }, (this || _global).fetchUsers = (this || _global).objects.getAllUUIDMetadata, (this || _global).createSpace = function (e) {
          return t.objects.setChannelMetadata({
            channel: e.spaceId,
            data: e.data,
            include: e.include
          });
        }, (this || _global).updateSpace = (this || _global).createSpace, (this || _global).removeSpace = function (e) {
          return t.objects.removeChannelMetadata({
            channel: e.spaceId
          });
        }, (this || _global).fetchSpace = function (e) {
          return t.objects.getChannelMetadata({
            channel: e.spaceId,
            include: e.include
          });
        }, (this || _global).fetchSpaces = (this || _global).objects.getAllChannelMetadata, (this || _global).addMemberships = function (e) {
          var n, r;
          return "string" == typeof e.spaceId ? t.objects.setChannelMembers({
            channel: e.spaceId,
            uuids: null === (n = e.users) || void 0 === n ? void 0 : n.map(function (e) {
              return "string" == typeof e ? e : {
                id: e.userId,
                custom: e.custom,
                status: e.status
              };
            }),
            limit: 0
          }) : t.objects.setMemberships({
            uuid: e.userId,
            channels: null === (r = e.spaces) || void 0 === r ? void 0 : r.map(function (e) {
              return "string" == typeof e ? e : {
                id: e.spaceId,
                custom: e.custom,
                status: e.status
              };
            }),
            limit: 0
          });
        }, (this || _global).updateMemberships = (this || _global).addMemberships, (this || _global).removeMemberships = function (e) {
          return "string" == typeof e.spaceId ? t.objects.removeChannelMembers({
            channel: e.spaceId,
            uuids: e.userIds,
            limit: 0
          }) : t.objects.removeMemberships({
            uuid: e.userId,
            channels: e.spaceIds,
            limit: 0
          });
        }, (this || _global).fetchMemberships = function (e) {
          return "string" == typeof e.spaceId ? t.objects.getChannelMembers({
            channel: e.spaceId,
            filter: e.filter,
            limit: e.limit,
            page: e.page,
            include: {
              customFields: e.include.customFields,
              UUIDFields: e.include.userFields,
              customUUIDFields: e.include.customUserFields,
              totalCount: e.include.totalCount
            },
            sort: null != e.sort ? Object.fromEntries(Object.entries(e.sort).map(function (e) {
              var t = s(e, 2),
                n = t[0],
                r = t[1];
              return [n.replace("user", "uuid"), r];
            })) : null
          }).then(function (e) {
            var t;
            return e.data = null === (t = e.data) || void 0 === t ? void 0 : t.map(function (e) {
              return {
                user: e.uuid,
                custom: e.custom,
                updated: e.updated,
                eTag: e.eTag
              };
            }), e;
          }) : t.objects.getMemberships({
            uuid: e.userId,
            filter: e.filter,
            limit: e.limit,
            page: e.page,
            include: {
              customFields: e.include.customFields,
              channelFields: e.include.spaceFields,
              customChannelFields: e.include.customSpaceFields,
              totalCount: e.include.totalCount
            },
            sort: null != e.sort ? Object.fromEntries(Object.entries(e.sort).map(function (e) {
              var t = s(e, 2),
                n = t[0],
                r = t[1];
              return [n.replace("space", "channel"), r];
            })) : null
          }).then(function (e) {
            var t;
            return e.data = null === (t = e.data) || void 0 === t ? void 0 : t.map(function (e) {
              return {
                space: e.channel,
                custom: e.custom,
                updated: e.updated,
                eTag: e.eTag
              };
            }), e;
          });
        }, (this || _global).time = d, (this || _global).stop = (this || _global).destroy, (this || _global).encrypt = function (e, t) {
          if (void 0 === t && h.cryptoModule) {
            var n = h.cryptoModule.encrypt(e);
            return "string" == typeof n ? n : v(n);
          }
          return a.encrypt(e, t);
        }, (this || _global).decrypt = function (e, t) {
          if (void 0 === t && f) {
            var n = h.cryptoModule.decrypt(e);
            return n instanceof ArrayBuffer ? v(n) : n;
          }
          return a.decrypt(e, t);
        }, (this || _global).getAuthKey = h.config.getAuthKey.bind(h.config), (this || _global).setAuthKey = h.config.setAuthKey.bind(h.config), (this || _global).getUUID = h.config.getUUID.bind(h.config), (this || _global).setUUID = h.config.setUUID.bind(h.config), (this || _global).getUserId = h.config.getUserId.bind(h.config), (this || _global).setUserId = h.config.setUserId.bind(h.config), (this || _global).getFilterExpression = h.config.getFilterExpression.bind(h.config), (this || _global).setFilterExpression = h.config.setFilterExpression.bind(h.config), (this || _global).setCipherKey = function (t) {
          return h.config.setCipherKey(t, e, h);
        }, (this || _global).setHeartbeatInterval = h.config.setHeartbeatInterval.bind(h.config), r.hasModule("proxy") && ((this || _global).setProxy = function (e) {
          h.config.setProxy(e), t.reconnect();
        });
      }
      return e.prototype.getVersion = function () {
        return (this || _global)._config.getVersion();
      }, e.prototype._addPnsdkSuffix = function (e, t) {
        (this || _global)._config._addPnsdkSuffix(e, t);
      }, e.prototype.networkDownDetected = function () {
        (this || _global)._listenerManager.announceNetworkDown(), (this || _global)._config.restore ? this.disconnect() : this.destroy(!0);
      }, e.prototype.networkUpDetected = function () {
        (this || _global)._listenerManager.announceNetworkUp(), this.reconnect();
      }, e.notificationPayload = function (e, t) {
        return new K(e, t);
      }, e.generateUUID = function () {
        return y();
      }, e.OPERATIONS = I, e.CATEGORIES = R, e;
    }(),
    qt = function () {
      function e(e) {
        var t = this || _global;
        (this || _global)._modules = {}, Object.keys(e).forEach(function (n) {
          t._modules[n] = e[n].bind(t);
        });
      }
      return e.prototype.init = function (e) {
        (this || _global)._config = e, Array.isArray((this || _global)._config.origin) ? (this || _global)._currentSubDomain = Math.floor(Math.random() * (this || _global)._config.origin.length) : (this || _global)._currentSubDomain = 0, (this || _global)._coreParams = {}, this.shiftStandardOrigin();
      }, e.prototype.nextOrigin = function () {
        var e = (this || _global)._config.secure ? "https://" : "http://";
        if ("string" == typeof (this || _global)._config.origin) return "".concat(e).concat((this || _global)._config.origin);
        (this || _global)._currentSubDomain += 1, (this || _global)._currentSubDomain >= (this || _global)._config.origin.length && ((this || _global)._currentSubDomain = 0);
        var t = (this || _global)._config.origin[(this || _global)._currentSubDomain];
        return "".concat(e).concat(t);
      }, e.prototype.hasModule = function (e) {
        return e in (this || _global)._modules;
      }, e.prototype.shiftStandardOrigin = function () {
        return (this || _global)._standardOrigin = this.nextOrigin(), (this || _global)._standardOrigin;
      }, e.prototype.getStandardOrigin = function () {
        return (this || _global)._standardOrigin;
      }, e.prototype.POSTFILE = function (e, t, n) {
        return (this || _global)._modules.postfile(e, t, n);
      }, e.prototype.GETFILE = function (e, t, n) {
        return (this || _global)._modules.getfile(e, t, n);
      }, e.prototype.POST = function (e, t, n, r) {
        return (this || _global)._modules.post(e, t, n, r);
      }, e.prototype.PATCH = function (e, t, n, r) {
        return (this || _global)._modules.patch(e, t, n, r);
      }, e.prototype.GET = function (e, t, n) {
        return (this || _global)._modules.get(e, t, n);
      }, e.prototype.DELETE = function (e, t, n) {
        return (this || _global)._modules.del(e, t, n);
      }, e.prototype._detectErrorCategory = function (e) {
        if ("ENOTFOUND" === e.code) return R.PNNetworkIssuesCategory;
        if ("ECONNREFUSED" === e.code) return R.PNNetworkIssuesCategory;
        if ("ECONNRESET" === e.code) return R.PNNetworkIssuesCategory;
        if ("EAI_AGAIN" === e.code) return R.PNNetworkIssuesCategory;
        if (0 === e.status || e.hasOwnProperty("status") && void 0 === e.status) return R.PNNetworkIssuesCategory;
        if (e.timeout) return R.PNTimeoutCategory;
        if ("ETIMEDOUT" === e.code) return R.PNNetworkIssuesCategory;
        if (e.response) {
          if (e.response.badRequest) return R.PNBadRequestCategory;
          if (e.response.forbidden) return R.PNAccessDeniedCategory;
        }
        return R.PNUnknownCategory;
      }, e;
    }();
  function zt(e) {
    var t = function (e) {
      return e && "object" == typeof e && e.constructor === Object;
    };
    if (!t(e)) return e;
    var n = {};
    return Object.keys(e).forEach(function (r) {
      var o = function (e) {
          return "string" == typeof e || e instanceof String;
        }(r),
        i = r,
        a = e[r];
      Array.isArray(r) || o && r.indexOf(",") >= 0 ? i = (o ? r.split(",") : r).reduce(function (e, t) {
        return e += String.fromCharCode(t);
      }, "") : (function (e) {
        return "number" == typeof e && isFinite(e);
      }(r) || o && !isNaN(r)) && (i = String.fromCharCode(o ? parseInt(r, 10) : 10));
      n[i] = t(a) ? zt(a) : a;
    }), n;
  }
  var Vt = function () {
      function e(e, t) {
        (this || _global)._base64ToBinary = t, (this || _global)._decode = e;
      }
      return e.prototype.decodeToken = function (e) {
        var t = "";
        e.length % 4 == 3 ? t = "=" : e.length % 4 == 2 && (t = "==");
        var n = e.replace(/-/gi, "+").replace(/_/gi, "/") + t,
          r = this._decode(this._base64ToBinary(n));
        if ("object" == typeof r) return r;
      }, e;
    }(),
    Wt = {
      exports: {}
    },
    Jt = {
      exports: {}
    };
  !function (e) {
    function t(e) {
      if (e) return function (e) {
        for (var n in t.prototype) e[n] = t.prototype[n];
        return e;
      }(e);
    }
    e.exports = t, t.prototype.on = t.prototype.addEventListener = function (e, t) {
      return (this || _global)._callbacks = (this || _global)._callbacks || {}, ((this || _global)._callbacks["$" + e] = (this || _global)._callbacks["$" + e] || []).push(t), this || _global;
    }, t.prototype.once = function (e, t) {
      function n() {
        this.off(e, n), t.apply(this || _global, arguments);
      }
      return n.fn = t, this.on(e, n), this || _global;
    }, t.prototype.off = t.prototype.removeListener = t.prototype.removeAllListeners = t.prototype.removeEventListener = function (e, t) {
      if ((this || _global)._callbacks = (this || _global)._callbacks || {}, 0 == arguments.length) return (this || _global)._callbacks = {}, this || _global;
      var n,
        r = (this || _global)._callbacks["$" + e];
      if (!r) return this || _global;
      if (1 == arguments.length) return delete (this || _global)._callbacks["$" + e], this || _global;
      for (var o = 0; o < r.length; o++) if ((n = r[o]) === t || n.fn === t) {
        r.splice(o, 1);
        break;
      }
      return 0 === r.length && delete (this || _global)._callbacks["$" + e], this || _global;
    }, t.prototype.emit = function (e) {
      (this || _global)._callbacks = (this || _global)._callbacks || {};
      for (var t = new Array(arguments.length - 1), n = (this || _global)._callbacks["$" + e], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      if (n) {
        r = 0;
        for (var o = (n = n.slice(0)).length; r < o; ++r) n[r].apply(this || _global, t);
      }
      return this || _global;
    }, t.prototype.listeners = function (e) {
      return (this || _global)._callbacks = (this || _global)._callbacks || {}, (this || _global)._callbacks["$" + e] || [];
    }, t.prototype.hasListeners = function (e) {
      return !!this.listeners(e).length;
    };
  }(Jt);
  var $t = tn;
  tn.default = tn, tn.stable = an, tn.stableStringify = an;
  var Qt = "[...]",
    Xt = "[Circular]",
    Yt = [],
    Zt = [];
  function en() {
    return {
      depthLimit: Number.MAX_SAFE_INTEGER,
      edgesLimit: Number.MAX_SAFE_INTEGER
    };
  }
  function tn(e, t, n, r) {
    var o;
    void 0 === r && (r = en()), rn(e, "", 0, [], void 0, 0, r);
    try {
      o = 0 === Zt.length ? JSON.stringify(e, t, n) : JSON.stringify(e, un(t), n);
    } catch (e) {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; 0 !== Yt.length;) {
        var i = Yt.pop();
        4 === i.length ? Object.defineProperty(i[0], i[1], i[3]) : i[0][i[1]] = i[2];
      }
    }
    return o;
  }
  function nn(e, t, n, r) {
    var o = Object.getOwnPropertyDescriptor(r, n);
    void 0 !== o.get ? o.configurable ? (Object.defineProperty(r, n, {
      value: e
    }), Yt.push([r, n, t, o])) : Zt.push([t, n, e]) : (r[n] = e, Yt.push([r, n, t]));
  }
  function rn(e, t, n, r, o, i, a) {
    var s;
    if (i += 1, "object" == typeof e && null !== e) {
      for (s = 0; s < r.length; s++) if (r[s] === e) return void nn(Xt, e, t, o);
      if (void 0 !== a.depthLimit && i > a.depthLimit) return void nn(Qt, e, t, o);
      if (void 0 !== a.edgesLimit && n + 1 > a.edgesLimit) return void nn(Qt, e, t, o);
      if (r.push(e), Array.isArray(e)) for (s = 0; s < e.length; s++) rn(e[s], s, s, r, e, i, a);else {
        var u = Object.keys(e);
        for (s = 0; s < u.length; s++) {
          var c = u[s];
          rn(e[c], c, s, r, e, i, a);
        }
      }
      r.pop();
    }
  }
  function on(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
  }
  function an(e, t, n, r) {
    void 0 === r && (r = en());
    var o,
      i = sn(e, "", 0, [], void 0, 0, r) || e;
    try {
      o = 0 === Zt.length ? JSON.stringify(i, t, n) : JSON.stringify(i, un(t), n);
    } catch (e) {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; 0 !== Yt.length;) {
        var a = Yt.pop();
        4 === a.length ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
      }
    }
    return o;
  }
  function sn(e, t, n, r, o, i, a) {
    var s;
    if (i += 1, "object" == typeof e && null !== e) {
      for (s = 0; s < r.length; s++) if (r[s] === e) return void nn(Xt, e, t, o);
      try {
        if ("function" == typeof e.toJSON) return;
      } catch (e) {
        return;
      }
      if (void 0 !== a.depthLimit && i > a.depthLimit) return void nn(Qt, e, t, o);
      if (void 0 !== a.edgesLimit && n + 1 > a.edgesLimit) return void nn(Qt, e, t, o);
      if (r.push(e), Array.isArray(e)) for (s = 0; s < e.length; s++) sn(e[s], s, s, r, e, i, a);else {
        var u = {},
          c = Object.keys(e).sort(on);
        for (s = 0; s < c.length; s++) {
          var l = c[s];
          sn(e[l], l, s, r, e, i, a), u[l] = e[l];
        }
        if (void 0 === o) return u;
        Yt.push([o, t, e]), o[t] = u;
      }
      r.pop();
    }
  }
  function un(e) {
    return e = void 0 !== e ? e : function (e, t) {
      return t;
    }, function (t, n) {
      if (Zt.length > 0) for (var r = 0; r < Zt.length; r++) {
        var o = Zt[r];
        if (o[1] === t && o[0] === n) {
          n = o[2], Zt.splice(r, 1);
          break;
        }
      }
      return e.call(this || _global, t, n);
    };
  }
  var cn,
    ln = "undefined" != typeof Symbol && Symbol,
    pn = function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == typeof Symbol.iterator) return !0;
      var e = {},
        t = Symbol("test"),
        n = Object(t);
      if ("string" == typeof t) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
      for (t in e[t] = 42, e) return !1;
      if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
      if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
      var r = Object.getOwnPropertySymbols(e);
      if (1 !== r.length || r[0] !== t) return !1;
      if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var o = Object.getOwnPropertyDescriptor(e, t);
        if (42 !== o.value || !0 !== o.enumerable) return !1;
      }
      return !0;
    },
    fn = "Function.prototype.bind called on incompatible ",
    hn = Array.prototype.slice,
    dn = Object.prototype.toString,
    yn = "[object Function]",
    gn = function (e) {
      var t = this || _global;
      if ("function" != typeof t || dn.call(t) !== yn) throw new TypeError(fn + t);
      for (var n, r = hn.call(arguments, 1), o = function () {
          if ((this || _global) instanceof n) {
            var o = t.apply(this || _global, r.concat(hn.call(arguments)));
            return Object(o) === o ? o : this || _global;
          }
          return t.apply(e, r.concat(hn.call(arguments)));
        }, i = Math.max(0, t.length - r.length), a = [], s = 0; s < i; s++) a.push("$" + s);
      if (n = Function("binder", "return function (" + a.join(",") + "){ return binder.apply(this,arguments); }")(o), t.prototype) {
        var u = function () {};
        u.prototype = t.prototype, n.prototype = new u(), u.prototype = null;
      }
      return n;
    },
    bn = Function.prototype.bind || gn,
    vn = bn.call(Function.call, Object.prototype.hasOwnProperty),
    mn = SyntaxError,
    _n = Function,
    On = TypeError,
    Sn = function (e) {
      try {
        return _n("\"use strict\"; return (" + e + ").constructor;")();
      } catch (e) {}
    },
    Pn = Object.getOwnPropertyDescriptor;
  if (Pn) try {
    Pn({}, "");
  } catch (e) {
    Pn = null;
  }
  var wn = function () {
      throw new On();
    },
    En = Pn ? function () {
      try {
        return wn;
      } catch (e) {
        try {
          return Pn(arguments, "callee").get;
        } catch (e) {
          return wn;
        }
      }
    }() : wn,
    Tn = "function" == typeof ln && "function" == typeof Symbol && "symbol" == typeof ln("foo") && "symbol" == typeof Symbol("bar") && pn(),
    An = Object.getPrototypeOf || function (e) {
      return e.__proto__;
    },
    Nn = {},
    kn = "undefined" == typeof Uint8Array ? cn : An(Uint8Array),
    Cn = {
      "%AggregateError%": "undefined" == typeof AggregateError ? cn : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? cn : ArrayBuffer,
      "%ArrayIteratorPrototype%": Tn ? An([][Symbol.iterator]()) : cn,
      "%AsyncFromSyncIteratorPrototype%": cn,
      "%AsyncFunction%": Nn,
      "%AsyncGenerator%": Nn,
      "%AsyncGeneratorFunction%": Nn,
      "%AsyncIteratorPrototype%": Nn,
      "%Atomics%": "undefined" == typeof Atomics ? cn : Atomics,
      "%BigInt%": "undefined" == typeof BigInt ? cn : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": "undefined" == typeof DataView ? cn : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": "undefined" == typeof Float32Array ? cn : Float32Array,
      "%Float64Array%": "undefined" == typeof Float64Array ? cn : Float64Array,
      "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? cn : FinalizationRegistry,
      "%Function%": _n,
      "%GeneratorFunction%": Nn,
      "%Int8Array%": "undefined" == typeof Int8Array ? cn : Int8Array,
      "%Int16Array%": "undefined" == typeof Int16Array ? cn : Int16Array,
      "%Int32Array%": "undefined" == typeof Int32Array ? cn : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": Tn ? An(An([][Symbol.iterator]())) : cn,
      "%JSON%": "object" == typeof JSON ? JSON : cn,
      "%Map%": "undefined" == typeof Map ? cn : Map,
      "%MapIteratorPrototype%": "undefined" != typeof Map && Tn ? An(new Map()[Symbol.iterator]()) : cn,
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": "undefined" == typeof Promise ? cn : Promise,
      "%Proxy%": "undefined" == typeof Proxy ? cn : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": "undefined" == typeof Reflect ? cn : Reflect,
      "%RegExp%": RegExp,
      "%Set%": "undefined" == typeof Set ? cn : Set,
      "%SetIteratorPrototype%": "undefined" != typeof Set && Tn ? An(new Set()[Symbol.iterator]()) : cn,
      "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? cn : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": Tn ? An(""[Symbol.iterator]()) : cn,
      "%Symbol%": Tn ? Symbol : cn,
      "%SyntaxError%": mn,
      "%ThrowTypeError%": En,
      "%TypedArray%": kn,
      "%TypeError%": On,
      "%Uint8Array%": "undefined" == typeof Uint8Array ? cn : Uint8Array,
      "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? cn : Uint8ClampedArray,
      "%Uint16Array%": "undefined" == typeof Uint16Array ? cn : Uint16Array,
      "%Uint32Array%": "undefined" == typeof Uint32Array ? cn : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": "undefined" == typeof WeakMap ? cn : WeakMap,
      "%WeakRef%": "undefined" == typeof WeakRef ? cn : WeakRef,
      "%WeakSet%": "undefined" == typeof WeakSet ? cn : WeakSet
    },
    jn = function e(t) {
      var n;
      if ("%AsyncFunction%" === t) n = Sn("async function () {}");else if ("%GeneratorFunction%" === t) n = Sn("function* () {}");else if ("%AsyncGeneratorFunction%" === t) n = Sn("async function* () {}");else if ("%AsyncGenerator%" === t) {
        var r = e("%AsyncGeneratorFunction%");
        r && (n = r.prototype);
      } else if ("%AsyncIteratorPrototype%" === t) {
        var o = e("%AsyncGenerator%");
        o && (n = An(o.prototype));
      }
      return Cn[t] = n, n;
    },
    Mn = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    },
    Rn = bn,
    Un = vn,
    In = Rn.call(Function.call, Array.prototype.concat),
    xn = Rn.call(Function.apply, Array.prototype.splice),
    Dn = Rn.call(Function.call, String.prototype.replace),
    Fn = Rn.call(Function.call, String.prototype.slice),
    Gn = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
    Ln = /\\(\\)?/g,
    Kn = function (e) {
      var t = Fn(e, 0, 1),
        n = Fn(e, -1);
      if ("%" === t && "%" !== n) throw new mn("invalid intrinsic syntax, expected closing `%`");
      if ("%" === n && "%" !== t) throw new mn("invalid intrinsic syntax, expected opening `%`");
      var r = [];
      return Dn(e, Gn, function (e, t, n, o) {
        r[r.length] = n ? Dn(o, Ln, "$1") : t || e;
      }), r;
    },
    Bn = function (e, t) {
      var n,
        r = e;
      if (Un(Mn, r) && (r = "%" + (n = Mn[r])[0] + "%"), Un(Cn, r)) {
        var o = Cn[r];
        if (o === Nn && (o = jn(r)), void 0 === o && !t) throw new On("intrinsic " + e + " exists, but is not available. Please file an issue!");
        return {
          alias: n,
          name: r,
          value: o
        };
      }
      throw new mn("intrinsic " + e + " does not exist!");
    },
    Hn = function (e, t) {
      if ("string" != typeof e || 0 === e.length) throw new On("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof t) throw new On("\"allowMissing\" argument must be a boolean");
      var n = Kn(e),
        r = n.length > 0 ? n[0] : "",
        o = Bn("%" + r + "%", t),
        i = o.name,
        a = o.value,
        s = !1,
        u = o.alias;
      u && (r = u[0], xn(n, In([0, 1], u)));
      for (var c = 1, l = !0; c < n.length; c += 1) {
        var p = n[c],
          f = Fn(p, 0, 1),
          h = Fn(p, -1);
        if (("\"" === f || "'" === f || "`" === f || "\"" === h || "'" === h || "`" === h) && f !== h) throw new mn("property names with quotes must have matching quotes");
        if ("constructor" !== p && l || (s = !0), Un(Cn, i = "%" + (r += "." + p) + "%")) a = Cn[i];else if (null != a) {
          if (!(p in a)) {
            if (!t) throw new On("base intrinsic for " + e + " exists, but the property is not available.");
            return;
          }
          if (Pn && c + 1 >= n.length) {
            var d = Pn(a, p);
            a = (l = !!d) && "get" in d && !("originalValue" in d.get) ? d.get : a[p];
          } else l = Un(a, p), a = a[p];
          l && !s && (Cn[i] = a);
        }
      }
      return a;
    },
    qn = {
      exports: {}
    };
  !function (e) {
    var t = bn,
      n = Hn,
      r = n("%Function.prototype.apply%"),
      o = n("%Function.prototype.call%"),
      i = n("%Reflect.apply%", !0) || t.call(o, r),
      a = n("%Object.getOwnPropertyDescriptor%", !0),
      s = n("%Object.defineProperty%", !0),
      u = n("%Math.max%");
    if (s) try {
      s({}, "a", {
        value: 1
      });
    } catch (e) {
      s = null;
    }
    e.exports = function (e) {
      var n = i(t, o, arguments);
      if (a && s) {
        var r = a(n, "length");
        r.configurable && s(n, "length", {
          value: 1 + u(0, e.length - (arguments.length - 1))
        });
      }
      return n;
    };
    var c = function () {
      return i(t, r, arguments);
    };
    s ? s(e.exports, "apply", {
      value: c
    }) : e.exports.apply = c;
  }(qn);
  var zn = Hn,
    Vn = qn.exports,
    Wn = Vn(zn("String.prototype.indexOf")),
    Jn = l(Object.freeze({
      __proto__: null,
      default: {}
    })),
    $n = "function" == typeof Map && Map.prototype,
    Qn = Object.getOwnPropertyDescriptor && $n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
    Xn = $n && Qn && "function" == typeof Qn.get ? Qn.get : null,
    Yn = $n && Map.prototype.forEach,
    Zn = "function" == typeof Set && Set.prototype,
    er = Object.getOwnPropertyDescriptor && Zn ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
    tr = Zn && er && "function" == typeof er.get ? er.get : null,
    nr = Zn && Set.prototype.forEach,
    rr = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
    or = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
    ir = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
    ar = Boolean.prototype.valueOf,
    sr = Object.prototype.toString,
    ur = Function.prototype.toString,
    cr = String.prototype.match,
    lr = String.prototype.slice,
    pr = String.prototype.replace,
    fr = String.prototype.toUpperCase,
    hr = String.prototype.toLowerCase,
    dr = RegExp.prototype.test,
    yr = Array.prototype.concat,
    gr = Array.prototype.join,
    br = Array.prototype.slice,
    vr = Math.floor,
    mr = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
    _r = Object.getOwnPropertySymbols,
    Or = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null,
    Sr = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
    Pr = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === Sr || "symbol") ? Symbol.toStringTag : null,
    wr = Object.prototype.propertyIsEnumerable,
    Er = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (e) {
      return e.__proto__;
    } : null);
  function Tr(e, t) {
    if (e === 1 / 0 || e === -1 / 0 || e != e || e && e > -1000 && e < 1000 || dr.call(/e/, t)) return t;
    var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if ("number" == typeof e) {
      var r = e < 0 ? -vr(-e) : vr(e);
      if (r !== e) {
        var o = String(r),
          i = lr.call(t, o.length + 1);
        return pr.call(o, n, "$&_") + "." + pr.call(pr.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return pr.call(t, n, "$&_");
  }
  var Ar = Jn,
    Nr = Ar.custom,
    kr = Ur(Nr) ? Nr : null;
  function Cr(e, t, n) {
    var r = "double" === (n.quoteStyle || t) ? "\"" : "'";
    return r + e + r;
  }
  function jr(e) {
    return pr.call(String(e), /"/g, "&quot;");
  }
  function Mr(e) {
    return !("[object Array]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
  }
  function Rr(e) {
    return !("[object RegExp]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
  }
  function Ur(e) {
    if (Sr) return e && "object" == typeof e && e instanceof Symbol;
    if ("symbol" == typeof e) return !0;
    if (!e || "object" != typeof e || !Or) return !1;
    try {
      return Or.call(e), !0;
    } catch (e) {}
    return !1;
  }
  var Ir = Object.prototype.hasOwnProperty || function (e) {
    return e in (this || _global);
  };
  function xr(e, t) {
    return Ir.call(e, t);
  }
  function Dr(e) {
    return sr.call(e);
  }
  function Fr(e, t) {
    if (e.indexOf) return e.indexOf(t);
    for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
    return -1;
  }
  function Gr(e, t) {
    if (e.length > t.maxStringLength) {
      var n = e.length - t.maxStringLength,
        r = "... " + n + " more character" + (n > 1 ? "s" : "");
      return Gr(lr.call(e, 0, t.maxStringLength), t) + r;
    }
    return Cr(pr.call(pr.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Lr), "single", t);
  }
  function Lr(e) {
    var t = e.charCodeAt(0),
      n = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
      }[t];
    return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + fr.call(t.toString(16));
  }
  function Kr(e) {
    return "Object(" + e + ")";
  }
  function Br(e) {
    return e + " { ? }";
  }
  function Hr(e, t, n, r) {
    return e + " (" + t + ") {" + (r ? qr(n, r) : gr.call(n, ", ")) + "}";
  }
  function qr(e, t) {
    if (0 === e.length) return "";
    var n = "\n" + t.prev + t.base;
    return n + gr.call(e, "," + n) + "\n" + t.prev;
  }
  function zr(e, t) {
    var n = Mr(e),
      r = [];
    if (n) {
      r.length = e.length;
      for (var o = 0; o < e.length; o++) r[o] = xr(e, o) ? t(e[o], e) : "";
    }
    var i,
      a = "function" == typeof _r ? _r(e) : [];
    if (Sr) {
      i = {};
      for (var s = 0; s < a.length; s++) i["$" + a[s]] = a[s];
    }
    for (var u in e) xr(e, u) && (n && String(Number(u)) === u && u < e.length || Sr && i["$" + u] instanceof Symbol || (dr.call(/[^\w$]/, u) ? r.push(t(u, e) + ": " + t(e[u], e)) : r.push(u + ": " + t(e[u], e))));
    if ("function" == typeof _r) for (var c = 0; c < a.length; c++) wr.call(e, a[c]) && r.push("[" + t(a[c]) + "]: " + t(e[a[c]], e));
    return r;
  }
  var Vr = Hn,
    Wr = function (e, t) {
      var n = zn(e, !!t);
      return "function" == typeof n && Wn(e, ".prototype.") > -1 ? Vn(n) : n;
    },
    Jr = function e(t, n, r, o) {
      var i = n || {};
      if (xr(i, "quoteStyle") && "single" !== i.quoteStyle && "double" !== i.quoteStyle) throw new TypeError("option \"quoteStyle\" must be \"single\" or \"double\"");
      if (xr(i, "maxStringLength") && ("number" == typeof i.maxStringLength ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : null !== i.maxStringLength)) throw new TypeError("option \"maxStringLength\", if provided, must be a positive integer, Infinity, or `null`");
      var a = !xr(i, "customInspect") || i.customInspect;
      if ("boolean" != typeof a && "symbol" !== a) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      if (xr(i, "indent") && null !== i.indent && "\t" !== i.indent && !(parseInt(i.indent, 10) === i.indent && i.indent > 0)) throw new TypeError("option \"indent\" must be \"\\t\", an integer > 0, or `null`");
      if (xr(i, "numericSeparator") && "boolean" != typeof i.numericSeparator) throw new TypeError("option \"numericSeparator\", if provided, must be `true` or `false`");
      var s = i.numericSeparator;
      if (void 0 === t) return "undefined";
      if (null === t) return "null";
      if ("boolean" == typeof t) return t ? "true" : "false";
      if ("string" == typeof t) return Gr(t, i);
      if ("number" == typeof t) {
        if (0 === t) return 1 / 0 / t > 0 ? "0" : "-0";
        var u = String(t);
        return s ? Tr(t, u) : u;
      }
      if ("bigint" == typeof t) {
        var c = String(t) + "n";
        return s ? Tr(t, c) : c;
      }
      var l = void 0 === i.depth ? 5 : i.depth;
      if (void 0 === r && (r = 0), r >= l && l > 0 && "object" == typeof t) return Mr(t) ? "[Array]" : "[Object]";
      var p = function (e, t) {
        var n;
        if ("\t" === e.indent) n = "\t";else {
          if (!("number" == typeof e.indent && e.indent > 0)) return null;
          n = gr.call(Array(e.indent + 1), " ");
        }
        return {
          base: n,
          prev: gr.call(Array(t + 1), n)
        };
      }(i, r);
      if (void 0 === o) o = [];else if (Fr(o, t) >= 0) return "[Circular]";
      function f(t, n, a) {
        if (n && (o = br.call(o)).push(n), a) {
          var s = {
            depth: i.depth
          };
          return xr(i, "quoteStyle") && (s.quoteStyle = i.quoteStyle), e(t, s, r + 1, o);
        }
        return e(t, i, r + 1, o);
      }
      if ("function" == typeof t && !Rr(t)) {
        var h = function (e) {
            if (e.name) return e.name;
            var t = cr.call(ur.call(e), /^function\s*([\w$]+)/);
            if (t) return t[1];
            return null;
          }(t),
          d = zr(t, f);
        return "[Function" + (h ? ": " + h : " (anonymous)") + "]" + (d.length > 0 ? " { " + gr.call(d, ", ") + " }" : "");
      }
      if (Ur(t)) {
        var y = Sr ? pr.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : Or.call(t);
        return "object" != typeof t || Sr ? y : Kr(y);
      }
      if (function (e) {
        if (!e || "object" != typeof e) return !1;
        if ("undefined" != typeof HTMLElement && e instanceof HTMLElement) return !0;
        return "string" == typeof e.nodeName && "function" == typeof e.getAttribute;
      }(t)) {
        for (var g = "<" + hr.call(String(t.nodeName)), b = t.attributes || [], v = 0; v < b.length; v++) g += " " + b[v].name + "=" + Cr(jr(b[v].value), "double", i);
        return g += ">", t.childNodes && t.childNodes.length && (g += "..."), g += "</" + hr.call(String(t.nodeName)) + ">";
      }
      if (Mr(t)) {
        if (0 === t.length) return "[]";
        var m = zr(t, f);
        return p && !function (e) {
          for (var t = 0; t < e.length; t++) if (Fr(e[t], "\n") >= 0) return !1;
          return !0;
        }(m) ? "[" + qr(m, p) + "]" : "[ " + gr.call(m, ", ") + " ]";
      }
      if (function (e) {
        return !("[object Error]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
      }(t)) {
        var _ = zr(t, f);
        return "cause" in Error.prototype || !("cause" in t) || wr.call(t, "cause") ? 0 === _.length ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + gr.call(_, ", ") + " }" : "{ [" + String(t) + "] " + gr.call(yr.call("[cause]: " + f(t.cause), _), ", ") + " }";
      }
      if ("object" == typeof t && a) {
        if (kr && "function" == typeof t[kr] && Ar) return Ar(t, {
          depth: l - r
        });
        if ("symbol" !== a && "function" == typeof t.inspect) return t.inspect();
      }
      if (function (e) {
        if (!Xn || !e || "object" != typeof e) return !1;
        try {
          Xn.call(e);
          try {
            tr.call(e);
          } catch (e) {
            return !0;
          }
          return e instanceof Map;
        } catch (e) {}
        return !1;
      }(t)) {
        var O = [];
        return Yn && Yn.call(t, function (e, n) {
          O.push(f(n, t, !0) + " => " + f(e, t));
        }), Hr("Map", Xn.call(t), O, p);
      }
      if (function (e) {
        if (!tr || !e || "object" != typeof e) return !1;
        try {
          tr.call(e);
          try {
            Xn.call(e);
          } catch (e) {
            return !0;
          }
          return e instanceof Set;
        } catch (e) {}
        return !1;
      }(t)) {
        var S = [];
        return nr && nr.call(t, function (e) {
          S.push(f(e, t));
        }), Hr("Set", tr.call(t), S, p);
      }
      if (function (e) {
        if (!rr || !e || "object" != typeof e) return !1;
        try {
          rr.call(e, rr);
          try {
            or.call(e, or);
          } catch (e) {
            return !0;
          }
          return e instanceof WeakMap;
        } catch (e) {}
        return !1;
      }(t)) return Br("WeakMap");
      if (function (e) {
        if (!or || !e || "object" != typeof e) return !1;
        try {
          or.call(e, or);
          try {
            rr.call(e, rr);
          } catch (e) {
            return !0;
          }
          return e instanceof WeakSet;
        } catch (e) {}
        return !1;
      }(t)) return Br("WeakSet");
      if (function (e) {
        if (!ir || !e || "object" != typeof e) return !1;
        try {
          return ir.call(e), !0;
        } catch (e) {}
        return !1;
      }(t)) return Br("WeakRef");
      if (function (e) {
        return !("[object Number]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
      }(t)) return Kr(f(Number(t)));
      if (function (e) {
        if (!e || "object" != typeof e || !mr) return !1;
        try {
          return mr.call(e), !0;
        } catch (e) {}
        return !1;
      }(t)) return Kr(f(mr.call(t)));
      if (function (e) {
        return !("[object Boolean]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
      }(t)) return Kr(ar.call(t));
      if (function (e) {
        return !("[object String]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
      }(t)) return Kr(f(String(t)));
      if (!function (e) {
        return !("[object Date]" !== Dr(e) || Pr && "object" == typeof e && Pr in e);
      }(t) && !Rr(t)) {
        var P = zr(t, f),
          w = Er ? Er(t) === Object.prototype : t instanceof Object || t.constructor === Object,
          E = t instanceof Object ? "" : "null prototype",
          T = !w && Pr && Object(t) === t && Pr in t ? lr.call(Dr(t), 8, -1) : E ? "Object" : "",
          A = (w || "function" != typeof t.constructor ? "" : t.constructor.name ? t.constructor.name + " " : "") + (T || E ? "[" + gr.call(yr.call([], T || [], E || []), ": ") + "] " : "");
        return 0 === P.length ? A + "{}" : p ? A + "{" + qr(P, p) + "}" : A + "{ " + gr.call(P, ", ") + " }";
      }
      return String(t);
    },
    $r = Vr("%TypeError%"),
    Qr = Vr("%WeakMap%", !0),
    Xr = Vr("%Map%", !0),
    Yr = Wr("WeakMap.prototype.get", !0),
    Zr = Wr("WeakMap.prototype.set", !0),
    eo = Wr("WeakMap.prototype.has", !0),
    to = Wr("Map.prototype.get", !0),
    no = Wr("Map.prototype.set", !0),
    ro = Wr("Map.prototype.has", !0),
    oo = function (e, t) {
      for (var n, r = e; null !== (n = r.next); r = n) if (n.key === t) return r.next = n.next, n.next = e.next, e.next = n, n;
    },
    io = String.prototype.replace,
    ao = /%20/g,
    so = "RFC3986",
    uo = {
      default: so,
      formatters: {
        RFC1738: function (e) {
          return io.call(e, ao, "+");
        },
        RFC3986: function (e) {
          return String(e);
        }
      },
      RFC1738: "RFC1738",
      RFC3986: so
    },
    co = uo,
    lo = Object.prototype.hasOwnProperty,
    po = Array.isArray,
    fo = function () {
      for (var e = [], t = 0; t < 256; ++t) e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
      return e;
    }(),
    ho = function (e, t) {
      for (var n = t && t.plainObjects ? Object.create(null) : {}, r = 0; r < e.length; ++r) void 0 !== e[r] && (n[r] = e[r]);
      return n;
    },
    yo = {
      arrayToObject: ho,
      assign: function (e, t) {
        return Object.keys(t).reduce(function (e, n) {
          return e[n] = t[n], e;
        }, e);
      },
      combine: function (e, t) {
        return [].concat(e, t);
      },
      compact: function (e) {
        for (var t = [{
            obj: {
              o: e
            },
            prop: "o"
          }], n = [], r = 0; r < t.length; ++r) for (var o = t[r], i = o.obj[o.prop], a = Object.keys(i), s = 0; s < a.length; ++s) {
          var u = a[s],
            c = i[u];
          "object" == typeof c && null !== c && -1 === n.indexOf(c) && (t.push({
            obj: i,
            prop: u
          }), n.push(c));
        }
        return function (e) {
          for (; e.length > 1;) {
            var t = e.pop(),
              n = t.obj[t.prop];
            if (po(n)) {
              for (var r = [], o = 0; o < n.length; ++o) void 0 !== n[o] && r.push(n[o]);
              t.obj[t.prop] = r;
            }
          }
        }(t), e;
      },
      decode: function (e, t, n) {
        var r = e.replace(/\+/g, " ");
        if ("iso-8859-1" === n) return r.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(r);
        } catch (e) {
          return r;
        }
      },
      encode: function (e, t, n, r, o) {
        if (0 === e.length) return e;
        var i = e;
        if ("symbol" == typeof e ? i = Symbol.prototype.toString.call(e) : "string" != typeof e && (i = String(e)), "iso-8859-1" === n) return escape(i).replace(/%u[0-9a-f]{4}/gi, function (e) {
          return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
        });
        for (var a = "", s = 0; s < i.length; ++s) {
          var u = i.charCodeAt(s);
          45 === u || 46 === u || 95 === u || 126 === u || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || o === co.RFC1738 && (40 === u || 41 === u) ? a += i.charAt(s) : u < 128 ? a += fo[u] : u < 2048 ? a += fo[192 | u >> 6] + fo[128 | 63 & u] : u < 55296 || u >= 57344 ? a += fo[224 | u >> 12] + fo[128 | u >> 6 & 63] + fo[128 | 63 & u] : (s += 1, u = 65536 + ((1023 & u) << 10 | 1023 & i.charCodeAt(s)), a += fo[240 | u >> 18] + fo[128 | u >> 12 & 63] + fo[128 | u >> 6 & 63] + fo[128 | 63 & u]);
        }
        return a;
      },
      isBuffer: function (e) {
        return !(!e || "object" != typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
      },
      isRegExp: function (e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      maybeMap: function (e, t) {
        if (po(e)) {
          for (var n = [], r = 0; r < e.length; r += 1) n.push(t(e[r]));
          return n;
        }
        return t(e);
      },
      merge: function e(t, n, r) {
        if (!n) return t;
        if ("object" != typeof n) {
          if (po(t)) t.push(n);else {
            if (!t || "object" != typeof t) return [t, n];
            (r && (r.plainObjects || r.allowPrototypes) || !lo.call(Object.prototype, n)) && (t[n] = !0);
          }
          return t;
        }
        if (!t || "object" != typeof t) return [t].concat(n);
        var o = t;
        return po(t) && !po(n) && (o = ho(t, r)), po(t) && po(n) ? (n.forEach(function (n, o) {
          if (lo.call(t, o)) {
            var i = t[o];
            i && "object" == typeof i && n && "object" == typeof n ? t[o] = e(i, n, r) : t.push(n);
          } else t[o] = n;
        }), t) : Object.keys(n).reduce(function (t, o) {
          var i = n[o];
          return lo.call(t, o) ? t[o] = e(t[o], i, r) : t[o] = i, t;
        }, o);
      }
    },
    go = function () {
      var e,
        t,
        n,
        r = {
          assert: function (e) {
            if (!r.has(e)) throw new $r("Side channel does not contain " + Jr(e));
          },
          get: function (r) {
            if (Qr && r && ("object" == typeof r || "function" == typeof r)) {
              if (e) return Yr(e, r);
            } else if (Xr) {
              if (t) return to(t, r);
            } else if (n) return function (e, t) {
              var n = oo(e, t);
              return n && n.value;
            }(n, r);
          },
          has: function (r) {
            if (Qr && r && ("object" == typeof r || "function" == typeof r)) {
              if (e) return eo(e, r);
            } else if (Xr) {
              if (t) return ro(t, r);
            } else if (n) return function (e, t) {
              return !!oo(e, t);
            }(n, r);
            return !1;
          },
          set: function (r, o) {
            Qr && r && ("object" == typeof r || "function" == typeof r) ? (e || (e = new Qr()), Zr(e, r, o)) : Xr ? (t || (t = new Xr()), no(t, r, o)) : (n || (n = {
              key: {},
              next: null
            }), function (e, t, n) {
              var r = oo(e, t);
              r ? r.value = n : e.next = {
                key: t,
                next: e.next,
                value: n
              };
            }(n, r, o));
          }
        };
      return r;
    },
    bo = yo,
    vo = uo,
    mo = Object.prototype.hasOwnProperty,
    _o = {
      brackets: function (e) {
        return e + "[]";
      },
      comma: "comma",
      indices: function (e, t) {
        return e + "[" + t + "]";
      },
      repeat: function (e) {
        return e;
      }
    },
    Oo = Array.isArray,
    So = Array.prototype.push,
    Po = function (e, t) {
      So.apply(e, Oo(t) ? t : [t]);
    },
    wo = Date.prototype.toISOString,
    Eo = vo.default,
    To = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: bo.encode,
      encodeValuesOnly: !1,
      format: Eo,
      formatter: vo.formatters[Eo],
      indices: !1,
      serializeDate: function (e) {
        return wo.call(e);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
    Ao = {},
    No = function e(t, n, r, o, i, a, s, u, c, l, p, f, h, d, y, g) {
      for (var b, v = t, m = g, _ = 0, O = !1; void 0 !== (m = m.get(Ao)) && !O;) {
        var S = m.get(t);
        if (_ += 1, void 0 !== S) {
          if (S === _) throw new RangeError("Cyclic object value");
          O = !0;
        }
        void 0 === m.get(Ao) && (_ = 0);
      }
      if ("function" == typeof u ? v = u(n, v) : v instanceof Date ? v = p(v) : "comma" === r && Oo(v) && (v = bo.maybeMap(v, function (e) {
        return e instanceof Date ? p(e) : e;
      })), null === v) {
        if (i) return s && !d ? s(n, To.encoder, y, "key", f) : n;
        v = "";
      }
      if ("string" == typeof (b = v) || "number" == typeof b || "boolean" == typeof b || "symbol" == typeof b || "bigint" == typeof b || bo.isBuffer(v)) return s ? [h(d ? n : s(n, To.encoder, y, "key", f)) + "=" + h(s(v, To.encoder, y, "value", f))] : [h(n) + "=" + h(String(v))];
      var P,
        w = [];
      if (void 0 === v) return w;
      if ("comma" === r && Oo(v)) d && s && (v = bo.maybeMap(v, s)), P = [{
        value: v.length > 0 ? v.join(",") || null : void 0
      }];else if (Oo(u)) P = u;else {
        var E = Object.keys(v);
        P = c ? E.sort(c) : E;
      }
      for (var T = o && Oo(v) && 1 === v.length ? n + "[]" : n, A = 0; A < P.length; ++A) {
        var N = P[A],
          k = "object" == typeof N && void 0 !== N.value ? N.value : v[N];
        if (!a || null !== k) {
          var C = Oo(v) ? "function" == typeof r ? r(T, N) : T : T + (l ? "." + N : "[" + N + "]");
          g.set(t, _);
          var j = go();
          j.set(Ao, g), Po(w, e(k, C, r, o, i, a, "comma" === r && d && Oo(v) ? null : s, u, c, l, p, f, h, d, y, j));
        }
      }
      return w;
    },
    ko = yo,
    Co = Object.prototype.hasOwnProperty,
    jo = Array.isArray,
    Mo = {
      allowDots: !1,
      allowPrototypes: !1,
      allowSparse: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decoder: ko.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1000,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
    Ro = function (e) {
      return e.replace(/&#(\d+);/g, function (e, t) {
        return String.fromCharCode(parseInt(t, 10));
      });
    },
    Uo = function (e, t) {
      return e && "string" == typeof e && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
    },
    Io = function (e, t, n, r) {
      if (e) {
        var o = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
          i = /(\[[^[\]]*])/g,
          a = n.depth > 0 && /(\[[^[\]]*])/.exec(o),
          s = a ? o.slice(0, a.index) : o,
          u = [];
        if (s) {
          if (!n.plainObjects && Co.call(Object.prototype, s) && !n.allowPrototypes) return;
          u.push(s);
        }
        for (var c = 0; n.depth > 0 && null !== (a = i.exec(o)) && c < n.depth;) {
          if (c += 1, !n.plainObjects && Co.call(Object.prototype, a[1].slice(1, -1)) && !n.allowPrototypes) return;
          u.push(a[1]);
        }
        return a && u.push("[" + o.slice(a.index) + "]"), function (e, t, n, r) {
          for (var o = r ? t : Uo(t, n), i = e.length - 1; i >= 0; --i) {
            var a,
              s = e[i];
            if ("[]" === s && n.parseArrays) a = [].concat(o);else {
              a = n.plainObjects ? Object.create(null) : {};
              var u = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s,
                c = parseInt(u, 10);
              n.parseArrays || "" !== u ? !isNaN(c) && s !== u && String(c) === u && c >= 0 && n.parseArrays && c <= n.arrayLimit ? (a = [])[c] = o : "__proto__" !== u && (a[u] = o) : a = {
                0: o
              };
            }
            o = a;
          }
          return o;
        }(u, t, n, r);
      }
    },
    xo = function (e, t) {
      var n,
        r = e,
        o = function (e) {
          if (!e) return To;
          if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
          var t = e.charset || To.charset;
          if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
          var n = vo.default;
          if (void 0 !== e.format) {
            if (!mo.call(vo.formatters, e.format)) throw new TypeError("Unknown format option provided.");
            n = e.format;
          }
          var r = vo.formatters[n],
            o = To.filter;
          return ("function" == typeof e.filter || Oo(e.filter)) && (o = e.filter), {
            addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : To.addQueryPrefix,
            allowDots: void 0 === e.allowDots ? To.allowDots : !!e.allowDots,
            charset: t,
            charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : To.charsetSentinel,
            delimiter: void 0 === e.delimiter ? To.delimiter : e.delimiter,
            encode: "boolean" == typeof e.encode ? e.encode : To.encode,
            encoder: "function" == typeof e.encoder ? e.encoder : To.encoder,
            encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : To.encodeValuesOnly,
            filter: o,
            format: n,
            formatter: r,
            serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : To.serializeDate,
            skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : To.skipNulls,
            sort: "function" == typeof e.sort ? e.sort : null,
            strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : To.strictNullHandling
          };
        }(t);
      "function" == typeof o.filter ? r = (0, o.filter)("", r) : Oo(o.filter) && (n = o.filter);
      var i,
        a = [];
      if ("object" != typeof r || null === r) return "";
      i = t && t.arrayFormat in _o ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
      var s = _o[i];
      if (t && "commaRoundTrip" in t && "boolean" != typeof t.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
      var u = "comma" === s && t && t.commaRoundTrip;
      n || (n = Object.keys(r)), o.sort && n.sort(o.sort);
      for (var c = go(), l = 0; l < n.length; ++l) {
        var p = n[l];
        o.skipNulls && null === r[p] || Po(a, No(r[p], p, s, u, o.strictNullHandling, o.skipNulls, o.encode ? o.encoder : null, o.filter, o.sort, o.allowDots, o.serializeDate, o.format, o.formatter, o.encodeValuesOnly, o.charset, c));
      }
      var f = a.join(o.delimiter),
        h = !0 === o.addQueryPrefix ? "?" : "";
      return o.charsetSentinel && ("iso-8859-1" === o.charset ? h += "utf8=%26%2310003%3B&" : h += "utf8=%E2%9C%93&"), f.length > 0 ? h + f : "";
    },
    Do = {
      formats: uo,
      parse: function (e, t) {
        var n = function (e) {
          if (!e) return Mo;
          if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
          if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
          var t = void 0 === e.charset ? Mo.charset : e.charset;
          return {
            allowDots: void 0 === e.allowDots ? Mo.allowDots : !!e.allowDots,
            allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : Mo.allowPrototypes,
            allowSparse: "boolean" == typeof e.allowSparse ? e.allowSparse : Mo.allowSparse,
            arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : Mo.arrayLimit,
            charset: t,
            charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : Mo.charsetSentinel,
            comma: "boolean" == typeof e.comma ? e.comma : Mo.comma,
            decoder: "function" == typeof e.decoder ? e.decoder : Mo.decoder,
            delimiter: "string" == typeof e.delimiter || ko.isRegExp(e.delimiter) ? e.delimiter : Mo.delimiter,
            depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : Mo.depth,
            ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
            interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : Mo.interpretNumericEntities,
            parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : Mo.parameterLimit,
            parseArrays: !1 !== e.parseArrays,
            plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : Mo.plainObjects,
            strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : Mo.strictNullHandling
          };
        }(t);
        if ("" === e || null == e) return n.plainObjects ? Object.create(null) : {};
        for (var r = "string" == typeof e ? function (e, t) {
            var n,
              r = {
                __proto__: null
              },
              o = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
              i = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
              a = o.split(t.delimiter, i),
              s = -1,
              u = t.charset;
            if (t.charsetSentinel) for (n = 0; n < a.length; ++n) 0 === a[n].indexOf("utf8=") && ("utf8=%E2%9C%93" === a[n] ? u = "utf-8" : "utf8=%26%2310003%3B" === a[n] && (u = "iso-8859-1"), s = n, n = a.length);
            for (n = 0; n < a.length; ++n) if (n !== s) {
              var c,
                l,
                p = a[n],
                f = p.indexOf("]="),
                h = -1 === f ? p.indexOf("=") : f + 1;
              -1 === h ? (c = t.decoder(p, Mo.decoder, u, "key"), l = t.strictNullHandling ? null : "") : (c = t.decoder(p.slice(0, h), Mo.decoder, u, "key"), l = ko.maybeMap(Uo(p.slice(h + 1), t), function (e) {
                return t.decoder(e, Mo.decoder, u, "value");
              })), l && t.interpretNumericEntities && "iso-8859-1" === u && (l = Ro(l)), p.indexOf("[]=") > -1 && (l = jo(l) ? [l] : l), Co.call(r, c) ? r[c] = ko.combine(r[c], l) : r[c] = l;
            }
            return r;
          }(e, n) : e, o = n.plainObjects ? Object.create(null) : {}, i = Object.keys(r), a = 0; a < i.length; ++a) {
          var s = i[a],
            u = Io(s, r[s], n, "string" == typeof e);
          o = ko.merge(o, u, n);
        }
        return !0 === n.allowSparse ? o : ko.compact(o);
      },
      stringify: xo
    },
    Fo = {};
  !function (e) {
    function t(e, t) {
      var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (!r) {
        if (Array.isArray(e) || (r = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return n(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === r && e.constructor && (r = e.constructor.name);
          if ("Map" === r || "Set" === r) return Array.from(e);
          if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return n(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          r && (e = r);
          var o = 0,
            i = function () {};
          return {
            s: i,
            n: function () {
              return o >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[o++]
              };
            },
            e: function (e) {
              throw e;
            },
            f: i
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var a,
        s = !0,
        u = !1;
      return {
        s: function () {
          r = r.call(e);
        },
        n: function () {
          var e = r.next();
          return s = e.done, e;
        },
        e: function (e) {
          u = !0, a = e;
        },
        f: function () {
          try {
            s || null == r.return || r.return();
          } finally {
            if (u) throw a;
          }
        }
      };
    }
    function n(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    e.type = e => e.split(/ *; */).shift(), e.params = e => {
      const n = {};
      var r,
        o = t(e.split(/ *; */));
      try {
        for (o.s(); !(r = o.n()).done;) {
          const e = r.value.split(/ *= */),
            t = e.shift(),
            o = e.shift();
          t && o && (n[t] = o);
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      return n;
    }, e.parseLinks = e => {
      const n = {};
      var r,
        o = t(e.split(/ *, */));
      try {
        for (o.s(); !(r = o.n()).done;) {
          const e = r.value.split(/ *; */),
            t = e[0].slice(1, -1);
          n[e[1].split(/ *= */)[1].slice(1, -1)] = t;
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      return n;
    }, e.cleanHeader = (e, t) => (delete e["content-type"], delete e["content-length"], delete e["transfer-encoding"], delete e.host, t && (delete e.authorization, delete e.cookie), e), e.isObject = e => null !== e && "object" == typeof e, e.hasOwn = Object.hasOwn || function (e, t) {
      if (null == e) throw new TypeError("Cannot convert undefined or null to object");
      return Object.prototype.hasOwnProperty.call(new Object(e), t);
    }, e.mixin = (t, n) => {
      for (const r in n) e.hasOwn(n, r) && (t[r] = n[r]);
    };
  }(Fo);
  const Go = Jn,
    Lo = Fo.isObject,
    Ko = Fo.hasOwn;
  var Bo = Ho;
  function Ho() {}
  Ho.prototype.clearTimeout = function () {
    return clearTimeout((this || _global)._timer), clearTimeout((this || _global)._responseTimeoutTimer), clearTimeout((this || _global)._uploadTimeoutTimer), delete (this || _global)._timer, delete (this || _global)._responseTimeoutTimer, delete (this || _global)._uploadTimeoutTimer, this || _global;
  }, Ho.prototype.parse = function (e) {
    return (this || _global)._parser = e, this || _global;
  }, Ho.prototype.responseType = function (e) {
    return (this || _global)._responseType = e, this || _global;
  }, Ho.prototype.serialize = function (e) {
    return (this || _global)._serializer = e, this || _global;
  }, Ho.prototype.timeout = function (e) {
    if (!e || "object" != typeof e) return (this || _global)._timeout = e, (this || _global)._responseTimeout = 0, (this || _global)._uploadTimeout = 0, this || _global;
    for (const t in e) if (Ko(e, t)) switch (t) {
      case "deadline":
        (this || _global)._timeout = e.deadline;
        break;
      case "response":
        (this || _global)._responseTimeout = e.response;
        break;
      case "upload":
        (this || _global)._uploadTimeout = e.upload;
        break;
      default:
        console.warn("Unknown timeout option", t);
    }
    return this || _global;
  }, Ho.prototype.retry = function (e, t) {
    return 0 !== arguments.length && !0 !== e || (e = 1), e <= 0 && (e = 0), (this || _global)._maxRetries = e, (this || _global)._retries = 0, (this || _global)._retryCallback = t, this || _global;
  };
  const qo = new Set(["ETIMEDOUT", "ECONNRESET", "EADDRINUSE", "ECONNREFUSED", "EPIPE", "ENOTFOUND", "ENETUNREACH", "EAI_AGAIN"]),
    zo = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);
  Ho.prototype._shouldRetry = function (e, t) {
    if (!(this || _global)._maxRetries || (this || _global)._retries++ >= (this || _global)._maxRetries) return !1;
    if ((this || _global)._retryCallback) try {
      const n = this._retryCallback(e, t);
      if (!0 === n) return !0;
      if (!1 === n) return !1;
    } catch (e) {
      console.error(e);
    }
    if (t && t.status && zo.has(t.status)) return !0;
    if (e) {
      if (e.code && qo.has(e.code)) return !0;
      if (e.timeout && "ECONNABORTED" === e.code) return !0;
      if (e.crossDomain) return !0;
    }
    return !1;
  }, Ho.prototype._retry = function () {
    return this.clearTimeout(), (this || _global).req && ((this || _global).req = null, (this || _global).req = this.request()), (this || _global)._aborted = !1, (this || _global).timedout = !1, (this || _global).timedoutError = null, this._end();
  }, Ho.prototype.then = function (e, t) {
    if (!(this || _global)._fullfilledPromise) {
      const e = this || _global;
      (this || _global)._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), (this || _global)._fullfilledPromise = new Promise((t, n) => {
        e.on("abort", () => {
          if ((this || _global)._maxRetries && (this || _global)._maxRetries > (this || _global)._retries) return;
          if ((this || _global).timedout && (this || _global).timedoutError) return void n((this || _global).timedoutError);
          const e = new Error("Aborted");
          e.code = "ABORTED", e.status = (this || _global).status, e.method = (this || _global).method, e.url = (this || _global).url, n(e);
        }), e.end((e, r) => {
          e ? n(e) : t(r);
        });
      });
    }
    return (this || _global)._fullfilledPromise.then(e, t);
  }, Ho.prototype.catch = function (e) {
    return this.then(void 0, e);
  }, Ho.prototype.use = function (e) {
    return e(this || _global), this || _global;
  }, Ho.prototype.ok = function (e) {
    if ("function" != typeof e) throw new Error("Callback required");
    return (this || _global)._okCallback = e, this || _global;
  }, Ho.prototype._isResponseOK = function (e) {
    return !!e && ((this || _global)._okCallback ? this._okCallback(e) : e.status >= 200 && e.status < 300);
  }, Ho.prototype.get = function (e) {
    return (this || _global)._header[e.toLowerCase()];
  }, Ho.prototype.getHeader = Ho.prototype.get, Ho.prototype.set = function (e, t) {
    if (Lo(e)) {
      for (const t in e) Ko(e, t) && this.set(t, e[t]);
      return this || _global;
    }
    return (this || _global)._header[e.toLowerCase()] = t, (this || _global).header[e] = t, this || _global;
  }, Ho.prototype.unset = function (e) {
    return delete (this || _global)._header[e.toLowerCase()], delete (this || _global).header[e], this || _global;
  }, Ho.prototype.field = function (e, t, n) {
    if (null == e) throw new Error(".field(name, val) name can not be empty");
    if ((this || _global)._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if (Lo(e)) {
      for (const t in e) Ko(e, t) && this.field(t, e[t]);
      return this || _global;
    }
    if (Array.isArray(t)) {
      for (const n in t) Ko(t, n) && this.field(e, t[n]);
      return this || _global;
    }
    if (null == t) throw new Error(".field(name, val) val can not be empty");
    return "boolean" == typeof t && (t = String(t)), n ? this._getFormData().append(e, t, n) : this._getFormData().append(e, t), this || _global;
  }, Ho.prototype.abort = function () {
    if ((this || _global)._aborted) return this || _global;
    if ((this || _global)._aborted = !0, (this || _global).xhr && (this || _global).xhr.abort(), (this || _global).req) {
      if (Go.gte(process.version, "v13.0.0") && Go.lt(process.version, "v14.0.0")) throw new Error("Superagent does not work in v13 properly with abort() due to Node.js core changes");
      (this || _global).req.abort();
    }
    return this.clearTimeout(), this.emit("abort"), this || _global;
  }, Ho.prototype._auth = function (e, t, n, r) {
    switch (n.type) {
      case "basic":
        this.set("Authorization", `Basic ${r(`${e}:${t}`)}`);
        break;
      case "auto":
        (this || _global).username = e, (this || _global).password = t;
        break;
      case "bearer":
        this.set("Authorization", `Bearer ${e}`);
    }
    return this || _global;
  }, Ho.prototype.withCredentials = function (e) {
    return void 0 === e && (e = !0), (this || _global)._withCredentials = e, this || _global;
  }, Ho.prototype.redirects = function (e) {
    return (this || _global)._maxRedirects = e, this || _global;
  }, Ho.prototype.maxResponseSize = function (e) {
    if ("number" != typeof e) throw new TypeError("Invalid argument");
    return (this || _global)._maxResponseSize = e, this || _global;
  }, Ho.prototype.toJSON = function () {
    return {
      method: (this || _global).method,
      url: (this || _global).url,
      data: (this || _global)._data,
      headers: (this || _global)._header
    };
  }, Ho.prototype.send = function (e) {
    const t = Lo(e);
    let n = (this || _global)._header["content-type"];
    if ((this || _global)._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (t && !(this || _global)._data) Array.isArray(e) ? (this || _global)._data = [] : this._isHost(e) || ((this || _global)._data = {});else if (e && (this || _global)._data && this._isHost((this || _global)._data)) throw new Error("Can't merge these send calls");
    if (t && Lo((this || _global)._data)) for (const t in e) {
      if ("bigint" == typeof e[t] && !e[t].toJSON) throw new Error("Cannot serialize BigInt value to json");
      Ko(e, t) && ((this || _global)._data[t] = e[t]);
    } else {
      if ("bigint" == typeof e) throw new Error("Cannot send value of type BigInt");
      "string" == typeof e ? (n || this.type("form"), n = (this || _global)._header["content-type"], n && (n = n.toLowerCase().trim()), (this || _global)._data = "application/x-www-form-urlencoded" === n ? (this || _global)._data ? `${(this || _global)._data}&${e}` : e : ((this || _global)._data || "") + e) : (this || _global)._data = e;
    }
    return !t || this._isHost(e) || n || this.type("json"), this || _global;
  }, Ho.prototype.sortQuery = function (e) {
    return (this || _global)._sort = void 0 === e || e, this || _global;
  }, Ho.prototype._finalizeQueryString = function () {
    const e = (this || _global)._query.join("&");
    if (e && ((this || _global).url += ((this || _global).url.includes("?") ? "&" : "?") + e), (this || _global)._query.length = 0, (this || _global)._sort) {
      const e = (this || _global).url.indexOf("?");
      if (e >= 0) {
        const t = (this || _global).url.slice(e + 1).split("&");
        "function" == typeof (this || _global)._sort ? t.sort((this || _global)._sort) : t.sort(), (this || _global).url = (this || _global).url.slice(0, e) + "?" + t.join("&");
      }
    }
  }, Ho.prototype._appendQueryString = () => {
    console.warn("Unsupported");
  }, Ho.prototype._timeoutError = function (e, t, n) {
    if ((this || _global)._aborted) return;
    const r = new Error(`${e + t}ms exceeded`);
    r.timeout = t, r.code = "ECONNABORTED", r.errno = n, (this || _global).timedout = !0, (this || _global).timedoutError = r, this.abort(), this.callback(r);
  }, Ho.prototype._setTimeouts = function () {
    const e = this || _global;
    (this || _global)._timeout && !(this || _global)._timer && ((this || _global)._timer = setTimeout(() => {
      e._timeoutError("Timeout of ", e._timeout, "ETIME");
    }, (this || _global)._timeout)), (this || _global)._responseTimeout && !(this || _global)._responseTimeoutTimer && ((this || _global)._responseTimeoutTimer = setTimeout(() => {
      e._timeoutError("Response timeout of ", e._responseTimeout, "ETIMEDOUT");
    }, (this || _global)._responseTimeout));
  };
  const Vo = Fo;
  var Wo = Jo;
  function Jo() {}
  function $o(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
      if (Array.isArray(e) || (n = function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return Qo(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Qo(e, t);
      }(e)) || t && e && "number" == typeof e.length) {
        n && (e = n);
        var r = 0,
          o = function () {};
        return {
          s: o,
          n: function () {
            return r >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[r++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: o
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i,
      a = !0,
      s = !1;
    return {
      s: function () {
        n = n.call(e);
      },
      n: function () {
        var e = n.next();
        return a = e.done, e;
      },
      e: function (e) {
        s = !0, i = e;
      },
      f: function () {
        try {
          a || null == n.return || n.return();
        } finally {
          if (s) throw i;
        }
      }
    };
  }
  function Qo(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function Xo() {
    (this || _global)._defaults = [];
  }
  Jo.prototype.get = function (e) {
    return (this || _global).header[e.toLowerCase()];
  }, Jo.prototype._setHeaderProperties = function (e) {
    const t = e["content-type"] || "";
    (this || _global).type = Vo.type(t);
    const n = Vo.params(t);
    for (const e in n) Object.prototype.hasOwnProperty.call(n, e) && ((this || _global)[e] = n[e]);
    (this || _global).links = {};
    try {
      e.link && ((this || _global).links = Vo.parseLinks(e.link));
    } catch (e) {}
  }, Jo.prototype._setStatusProperties = function (e) {
    const t = Math.trunc(e / 100);
    (this || _global).statusCode = e, (this || _global).status = (this || _global).statusCode, (this || _global).statusType = t, (this || _global).info = 1 === t, (this || _global).ok = 2 === t, (this || _global).redirect = 3 === t, (this || _global).clientError = 4 === t, (this || _global).serverError = 5 === t, (this || _global).error = (4 === t || 5 === t) && this.toError(), (this || _global).created = 201 === e, (this || _global).accepted = 202 === e, (this || _global).noContent = 204 === e, (this || _global).badRequest = 400 === e, (this || _global).unauthorized = 401 === e, (this || _global).notAcceptable = 406 === e, (this || _global).forbidden = 403 === e, (this || _global).notFound = 404 === e, (this || _global).unprocessableEntity = 422 === e;
  };
  for (var Yo = 0, Zo = ["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert", "disableTLSCerts"]; Yo < Zo.length; Yo++) {
    const e = Zo[Yo];
    Xo.prototype[e] = function () {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
      return (this || _global)._defaults.push({
        fn: e,
        args: n
      }), this || _global;
    };
  }
  Xo.prototype._setDefaults = function (e) {
    var t,
      n = $o((this || _global)._defaults);
    try {
      for (n.s(); !(t = n.n()).done;) {
        const n = t.value;
        e[n.fn](...n.args);
      }
    } catch (e) {
      n.e(e);
    } finally {
      n.f();
    }
  };
  var ei = Xo;
  !function (e, t) {
    function n(e, t) {
      var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (!n) {
        if (Array.isArray(e) || (n = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return r(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return r(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          n && (e = n);
          var o = 0,
            i = function () {};
          return {
            s: i,
            n: function () {
              return o >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[o++]
              };
            },
            e: function (e) {
              throw e;
            },
            f: i
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var a,
        s = !0,
        u = !1;
      return {
        s: function () {
          n = n.call(e);
        },
        n: function () {
          var e = n.next();
          return s = e.done, e;
        },
        e: function (e) {
          u = !0, a = e;
        },
        f: function () {
          try {
            s || null == n.return || n.return();
          } finally {
            if (u) throw a;
          }
        }
      };
    }
    function r(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    let o;
    "undefined" != typeof window ? o = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), o = void 0) : o = self;
    const i = Jt.exports,
      a = $t,
      s = Do,
      u = Bo,
      c = Fo.isObject,
      l = Fo.mixin,
      p = Fo.hasOwn,
      f = Wo,
      h = ei;
    function d() {}
    e.exports = function (e, n) {
      return "function" == typeof n ? new t.Request("GET", e).end(n) : 1 === arguments.length ? new t.Request("GET", e) : new t.Request(e, n);
    };
    const y = t = e.exports;
    t.Request = S, y.getXHR = () => {
      if (o.XMLHttpRequest) return new o.XMLHttpRequest();
      throw new Error("Browser-only version of superagent could not find XHR");
    };
    const g = "".trim ? e => e.trim() : e => e.replace(/(^\s*|\s*$)/g, "");
    function b(e) {
      if (!c(e)) return e;
      const t = [];
      for (const n in e) p(e, n) && v(t, n, e[n]);
      return t.join("&");
    }
    function v(e, t, r) {
      if (void 0 !== r) if (null !== r) {
        if (Array.isArray(r)) {
          var o,
            i = n(r);
          try {
            for (i.s(); !(o = i.n()).done;) {
              v(e, t, o.value);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        } else if (c(r)) for (const n in r) p(r, n) && v(e, `${t}[${n}]`, r[n]);else e.push(encodeURI(t) + "=" + encodeURIComponent(r));
      } else e.push(encodeURI(t));
    }
    function m(e) {
      const t = {},
        n = e.split("&");
      let r, o;
      for (let e = 0, i = n.length; e < i; ++e) r = n[e], o = r.indexOf("="), -1 === o ? t[decodeURIComponent(r)] = "" : t[decodeURIComponent(r.slice(0, o))] = decodeURIComponent(r.slice(o + 1));
      return t;
    }
    function _(e) {
      return /[/+]json($|[^-\w])/i.test(e);
    }
    function O(e) {
      (this || _global).req = e, (this || _global).xhr = (this || _global).req.xhr, (this || _global).text = "HEAD" !== (this || _global).req.method && ("" === (this || _global).xhr.responseType || "text" === (this || _global).xhr.responseType) || void 0 === (this || _global).xhr.responseType ? (this || _global).xhr.responseText : null, (this || _global).statusText = (this || _global).req.xhr.statusText;
      let t = (this || _global).xhr.status;
      1223 === t && (t = 204), this._setStatusProperties(t), (this || _global).headers = function (e) {
        const t = e.split(/\r?\n/),
          n = {};
        let r, o, i, a;
        for (let e = 0, s = t.length; e < s; ++e) o = t[e], r = o.indexOf(":"), -1 !== r && (i = o.slice(0, r).toLowerCase(), a = g(o.slice(r + 1)), n[i] = a);
        return n;
      }((this || _global).xhr.getAllResponseHeaders()), (this || _global).header = (this || _global).headers, (this || _global).header["content-type"] = (this || _global).xhr.getResponseHeader("content-type"), this._setHeaderProperties((this || _global).header), null === (this || _global).text && e._responseType ? (this || _global).body = (this || _global).xhr.response : (this || _global).body = "HEAD" === (this || _global).req.method ? null : this._parseBody((this || _global).text ? (this || _global).text : (this || _global).xhr.response);
    }
    function S(e, t) {
      const n = this || _global;
      (this || _global)._query = (this || _global)._query || [], (this || _global).method = e, (this || _global).url = t, (this || _global).header = {}, (this || _global)._header = {}, this.on("end", () => {
        let e,
          t = null,
          r = null;
        try {
          r = new O(n);
        } catch (e) {
          return t = new Error("Parser is unable to parse the response"), t.parse = !0, t.original = e, n.xhr ? (t.rawResponse = void 0 === n.xhr.responseType ? n.xhr.responseText : n.xhr.response, t.status = n.xhr.status ? n.xhr.status : null, t.statusCode = t.status) : (t.rawResponse = null, t.status = null), n.callback(t);
        }
        n.emit("response", r);
        try {
          n._isResponseOK(r) || (e = new Error(r.statusText || r.text || "Unsuccessful HTTP response"));
        } catch (t) {
          e = t;
        }
        e ? (e.original = t, e.response = r, e.status = e.status || r.status, n.callback(e, r)) : n.callback(null, r);
      });
    }
    y.serializeObject = b, y.parseString = m, y.types = {
      html: "text/html",
      json: "application/json",
      xml: "text/xml",
      urlencoded: "application/x-www-form-urlencoded",
      form: "application/x-www-form-urlencoded",
      "form-data": "application/x-www-form-urlencoded"
    }, y.serialize = {
      "application/x-www-form-urlencoded": s.stringify,
      "application/json": a
    }, y.parse = {
      "application/x-www-form-urlencoded": m,
      "application/json": JSON.parse
    }, l(O.prototype, f.prototype), O.prototype._parseBody = function (e) {
      let t = y.parse[(this || _global).type];
      return (this || _global).req._parser ? (this || _global).req._parser(this || _global, e) : (!t && _((this || _global).type) && (t = y.parse["application/json"]), t && e && (e.length > 0 || e instanceof Object) ? t(e) : null);
    }, O.prototype.toError = function () {
      const e = (this || _global).req,
        t = e.method,
        n = e.url,
        r = `cannot ${t} ${n} (${(this || _global).status})`,
        o = new Error(r);
      return o.status = (this || _global).status, o.method = t, o.url = n, o;
    }, y.Response = O, i(S.prototype), l(S.prototype, u.prototype), S.prototype.type = function (e) {
      return this.set("Content-Type", y.types[e] || e), this || _global;
    }, S.prototype.accept = function (e) {
      return this.set("Accept", y.types[e] || e), this || _global;
    }, S.prototype.auth = function (e, t, n) {
      1 === arguments.length && (t = ""), "object" == typeof t && null !== t && (n = t, t = ""), n || (n = {
        type: "function" == typeof btoa ? "basic" : "auto"
      });
      const r = n.encoder ? n.encoder : e => {
        if ("function" == typeof btoa) return btoa(e);
        throw new Error("Cannot use basic auth, btoa is not a function");
      };
      return this._auth(e, t, n, r);
    }, S.prototype.query = function (e) {
      return "string" != typeof e && (e = b(e)), e && (this || _global)._query.push(e), this || _global;
    }, S.prototype.attach = function (e, t, n) {
      if (t) {
        if ((this || _global)._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(e, t, n || t.name);
      }
      return this || _global;
    }, S.prototype._getFormData = function () {
      return (this || _global)._formData || ((this || _global)._formData = new o.FormData()), (this || _global)._formData;
    }, S.prototype.callback = function (e, t) {
      if (this._shouldRetry(e, t)) return this._retry();
      const n = (this || _global)._callback;
      this.clearTimeout(), e && ((this || _global)._maxRetries && (e.retries = (this || _global)._retries - 1), this.emit("error", e)), n(e, t);
    }, S.prototype.crossDomainError = function () {
      const e = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
      e.crossDomain = !0, e.status = (this || _global).status, e.method = (this || _global).method, e.url = (this || _global).url, this.callback(e);
    }, S.prototype.agent = function () {
      return console.warn("This is not supported in browser version of superagent"), this || _global;
    }, S.prototype.ca = S.prototype.agent, S.prototype.buffer = S.prototype.ca, S.prototype.write = () => {
      throw new Error("Streaming is not supported in browser version of superagent");
    }, S.prototype.pipe = S.prototype.write, S.prototype._isHost = function (e) {
      return e && "object" == typeof e && !Array.isArray(e) && "[object Object]" !== Object.prototype.toString.call(e);
    }, S.prototype.end = function (e) {
      (this || _global)._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), (this || _global)._endCalled = !0, (this || _global)._callback = e || d, this._finalizeQueryString(), this._end();
    }, S.prototype._setUploadTimeout = function () {
      const e = this || _global;
      (this || _global)._uploadTimeout && !(this || _global)._uploadTimeoutTimer && ((this || _global)._uploadTimeoutTimer = setTimeout(() => {
        e._timeoutError("Upload timeout of ", e._uploadTimeout, "ETIMEDOUT");
      }, (this || _global)._uploadTimeout));
    }, S.prototype._end = function () {
      if ((this || _global)._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
      const e = this || _global;
      (this || _global).xhr = y.getXHR();
      const t = (this || _global).xhr;
      let n = (this || _global)._formData || (this || _global)._data;
      this._setTimeouts(), t.addEventListener("readystatechange", () => {
        const n = t.readyState;
        if (n >= 2 && e._responseTimeoutTimer && clearTimeout(e._responseTimeoutTimer), 4 !== n) return;
        let r;
        try {
          r = t.status;
        } catch (e) {
          r = 0;
        }
        if (!r) {
          if (e.timedout || e._aborted) return;
          return e.crossDomainError();
        }
        e.emit("end");
      });
      const r = (t, n) => {
        n.total > 0 && (n.percent = n.loaded / n.total * 100, 100 === n.percent && clearTimeout(e._uploadTimeoutTimer)), n.direction = t, e.emit("progress", n);
      };
      if (this.hasListeners("progress")) try {
        t.addEventListener("progress", r.bind(null, "download")), t.upload && t.upload.addEventListener("progress", r.bind(null, "upload"));
      } catch (e) {}
      t.upload && this._setUploadTimeout();
      try {
        (this || _global).username && (this || _global).password ? t.open((this || _global).method, (this || _global).url, !0, (this || _global).username, (this || _global).password) : t.open((this || _global).method, (this || _global).url, !0);
      } catch (e) {
        return this.callback(e);
      }
      if ((this || _global)._withCredentials && (t.withCredentials = !0), !(this || _global)._formData && "GET" !== (this || _global).method && "HEAD" !== (this || _global).method && "string" != typeof n && !this._isHost(n)) {
        const e = (this || _global)._header["content-type"];
        let t = (this || _global)._serializer || y.serialize[e ? e.split(";")[0] : ""];
        !t && _(e) && (t = y.serialize["application/json"]), t && (n = t(n));
      }
      for (const e in (this || _global).header) null !== (this || _global).header[e] && p((this || _global).header, e) && t.setRequestHeader(e, (this || _global).header[e]);
      (this || _global)._responseType && (t.responseType = (this || _global)._responseType), this.emit("request", this || _global), t.send(void 0 === n ? null : n);
    }, y.agent = () => new h();
    for (var P = 0, w = ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"]; P < w.length; P++) {
      const e = w[P];
      h.prototype[e.toLowerCase()] = function (t, n) {
        const r = new y.Request(e, t);
        return this._setDefaults(r), n && r.end(n), r;
      };
    }
    function E(e, t, n) {
      const r = y("DELETE", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }
    h.prototype.del = h.prototype.delete, y.get = (e, t, n) => {
      const r = y("GET", e);
      return "function" == typeof t && (n = t, t = null), t && r.query(t), n && r.end(n), r;
    }, y.head = (e, t, n) => {
      const r = y("HEAD", e);
      return "function" == typeof t && (n = t, t = null), t && r.query(t), n && r.end(n), r;
    }, y.options = (e, t, n) => {
      const r = y("OPTIONS", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }, y.del = E, y.delete = E, y.patch = (e, t, n) => {
      const r = y("PATCH", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }, y.post = (e, t, n) => {
      const r = y("POST", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }, y.put = (e, t, n) => {
      const r = y("PUT", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    };
  }(Wt, Wt.exports);
  var ti = Wt.exports;
  function ni(e) {
    var t = new Date().getTime(),
      n = new Date().toISOString(),
      r = console && console.log ? console : window && window.console && window.console.log ? window.console : console;
    r.log("<<<<<"), r.log("[".concat(n, "]"), "\n", e.url, "\n", e.qs), r.log("-----"), e.on("response", function (n) {
      var o = new Date().getTime() - t,
        i = new Date().toISOString();
      r.log(">>>>>>"), r.log("[".concat(i, " / ").concat(o, "]"), "\n", e.url, "\n", e.qs, "\n", n.text), r.log("-----");
    });
  }
  function ri(e, t, n) {
    var r = this || _global;
    (this || _global)._config.logVerbosity && (e = e.use(ni)), (this || _global)._config.proxy && (this || _global)._modules.proxy && (e = (this || _global)._modules.proxy.call(this || _global, e)), (this || _global)._config.keepAlive && (this || _global)._modules.keepAlive && (e = (this || _global)._modules.keepAlive(e));
    var o = e;
    if (t.abortSignal) var i = t.abortSignal.subscribe(function () {
      o.abort(), i();
    });
    return !0 === t.forceBuffered ? o = "undefined" == typeof Blob ? o.buffer().responseType("arraybuffer") : o.responseType("arraybuffer") : !1 === t.forceBuffered && (o = o.buffer(!1)), (o = o.timeout(t.timeout)).on("abort", function () {
      return n({
        category: R.PNUnknownCategory,
        error: !0,
        operation: t.operation,
        errorData: new Error("Aborted")
      }, null);
    }), o.end(function (e, o) {
      var i,
        a = {};
      if (a.error = null !== e, a.operation = t.operation, o && o.status && (a.statusCode = o.status), e) {
        if (e.response && e.response.text && !r._config.logVerbosity) try {
          a.errorData = JSON.parse(e.response.text);
        } catch (t) {
          a.errorData = e;
        } else a.errorData = e;
        return a.category = r._detectErrorCategory(e), n(a, null);
      }
      if (t.ignoreBody) i = {
        headers: o.headers,
        redirects: o.redirects,
        response: o
      };else try {
        i = JSON.parse(o.text);
      } catch (e) {
        return a.errorData = o, a.error = !0, n(a, null);
      }
      return i.error && 1 === i.error && i.status && i.message && i.service ? (a.errorData = i, a.statusCode = i.status, a.error = !0, a.category = r._detectErrorCategory(a), n(a, null)) : (i.error && i.error.message && (a.errorData = i.error), n(a, i));
    }), o;
  }
  function oi(e, t, n) {
    return o(this || _global, void 0, void 0, function () {
      var r;
      return i(this || _global, function (o) {
        switch (o.label) {
          case 0:
            return r = ti.post(e), t.forEach(function (e) {
              var t = e.key,
                n = e.value;
              r = r.field(t, n);
            }), r.attach("file", n, {
              contentType: "application/octet-stream"
            }), [4, r];
          case 1:
            return [2, o.sent()];
        }
      });
    });
  }
  function ii(e, t, n) {
    var r = ti.get(this.getStandardOrigin() + t.url).set(t.headers).query(e);
    return ri.call(this || _global, r, t, n);
  }
  function ai(e, t, n) {
    var r = ti.get(this.getStandardOrigin() + t.url).set(t.headers).query(e);
    return ri.call(this || _global, r, t, n);
  }
  function si(e, t, n, r) {
    var o = ti.post(this.getStandardOrigin() + n.url).query(e).set(n.headers).send(t);
    return ri.call(this || _global, o, n, r);
  }
  function ui(e, t, n, r) {
    var o = ti.patch(this.getStandardOrigin() + n.url).query(e).set(n.headers).send(t);
    return ri.call(this || _global, o, n, r);
  }
  function ci(e, t, n) {
    var r = ti.delete(this.getStandardOrigin() + t.url).set(t.headers).query(e);
    return ri.call(this || _global, r, t, n);
  }
  function li(e, t) {
    var n = new Uint8Array(e.byteLength + t.byteLength);
    return n.set(new Uint8Array(e), 0), n.set(new Uint8Array(t), e.byteLength), n.buffer;
  }
  var pi,
    fi = function () {
      function e() {}
      return Object.defineProperty(e.prototype, "algo", {
        get: function () {
          return "aes-256-cbc";
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.encrypt = function (e, t) {
        return o(this || _global, void 0, void 0, function () {
          var n;
          return i(this || _global, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getKey(e)];
              case 1:
                if (n = r.sent(), t instanceof ArrayBuffer) return [2, this.encryptArrayBuffer(n, t)];
                if ("string" == typeof t) return [2, this.encryptString(n, t)];
                throw new Error("Cannot encrypt this file. In browsers file encryption supports only string or ArrayBuffer");
            }
          });
        });
      }, e.prototype.decrypt = function (e, t) {
        return o(this || _global, void 0, void 0, function () {
          var n;
          return i(this || _global, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getKey(e)];
              case 1:
                if (n = r.sent(), t instanceof ArrayBuffer) return [2, this.decryptArrayBuffer(n, t)];
                if ("string" == typeof t) return [2, this.decryptString(n, t)];
                throw new Error("Cannot decrypt this file. In browsers file decryption supports only string or ArrayBuffer");
            }
          });
        });
      }, e.prototype.encryptFile = function (e, t, n) {
        return o(this || _global, void 0, void 0, function () {
          var r, o, a;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                if (t.data.byteLength <= 0) throw new Error("encryption error. empty content");
                return [4, this.getKey(e)];
              case 1:
                return r = i.sent(), [4, t.data.arrayBuffer()];
              case 2:
                return o = i.sent(), [4, this.encryptArrayBuffer(r, o)];
              case 3:
                return a = i.sent(), [2, n.create({
                  name: t.name,
                  mimeType: "application/octet-stream",
                  data: a
                })];
            }
          });
        });
      }, e.prototype.decryptFile = function (e, t, n) {
        return o(this || _global, void 0, void 0, function () {
          var r, o, a;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.getKey(e)];
              case 1:
                return r = i.sent(), [4, t.data.arrayBuffer()];
              case 2:
                return o = i.sent(), [4, this.decryptArrayBuffer(r, o)];
              case 3:
                return a = i.sent(), [2, n.create({
                  name: t.name,
                  data: a
                })];
            }
          });
        });
      }, e.prototype.getKey = function (t) {
        return o(this || _global, void 0, void 0, function () {
          var n, r, o;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return [4, crypto.subtle.digest("SHA-256", e.encoder.encode(t))];
              case 1:
                return n = i.sent(), r = Array.from(new Uint8Array(n)).map(function (e) {
                  return e.toString(16).padStart(2, "0");
                }).join(""), o = e.encoder.encode(r.slice(0, 32)).buffer, [2, crypto.subtle.importKey("raw", o, "AES-CBC", !0, ["encrypt", "decrypt"])];
            }
          });
        });
      }, e.prototype.encryptArrayBuffer = function (e, t) {
        return o(this || _global, void 0, void 0, function () {
          var n, r, o;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return n = crypto.getRandomValues(new Uint8Array(16)), r = li, o = [n.buffer], [4, crypto.subtle.encrypt({
                  name: "AES-CBC",
                  iv: n
                }, e, t)];
              case 1:
                return [2, r.apply(void 0, o.concat([i.sent()]))];
            }
          });
        });
      }, e.prototype.decryptArrayBuffer = function (t, n) {
        return o(this || _global, void 0, void 0, function () {
          var r;
          return i(this || _global, function (o) {
            switch (o.label) {
              case 0:
                if (r = n.slice(0, 16), n.slice(e.IV_LENGTH).byteLength <= 0) throw new Error("decryption error: empty content");
                return [4, crypto.subtle.decrypt({
                  name: "AES-CBC",
                  iv: r
                }, t, n.slice(e.IV_LENGTH))];
              case 1:
                return [2, o.sent()];
            }
          });
        });
      }, e.prototype.encryptString = function (t, n) {
        return o(this || _global, void 0, void 0, function () {
          var r, o, a, s;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return r = crypto.getRandomValues(new Uint8Array(16)), o = e.encoder.encode(n).buffer, [4, crypto.subtle.encrypt({
                  name: "AES-CBC",
                  iv: r
                }, t, o)];
              case 1:
                return a = i.sent(), s = li(r.buffer, a), [2, e.decoder.decode(s)];
            }
          });
        });
      }, e.prototype.decryptString = function (t, n) {
        return o(this || _global, void 0, void 0, function () {
          var r, o, a, s;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return r = e.encoder.encode(n).buffer, o = r.slice(0, 16), a = r.slice(16), [4, crypto.subtle.decrypt({
                  name: "AES-CBC",
                  iv: o
                }, t, a)];
              case 1:
                return s = i.sent(), [2, e.decoder.decode(s)];
            }
          });
        });
      }, e.IV_LENGTH = 16, e.encoder = new TextEncoder(), e.decoder = new TextDecoder(), e;
    }(),
    hi = (pi = function () {
      function e(e) {
        if (e instanceof File) (this || _global).data = e, (this || _global).name = (this || _global).data.name, (this || _global).mimeType = (this || _global).data.type;else if (e.data) {
          var t = e.data;
          (this || _global).data = new File([t], e.name, {
            type: e.mimeType
          }), (this || _global).name = e.name, e.mimeType && ((this || _global).mimeType = e.mimeType);
        }
        if (void 0 === (this || _global).data) throw new Error("Couldn't construct a file out of supplied options.");
        if (void 0 === (this || _global).name) throw new Error("Couldn't guess filename out of the options. Please provide one.");
      }
      return e.create = function (e) {
        return new (this || _global)(e);
      }, e.prototype.toBuffer = function () {
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (e) {
            throw new Error("This feature is only supported in Node.js environments.");
          });
        });
      }, e.prototype.toStream = function () {
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (e) {
            throw new Error("This feature is only supported in Node.js environments.");
          });
        });
      }, e.prototype.toFileUri = function () {
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (e) {
            throw new Error("This feature is only supported in react native environments.");
          });
        });
      }, e.prototype.toBlob = function () {
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (e) {
            return [2, (this || _global).data];
          });
        });
      }, e.prototype.toArrayBuffer = function () {
        return o(this || _global, void 0, void 0, function () {
          var e = this || _global;
          return i(this || _global, function (t) {
            return [2, new Promise(function (t, n) {
              var r = new FileReader();
              r.addEventListener("load", function () {
                if (r.result instanceof ArrayBuffer) return t(r.result);
              }), r.addEventListener("error", function () {
                n(r.error);
              }), r.readAsArrayBuffer(e.data);
            })];
          });
        });
      }, e.prototype.toString = function () {
        return o(this || _global, void 0, void 0, function () {
          var e = this || _global;
          return i(this || _global, function (t) {
            return [2, new Promise(function (t, n) {
              var r = new FileReader();
              r.addEventListener("load", function () {
                if ("string" == typeof r.result) return t(r.result);
              }), r.addEventListener("error", function () {
                n(r.error);
              }), r.readAsBinaryString(e.data);
            })];
          });
        });
      }, e.prototype.toFile = function () {
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (e) {
            return [2, (this || _global).data];
          });
        });
      }, e;
    }(), pi.supportsFile = "undefined" != typeof File, pi.supportsBlob = "undefined" != typeof Blob, pi.supportsArrayBuffer = "undefined" != typeof ArrayBuffer, pi.supportsBuffer = !1, pi.supportsStream = !1, pi.supportsString = !0, pi.supportsEncryptFile = !0, pi.supportsFileUri = !1, pi),
    di = function () {
      function e(e) {
        (this || _global).config = e, (this || _global).cryptor = new A({
          config: e
        }), (this || _global).fileCryptor = new fi();
      }
      return Object.defineProperty(e.prototype, "identifier", {
        get: function () {
          return "";
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.encrypt = function (e) {
        var t = "string" == typeof e ? e : new TextDecoder().decode(e);
        return {
          data: (this || _global).cryptor.encrypt(t),
          metadata: null
        };
      }, e.prototype.decrypt = function (e) {
        var t = "string" == typeof e.data ? e.data : v(e.data);
        return (this || _global).cryptor.decrypt(t);
      }, e.prototype.encryptFile = function (e, t) {
        var n;
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (r) {
            return [2, (this || _global).fileCryptor.encryptFile(null === (n = (this || _global).config) || void 0 === n ? void 0 : n.cipherKey, e, t)];
          });
        });
      }, e.prototype.decryptFile = function (e, t) {
        return o(this || _global, void 0, void 0, function () {
          return i(this || _global, function (n) {
            return [2, (this || _global).fileCryptor.decryptFile((this || _global).config.cipherKey, e, t)];
          });
        });
      }, e;
    }(),
    yi = function () {
      function e(e) {
        (this || _global).cipherKey = e.cipherKey, (this || _global).CryptoJS = E, (this || _global).encryptedKey = (this || _global).CryptoJS.SHA256((this || _global).cipherKey);
      }
      return Object.defineProperty(e.prototype, "algo", {
        get: function () {
          return "AES-CBC";
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function () {
          return "ACRH";
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.getIv = function () {
        return crypto.getRandomValues(new Uint8Array(e.BLOCK_SIZE));
      }, e.prototype.getKey = function () {
        return o(this || _global, void 0, void 0, function () {
          var t, n;
          return i(this || _global, function (r) {
            switch (r.label) {
              case 0:
                return t = e.encoder.encode((this || _global).cipherKey), [4, crypto.subtle.digest("SHA-256", t.buffer)];
              case 1:
                return n = r.sent(), [2, crypto.subtle.importKey("raw", n, (this || _global).algo, !0, ["encrypt", "decrypt"])];
            }
          });
        });
      }, e.prototype.encrypt = function (t) {
        if (0 === ("string" == typeof t ? t : e.decoder.decode(t)).length) throw new Error("encryption error. empty content");
        var n = this.getIv();
        return {
          metadata: n,
          data: b((this || _global).CryptoJS.AES.encrypt(t, (this || _global).encryptedKey, {
            iv: this.bufferToWordArray(n),
            mode: (this || _global).CryptoJS.mode.CBC
          }).ciphertext.toString((this || _global).CryptoJS.enc.Base64))
        };
      }, e.prototype.decrypt = function (t) {
        var n = this.bufferToWordArray(new Uint8ClampedArray(t.metadata)),
          r = this.bufferToWordArray(new Uint8ClampedArray(t.data));
        return e.encoder.encode((this || _global).CryptoJS.AES.decrypt({
          ciphertext: r
        }, (this || _global).encryptedKey, {
          iv: n,
          mode: (this || _global).CryptoJS.mode.CBC
        }).toString((this || _global).CryptoJS.enc.Utf8)).buffer;
      }, e.prototype.encryptFileData = function (e) {
        return o(this || _global, void 0, void 0, function () {
          var t, n, r;
          return i(this || _global, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.getKey()];
              case 1:
                return t = o.sent(), n = this.getIv(), r = {}, [4, crypto.subtle.encrypt({
                  name: (this || _global).algo,
                  iv: n
                }, t, e)];
              case 2:
                return [2, (r.data = o.sent(), r.metadata = n, r)];
            }
          });
        });
      }, e.prototype.decryptFileData = function (e) {
        return o(this || _global, void 0, void 0, function () {
          var t;
          return i(this || _global, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getKey()];
              case 1:
                return t = n.sent(), [2, crypto.subtle.decrypt({
                  name: (this || _global).algo,
                  iv: e.metadata
                }, t, e.data)];
            }
          });
        });
      }, e.prototype.bufferToWordArray = function (e) {
        var t,
          n = [];
        for (t = 0; t < e.length; t += 1) n[t / 4 | 0] |= e[t] << 24 - 8 * t;
        return (this || _global).CryptoJS.lib.WordArray.create(n, e.length);
      }, e.BLOCK_SIZE = 16, e.encoder = new TextEncoder(), e.decoder = new TextDecoder(), e;
    }(),
    gi = function () {
      function e(e) {
        var t;
        (this || _global).defaultCryptor = e.default, (this || _global).cryptors = null !== (t = e.cryptors) && void 0 !== t ? t : [];
      }
      return e.legacyCryptoModule = function (e) {
        var t;
        return new (this || _global)({
          default: new di({
            cipherKey: e.cipherKey,
            useRandomIVs: null === (t = e.useRandomIVs) || void 0 === t || t
          }),
          cryptors: [new yi({
            cipherKey: e.cipherKey
          })]
        });
      }, e.aesCbcCryptoModule = function (e) {
        var t;
        return new (this || _global)({
          default: new yi({
            cipherKey: e.cipherKey
          }),
          cryptors: [new di({
            cipherKey: e.cipherKey,
            useRandomIVs: null === (t = e.useRandomIVs) || void 0 === t || t
          })]
        });
      }, e.withDefaultCryptor = function (e) {
        return new (this || _global)({
          default: e
        });
      }, e.prototype.getAllCryptors = function () {
        return u([(this || _global).defaultCryptor], s((this || _global).cryptors), !1);
      }, e.prototype.encrypt = function (e) {
        var t = (this || _global).defaultCryptor.encrypt(e);
        if (!t.metadata) return t.data;
        var n = this.getHeaderData(t);
        return this.concatArrayBuffer(n, t.data);
      }, e.prototype.decrypt = function (e) {
        var t = "string" == typeof e ? b(e) : e,
          n = bi.tryParse(t),
          r = this.getCryptor(n),
          o = n.length > 0 ? t.slice(n.length - n.metadataLength, n.length) : null;
        if (t.slice(n.length).byteLength <= 0) throw new Error("decryption error. empty content");
        return r.decrypt({
          data: t.slice(n.length),
          metadata: o
        });
      }, e.prototype.encryptFile = function (e, t) {
        return o(this || _global, void 0, void 0, function () {
          var n, r;
          return i(this || _global, function (o) {
            switch (o.label) {
              case 0:
                return (this || _global).defaultCryptor.identifier === bi.LEGACY_IDENTIFIER ? [2, (this || _global).defaultCryptor.encryptFile(e, t)] : (n = this.getFileData(e.data), [4, (this || _global).defaultCryptor.encryptFileData(n)]);
              case 1:
                return r = o.sent(), [2, t.create({
                  name: e.name,
                  mimeType: "application/octet-stream",
                  data: this.concatArrayBuffer(this.getHeaderData(r), r.data)
                })];
            }
          });
        });
      }, e.prototype.decryptFile = function (t, n) {
        return o(this || _global, void 0, void 0, function () {
          var r, o, a, s, u, c, l, p;
          return i(this || _global, function (i) {
            switch (i.label) {
              case 0:
                return [4, t.data.arrayBuffer()];
              case 1:
                return r = i.sent(), o = bi.tryParse(r), (null == (a = this.getCryptor(o)) ? void 0 : a.identifier) === e.LEGACY_IDENTIFIER ? [2, a.decryptFile(t, n)] : (s = this.getFileData(r), u = s.slice(o.length - o.metadataLength, o.length), l = (c = n).create, p = {
                  name: t.name
                }, [4, (this || _global).defaultCryptor.decryptFileData({
                  data: r.slice(o.length),
                  metadata: u
                })]);
              case 2:
                return [2, l.apply(c, [(p.data = i.sent(), p)])];
            }
          });
        });
      }, e.prototype.getCryptor = function (e) {
        if ("" === e) {
          var t = this.getAllCryptors().find(function (e) {
            return "" === e.identifier;
          });
          if (t) return t;
          throw new Error("unknown cryptor error");
        }
        if (e instanceof vi) return this.getCryptorFromId(e.identifier);
      }, e.prototype.getCryptorFromId = function (e) {
        var t = this.getAllCryptors().find(function (t) {
          return e === t.identifier;
        });
        if (t) return t;
        throw Error("unknown cryptor error");
      }, e.prototype.concatArrayBuffer = function (e, t) {
        var n = new Uint8Array(e.byteLength + t.byteLength);
        return n.set(new Uint8Array(e), 0), n.set(new Uint8Array(t), e.byteLength), n.buffer;
      }, e.prototype.getHeaderData = function (e) {
        if (e.metadata) {
          var t = bi.from((this || _global).defaultCryptor.identifier, e.metadata),
            n = new Uint8Array(t.length),
            r = 0;
          return n.set(t.data, r), r += t.length - e.metadata.byteLength, n.set(new Uint8Array(e.metadata), r), n.buffer;
        }
      }, e.prototype.getFileData = function (t) {
        if (t instanceof ArrayBuffer) return t;
        if ("string" == typeof t) return e.encoder.encode(t);
        throw new Error("Cannot decrypt/encrypt file. In browsers file decryption supports only string or ArrayBuffer");
      }, e.LEGACY_IDENTIFIER = "", e.encoder = new TextEncoder(), e.decoder = new TextDecoder(), e;
    }(),
    bi = function () {
      function e() {}
      return e.from = function (t, n) {
        if (t !== e.LEGACY_IDENTIFIER) return new vi(t, n.byteLength);
      }, e.tryParse = function (t) {
        var n = new Uint8Array(t),
          r = "";
        if (n.byteLength >= 4 && (r = n.slice(0, 4), (this || _global).decoder.decode(r) !== e.SENTINEL)) return "";
        if (!(n.byteLength >= 5)) throw new Error("decryption error. invalid header version");
        if (n[4] > e.MAX_VERSION) throw new Error("unknown cryptor error");
        var o = "",
          i = 5 + e.IDENTIFIER_LENGTH;
        if (!(n.byteLength >= i)) throw new Error("decryption error. invalid crypto identifier");
        o = n.slice(5, i);
        var a = null;
        if (!(n.byteLength >= i + 1)) throw new Error("decryption error. invalid metadata length");
        return a = n[i], i += 1, 255 === a && n.byteLength >= i + 2 && (a = new Uint16Array(n.slice(i, i + 2)).reduce(function (e, t) {
          return (e << 8) + t;
        }, 0), i += 2), new vi((this || _global).decoder.decode(o), a);
      }, e.SENTINEL = "PNED", e.LEGACY_IDENTIFIER = "", e.IDENTIFIER_LENGTH = 4, e.VERSION = 1, e.MAX_VERSION = 1, e.decoder = new TextDecoder(), e;
    }(),
    vi = function () {
      function e(e, t) {
        (this || _global)._identifier = e, (this || _global)._metadataLength = t;
      }
      return Object.defineProperty(e.prototype, "identifier", {
        get: function () {
          return (this || _global)._identifier;
        },
        set: function (e) {
          (this || _global)._identifier = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "metadataLength", {
        get: function () {
          return (this || _global)._metadataLength;
        },
        set: function (e) {
          (this || _global)._metadataLength = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "version", {
        get: function () {
          return bi.VERSION;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "length", {
        get: function () {
          return bi.SENTINEL.length + 1 + bi.IDENTIFIER_LENGTH + ((this || _global).metadataLength < 255 ? 1 : 3) + (this || _global).metadataLength;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "data", {
        get: function () {
          var e = 0,
            t = new Uint8Array((this || _global).length),
            n = new TextEncoder();
          t.set(n.encode(bi.SENTINEL)), t[e += bi.SENTINEL.length] = (this || _global).version, e++, (this || _global).identifier && t.set(n.encode((this || _global).identifier), e), e += bi.IDENTIFIER_LENGTH;
          var r = (this || _global).metadataLength;
          return r < 255 ? t[e] = r : t.set([255, r >> 8, 255 & r], e), t;
        },
        enumerable: !1,
        configurable: !0
      }), e.IDENTIFIER_LENGTH = 4, e.SENTINEL = "PNED", e;
    }();
  function mi(e) {
    if (!navigator || !navigator.sendBeacon) return !1;
    navigator.sendBeacon(e);
  }
  var _i = function (e) {
    function n(t) {
      var n = this || _global,
        r = t.listenToBrowserNetworkEvents,
        o = void 0 === r || r;
      return t.sdkFamily = "Web", t.networking = new qt({
        del: ci,
        get: ai,
        post: si,
        patch: ui,
        sendBeacon: mi,
        getfile: ii,
        postfile: oi
      }), t.cbor = new Vt(function (e) {
        return zt(f.decode(e));
      }, b), t.PubNubFile = hi, t.cryptography = new fi(), t.initCryptoModule = function (e) {
        return new gi({
          default: new di({
            cipherKey: e.cipherKey,
            useRandomIVs: e.useRandomIVs
          }),
          cryptors: [new yi({
            cipherKey: e.cipherKey
          })]
        });
      }, n = e.call(this || _global, t) || this || _global, o && (window.addEventListener("offline", function () {
        n.networkDownDetected();
      }), window.addEventListener("online", function () {
        n.networkUpDetected();
      })), n;
    }
    return t(n, e), n.CryptoModule = gi, n;
  }(Ht);
  return _i;
});
export default exports;